(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.aP.Q === region.a5.Q)
	{
		return 'on line ' + region.aP.Q;
	}
	return 'on lines ' + region.aP.Q + ' through ' + region.a5.Q;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word >= 0
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.cF,
		impl.dC,
		impl.dq,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_enqueueEffects(managers, result.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		z: func(record.z),
		aR: record.aR,
		aI: record.aI
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.z;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.aR;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.aI) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.cF,
		impl.dC,
		impl.dq,
		function(sendToApp, initialModel) {
			var view = impl.dF;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.cF,
		impl.dC,
		impl.dq,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.aN && impl.aN(sendToApp)
			var view = impl.dF;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.b4);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.dw) && (_VirtualDom_doc.title = title = doc.dw);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.cW;
	var onUrlRequest = impl.cX;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		aN: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.bC === next.bC
							&& curr.be === next.be
							&& curr.bv.a === next.bv.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		cF: function(flags)
		{
			return A3(impl.cF, flags, _Browser_getUrl(), key);
		},
		dF: impl.dF,
		dC: impl.dC,
		dq: impl.dq
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { cA: 'hidden', b7: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { cA: 'mozHidden', b7: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { cA: 'msHidden', b7: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { cA: 'webkitHidden', b7: 'webkitvisibilitychange' }
		: { cA: 'hidden', b7: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		bL: _Browser_getScene(),
		bW: {
			bY: _Browser_window.pageXOffset,
			bZ: _Browser_window.pageYOffset,
			bX: _Browser_doc.documentElement.clientWidth,
			bc: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		bX: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		bc: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			bL: {
				bX: node.scrollWidth,
				bc: node.scrollHeight
			},
			bW: {
				bY: node.scrollLeft,
				bZ: node.scrollTop,
				bX: node.clientWidth,
				bc: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			bL: _Browser_getScene(),
			bW: {
				bY: x,
				bZ: y,
				bX: _Browser_doc.documentElement.clientWidth,
				bc: _Browser_doc.documentElement.clientHeight
			},
			ch: {
				bY: x + rect.left,
				bZ: y + rect.top,
				bX: rect.width,
				bc: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.f) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.h),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.h);
		} else {
			var treeLen = builder.f * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.i) : builder.i;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.f);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.h) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.h);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{i: nodeList, f: (len / $elm$core$Array$branchFactor) | 0, h: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {a9: fragment, be: host, bt: path, bv: port_, bC: protocol, bD: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$document = _Browser_document;
var $author$project$Model$Model$CurrentTimeCallback = function (a) {
	return {$: 21, a: a};
};
var $author$project$Model$Model$GetLastTeam = function (a) {
	return {$: 17, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Model$Model$Model = function (navOpen) {
	return function (view) {
		return function (tabOpened) {
			return function (teamName) {
				return function (pointsAllowed) {
					return function (gearPhase) {
						return function (vehicles) {
							return function (sponsor) {
								return function (tmpVehicle) {
									return function (tmpWeapon) {
										return function (tmpUpgrade) {
											return function (error) {
												return function (importValue) {
													return function (storageKeys) {
														return function (storageData) {
															return function (settings) {
																return function (featureFlags) {
																	return function (storageKey) {
																		return {cj: error, cp: featureFlags, cu: gearPhase, cE: importValue, cM: navOpen, c5: pointsAllowed, dd: settings, dl: sponsor, dn: storageData, $7: storageKey, dp: storageKeys, ds: tabOpened, dv: teamName, dx: tmpUpgrade, dy: tmpVehicle, dz: tmpWeapon, dE: vehicles, dF: view};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$Views$ViewDashboard = {$: 0};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $author$project$Model$Features$flags = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('feature-generate-team', false),
			_Utils_Tuple2('feature-car-photo', false),
			_Utils_Tuple2('feature-printing', false)
		]));
var $author$project$Model$Settings$Settings = F6(
	function (percentVehicles, percentWeapons, percentUpgrades, percentPerks, pointsAllowed, spinResults) {
		return {c$: percentPerks, c0: percentUpgrades, c1: percentVehicles, c2: percentWeapons, c5: pointsAllowed, dk: spinResults};
	});
var $author$project$Model$Settings$init = A6($author$project$Model$Settings$Settings, 60, 30, 10, 0, 50, _List_Nil);
var $author$project$Model$Model$defaultModel = $author$project$Model$Model$Model(false)($author$project$Model$Views$ViewDashboard)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)(50)(1)($elm$core$Dict$empty)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)(_List_Nil)('')(_List_Nil)(_List_Nil)($author$project$Model$Settings$init)($author$project$Model$Features$flags)('');
var $author$project$Update$UtilsGeneric$do = function (msg) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return msg;
		},
		$elm$core$Task$succeed(msg));
};
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Model$Model$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Model$Model$defaultModel,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$author$project$Update$UtilsGeneric$do(
					$author$project$Model$Model$GetLastTeam('')),
					A2($elm$core$Task$perform, $author$project$Model$Model$CurrentTimeCallback, $elm$time$Time$now)
				])));
};
var $author$project$Model$Model$DeleteItemCallback = function (a) {
	return {$: 16, a: a};
};
var $author$project$Model$Model$GetAllStorage = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$Model$GetLastTeamCallback = function (a) {
	return {$: 18, a: a};
};
var $author$project$Model$Model$GetStorage = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$Model$SetLastTeamCallback = function (a) {
	return {$: 20, a: a};
};
var $author$project$Model$Vehicle$SetPhotoUrlCallback = function (a) {
	return {$: 19, a: a};
};
var $author$project$Model$Model$SetStorageCallback = function (a) {
	return {$: 12, a: a};
};
var $author$project$Model$Model$VehicleMsg = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Ports$Storage$deleteSub = _Platform_incomingPort('deleteSub', $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Ports$Storage$getLastTeamSub = _Platform_incomingPort(
	'getLastTeamSub',
	A2(
		$elm$json$Json$Decode$andThen,
		function (value) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (name) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (key) {
							return $elm$json$Json$Decode$succeed(
								{cH: key, cK: name, N: value});
						},
						A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string)));
var $author$project$Ports$Photo$getPhotoUrl = _Platform_incomingPort('getPhotoUrl', $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Ports$Storage$getStorageSub = _Platform_incomingPort(
	'getStorageSub',
	$elm$json$Json$Decode$list(
		A2(
			$elm$json$Json$Decode$andThen,
			function (value) {
				return A2(
					$elm$json$Json$Decode$andThen,
					function (name) {
						return A2(
							$elm$json$Json$Decode$andThen,
							function (key) {
								return $elm$json$Json$Decode$succeed(
									{cH: key, cK: name, N: value});
							},
							A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
					},
					A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
			},
			A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string))));
var $author$project$Ports$Storage$getSub = _Platform_incomingPort(
	'getSub',
	A2(
		$elm$json$Json$Decode$andThen,
		function (value) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (name) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (key) {
							return $elm$json$Json$Decode$succeed(
								{cH: key, cK: name, N: value});
						},
						A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string)));
var $author$project$Ports$Storage$setLastTeamSub = _Platform_incomingPort('setLastTeamSub', $elm$json$Json$Decode$string);
var $author$project$Ports$Storage$setSub = _Platform_incomingPort(
	'setSub',
	A2(
		$elm$json$Json$Decode$andThen,
		function (value) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (name) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (key) {
							return $elm$json$Json$Decode$succeed(
								{cH: key, cK: name, N: value});
						},
						A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string)));
var $author$project$Subscriptions$Subscriptions$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$Storage$getStorageSub($author$project$Model$Model$GetAllStorage),
				$author$project$Ports$Storage$getSub($author$project$Model$Model$GetStorage),
				$author$project$Ports$Storage$setSub($author$project$Model$Model$SetStorageCallback),
				$author$project$Ports$Storage$deleteSub($author$project$Model$Model$DeleteItemCallback),
				$author$project$Ports$Storage$getLastTeamSub($author$project$Model$Model$GetLastTeamCallback),
				$author$project$Ports$Storage$setLastTeamSub($author$project$Model$Model$SetLastTeamCallback),
				$author$project$Ports$Photo$getPhotoUrl(
				A2($elm$core$Basics$composeL, $author$project$Model$Model$VehicleMsg, $author$project$Model$Vehicle$SetPhotoUrlCallback))
			]));
};
var $author$project$Model$Model$Import = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Model$Model$SaveModel = {$: 13};
var $author$project$Model$Model$SetImport = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$Model$SetLastTeam = function (a) {
	return {$: 19, a: a};
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Ports$Storage$delete = _Platform_outgoingPort('delete', $elm$json$Json$Encode$string);
var $author$project$Model$Model$NavToggle = function (a) {
	return {$: 0, a: a};
};
var $author$project$Update$Utils$doNavClose = $author$project$Update$UtilsGeneric$do(
	$author$project$Model$Model$NavToggle(false));
var $author$project$Ports$Storage$get = _Platform_outgoingPort('get', $elm$json$Json$Encode$string);
var $author$project$Ports$Storage$getLastTeam = _Platform_outgoingPort('getLastTeam', $elm$json$Json$Encode$string);
var $author$project$Ports$Storage$getStorage = _Platform_outgoingPort('getStorage', $elm$json$Json$Encode$string);
var $author$project$Model$Model$JsonDecodeError = function (a) {
	return {$: 5, a: a};
};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Model$Settings$SpinResult = F2(
	function (summary, cost) {
		return {cb: cost, dr: summary};
	});
var $author$project$Model$Decoders$Settings$spinResultDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'cost',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'summary',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$Settings$SpinResult)));
var $author$project$Model$Decoders$Settings$settingsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'spinResults',
	$elm$json$Json$Decode$list($author$project$Model$Decoders$Settings$spinResultDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'pointsAllowed',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'percentPerks',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'percentUpgrades',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'percentWeapons',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'percentVehicles',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Model$Settings$Settings)))))));
var $author$project$Model$Sponsors$Sponsor = F4(
	function (name, description, perks, grantedClasses) {
		return {ap: description, cv: grantedClasses, cK: name, c3: perks};
	});
var $author$project$Model$Sponsors$Aggression = 0;
var $author$project$Model$Sponsors$Badass = 1;
var $author$project$Model$Sponsors$Daring = 3;
var $author$project$Model$Sponsors$Military = 5;
var $author$project$Model$Sponsors$Precision = 6;
var $author$project$Model$Sponsors$PrisonCars = 11;
var $author$project$Model$Sponsors$Speed = 9;
var $author$project$Model$Sponsors$Technology = 10;
var $author$project$Model$Decoders$Sponsors$perkClassDecoderHelper = function (s) {
	switch (s) {
		case 'Aggression':
			return $elm$json$Json$Decode$succeed(0);
		case 'Badass':
			return $elm$json$Json$Decode$succeed(1);
		case 'Daring':
			return $elm$json$Json$Decode$succeed(3);
		case 'Military':
			return $elm$json$Json$Decode$succeed(5);
		case 'Precision':
			return $elm$json$Json$Decode$succeed(6);
		case 'Speed':
			return $elm$json$Json$Decode$succeed(9);
		case 'Technology':
			return $elm$json$Json$Decode$succeed(10);
		case 'PrisonCars':
			return $elm$json$Json$Decode$succeed(11);
		default:
			return $elm$json$Json$Decode$fail(s + ' is not a valid perk class.');
	}
};
var $author$project$Model$Sponsors$TeamPerk = F2(
	function (name, description) {
		return {ap: description, cK: name};
	});
var $author$project$Model$Decoders$Sponsors$teamPerkDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$Sponsors$TeamPerk)));
var $author$project$Model$Decoders$Sponsors$sponsorDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'grantedClasses',
	$elm$json$Json$Decode$list(
		A2($elm$json$Json$Decode$andThen, $author$project$Model$Decoders$Sponsors$perkClassDecoderHelper, $elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'perks',
		$elm$json$Json$Decode$list($author$project$Model$Decoders$Sponsors$teamPerkDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$Sponsors$Sponsor)))));
var $author$project$Model$Vehicle$Vehicle = function (name) {
	return function (category) {
		return function (photo) {
			return function (type_) {
				return function (gear) {
					return function (hazards) {
						return function (handling) {
							return function (skidResults) {
								return function (hull) {
									return function (crew) {
										return function (equipment) {
											return function (weight) {
												return function (activated) {
													return function (weapons) {
														return function (upgrades) {
															return function (notes) {
																return function (cost) {
																	return function (key) {
																		return function (specials) {
																			return function (perks) {
																				return function (requiredSponsor) {
																					return {b$: activated, b6: category, cb: cost, cc: crew, ci: equipment, ct: gear, cw: handling, cx: hazards, cB: hull, cH: key, cK: name, cU: notes, c3: perks, c4: photo, da: requiredSponsor, dh: skidResults, dj: specials, dB: type_, dD: upgrades, dG: weapons, dH: weight};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Model$Shared$Advanced = 1;
var $author$project$Model$Shared$Basic = 0;
var $author$project$Model$Decoders$Shared$categoryDecoderHelper = function (str) {
	switch (str) {
		case 'Basic':
			return $elm$json$Json$Decode$succeed(0);
		case 'Advanced':
			return $elm$json$Json$Decode$succeed(1);
		default:
			return $elm$json$Json$Decode$fail(str + ' is not a valid category type');
	}
};
var $author$project$Model$Vehicle$GearTracker = F2(
	function (current, max) {
		return {a2: current, bo: max};
	});
var $author$project$Model$Decoders$Vehicles$gearDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'max',
	$elm$json$Json$Decode$int,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		1,
		$elm$json$Json$Decode$succeed($author$project$Model$Vehicle$GearTracker)));
var $author$project$Model$Vehicle$HullHolder = F2(
	function (current, max) {
		return {a2: current, bo: max};
	});
var $author$project$Model$Decoders$Vehicles$hullDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'max',
	$elm$json$Json$Decode$int,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		0,
		$elm$json$Json$Decode$succeed($author$project$Model$Vehicle$HullHolder)));
var $author$project$Model$Sponsors$Built = 2;
var $author$project$Model$Sponsors$Horror = 4;
var $author$project$Model$Sponsors$defaultSponsor = A4($author$project$Model$Sponsors$Sponsor, '', '', _List_Nil, _List_Nil);
var $author$project$Model$Sponsors$beverly = _Utils_update(
	$author$project$Model$Sponsors$defaultSponsor,
	{
		ap: 'The low growling of the starting grid was eclipsed by an ear-splitting, dizzying sound. Eyeball-shakingly loud, the screeching was suffocating.  A single car drifted forward into the pack, windows like onyx, bumper corroded. The sound changed timbre, dropping suddenly to a sub-audible throb that tightened chests and shattered headlamps. Despite the harsh desert sun, frost began to form  on windshields. Beverly was a stupid story told to scare children. She wasn\'t real.',
		cv: _List_fromArray(
			[4, 2]),
		cK: 'Beverly, the Devil on the Highway',
		c3: _List_fromArray(
			[
				A2($author$project$Model$Sponsors$TeamPerk, 'Graveyard Shift', 'At the start of the game, after deployment, all vehicles in this team except one must gain the Ghost Rider special rule.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Ghost Rider', 'This vehicle ignores, and is ignored by, other vehicles at all times. This vehicle cannot be involved in Collisions. This vehicle may not make shooting attacks or be attacked with shooting weapons. This vehicle may never count towards the victory conditions of a scenario.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Soul Anchor', 'If all in-play vehicles from this team have the Ghost Rider special rule immediately remove all vehicles on this team from play.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'At the Crossroads', 'This team may choose to pay only 1 Audience Vote to respawn a vehicle. If they do, the respawned vehicle must gain the Ghost Rider special rule.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Inexorable', 'If a vehicle from this team is a wreck or out of play, the vehicle may be respawned, even if other rules would ordinarily prevent that.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Soul Harvest', 'If this vehicle\'s movement template comes into contact with an enemy vehicle, this vehicle gains Soul Token, even if the enemy vehicle is being ignored. If this vehicle\'s movement template comes into contact with a friendly vehicle without the Ghost Rider rule that it did not start in contact with, choose one: either gain 1 Audience Vote for each Soul token or repair two Hull Points on the vehicle without the Ghost Rider rule for each Soul Token. Then discard all Soul Tokens from this vehicle. A Ghost Rider may gain a Soul Token and give it to a friendly vehicle in the same activation, as long as it would come into contact with the enemy vehicle first.')
			])
	});
var $author$project$Model$Sponsors$Pursuit = 7;
var $author$project$Model$Sponsors$highwayPatrol = _Utils_update(
	$author$project$Model$Sponsors$defaultSponsor,
	{
		ap: 'Along the Wrecked and broken highways, where law is another word for vengeance, and justice is a forgotten memory; a handful of souls still cling to a dream of order. Perhaps they do it for the glory. Maybe they even get a kick out of it. They are unsanctioned, unloved, and unpaid. Their only power: a badge of bronze. Their only weapon: 600 horsepower of fuel-injected steel. The Highway Patrol are the last law in a world gone crazy.',
		cv: _List_fromArray(
			[9, 7]),
		cK: 'Highway Patrol',
		c3: _List_fromArray(
			[
				A2($author$project$Model$Sponsors$TeamPerk, 'Hot Pursuit', 'Before the first Gear Phase of the game, after deployment, this team must nominate one enemy vehicle as the \"bogey\". If the bogey is Wrecked or disqualified, immediately nominate another enemy vehicle to be the bogey.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Bogey at 12 o\'Clock', 'At the end of this Movement Step, if the bogey in is this vehicle\'s front Arc of Fire, and further than Double Range away, and can be seen by this vehicle, this vehicle may immediately resolve another Movement Step.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Siren', 'At the end of this vehicle\'s Attack Step, if this vehicle is in the bogey\'s rear Arc of Fire (regardless of range), the bogey must either reduce its Gear by 1 or gain 2 Hazard Tokens.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Steel Justice', 'If the bogey wipes out, this team, as a whole, gains 2 Audience Votes. If the bogey is Wrecked this team, as a whole, gains 4 Audience Votes')
			])
	});
var $author$project$Model$Sponsors$idris = _Utils_update(
	$author$project$Model$Sponsors$defaultSponsor,
	{
		ap: 'Yandi Idris is an addict. From the first time the hot and sweet fumes of a singing petrol engine filled his nose he could find no other joy. He said that the first time he pressed that nitro-oxide button was like touching the face of God. Mystical, irrational and dangerous, the Cult of Speed spread like wildfire after Idris\' meteoric rise during the 2012 Gaslands season. He crossed the final finishing line in a ball of fire and his body was never found. His fanatical followers say that at 201mph you can hear his sonorous voice on the rushing head wind.',
		cv: _List_fromArray(
			[6, 9]),
		cK: 'Idris',
		c3: _List_fromArray(
			[
				A2($author$project$Model$Sponsors$TeamPerk, 'N2O Addict', 'This team may purchase the Nitro upgrade at half the listed cost.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Speed Demon', 'When using Nitro, vehicles in this team only gain hazard tokens until they have 3 hazard tokens after each of the two activation, rather than the normal 5.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Cult of Speed', 'If a vehicle in this team selects the long straight maneuver template in movement step 1.1 during gear phase 1, 2 or 3, this team gains +1 audience vote.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Kiss My Asphalt', 'This team may not purchase Gyrocopters.')
			])
	});
var $author$project$Model$Sponsors$Tuning = 12;
var $author$project$Model$Sponsors$maxxine = _Utils_update(
	$author$project$Model$Sponsors$defaultSponsor,
	{
		ap: 'Maxxine is the current grease-smeared face of The Black Swans. While many might assume art to have been the last thing to survive the Martian bombs, The Black Swans dance their mechanised masque for a hypnotised audience. It\'s ballet, but the dancers weigh 4,000 pounds and are dripping in engine oil.',
		cv: _List_fromArray(
			[12, 7]),
		cK: 'Maxxine',
		c3: _List_fromArray(
			[
				A2($author$project$Model$Sponsors$TeamPerk, 'Dizzy', 'This vehicle may resolve any number of Spin results separately • during its Movement Step, one after another. This can allow this vehicle to Spin more than 90 degrees during its Movement Step.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Maxximum Drift', 'If this vehicle resolves two Slide results in a single Movement Step, it may use the Medium Straight in place of the slide template. If this vehicle resolves three or more Slide results in a single Movement Step, it may use the Long Straight in place of the Slide template.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Meshuggah', 'When this vehicle resolves a Slide or Spin that ends within Medium range of a friendly vehicle without causing a Collision, this team gains 1 Audience Vote.')
			])
	});
var $author$project$Model$Sponsors$mishkin = _Utils_update(
	$author$project$Model$Sponsors$defaultSponsor,
	{
		ap: 'Andre Mishkin is not a natural sportsman. However, the brilliant Russian engineer and inventor proves in 2010 that technology is just as solid an answer as skill or ferocity on the track. From his research and development facility on Mars he continues to send designs for unusual and devastating weapons and sleep, hi-tech vehicles to Earth for field-testing by the teams he sponsors.',
		cv: _List_fromArray(
			[5, 10]),
		cK: 'Mishkin',
		c3: _List_fromArray(
			[
				A2($author$project$Model$Sponsors$TeamPerk, 'Thumpermonkey', 'This team may purchase electrical weapons and upgrades.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Dynamo', 'After activating in gear Phase 4, 5 or 6, this vehicle may add +1 ammo tokens to a single electrical weapon or upgrade on that vehicle.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'All the Toys', 'Whenever a vehicle in this team attack with a named weapon that has not been attacked with by any vehicle during this game yet this team gains +1 audience vote.')
			])
	});
var $author$project$Model$Sponsors$miyazaki = _Utils_update(
	$author$project$Model$Sponsors$defaultSponsor,
	{
		ap: 'Yuri Miyazaki grew up in the rubble of Tokyo, fighting her way to the top of the speedway circuit with incredible feats of daring and vehicular agility. She has a small fleet of elite couriers who run jobs for the wealthiest or most desperate clients. It is whispered that she also runs guns for the Pro-Earth Resistance, but no one who spreads that rumour lives long enough to spread it far. Miyazaki\'s drivers are unsurpassed in their skill and finesse.',
		cv: _List_fromArray(
			[3, 6]),
		cK: 'Miyazaki',
		c3: _List_fromArray(
			[
				A2($author$project$Model$Sponsors$TeamPerk, 'Virtuoso', 'The first time each vehicle in this team uses push it in an activation they may push it without gaining a hazard token.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Evasive Maneuvers', 'Before making an evade roll, vehicles in this team may gain any number of hazard tokens to add +1 to each of their evade dice for each hazard token gained. A roll of \"1\" on an evade dice always counts as a failure.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Elegance', 'Teams sponsored by Miyazaki may not purchase Pickup Trucks, Buses or War Rigs.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Showing Off', 'Once per gear phase, if all of this team\'s in-play vehicles activated, resolved at least on un-canceled spin result, resolved at least one un-canceled slide result, resolved at least on stick-shift, and did not wipe out, this team gains +1 audience vote for each of this team\'s in-play vehicles.')
			])
	});
var $author$project$Model$Sponsors$orderOfTheInferno = _Utils_update(
	$author$project$Model$Sponsors$defaultSponsor,
	{
		ap: 'Yandi Idris is not dead. He cannot die. He rides on in the living flame. His voice can be heard in the roar of the road and the screams of superheated metal. Yandi is free, and we can be too. He has shown us the path. Only by knowing the flames can we know true freedom. Buy your copy of \"Freedom in The Flames\" today to find out more. Available from Order of the Inferno stalls at all major trading outposts.',
		cv: _List_fromArray(
			[4, 9]),
		cK: 'Order of the Inferno',
		c3: _List_fromArray(
			[
				A2($author$project$Model$Sponsors$TeamPerk, 'Fire Walk With Me', 'When this vehicle would receive damage from any weapon or effect with the Fire rule, this vehicle may reduce the damage received by up to three, to a minimum of one.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Burning Man', 'If this vehicle is On Fire it gains +1 to all Evade dice.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Cult of Flame', 'At the end of the Gear Phase, if there are more enemy vehicles On Fire than there are friendly vehicles On Fire, or all enemy vehicles are On Fire, this team gains 1 Audience Vote for each friendly vehicle that is On Fire. ')
			])
	});
var $author$project$Model$Sponsors$Reckless = 8;
var $author$project$Model$Sponsors$rustysBootleggers = _Utils_update(
	$author$project$Model$Sponsors$defaultSponsor,
	{
		ap: 'Zeke Rusty and his boys been wall to wall and treetop-tall since before the world went to hell, running moonshine past Smokey back since before the big red one fell. Their stills are volatile, their delivery vehicles are ramshackle, but they still run liquor that grandpappy would be proud of.. Though none the boys can remember just how he liked it right now. Damn that gin.',
		cv: _List_fromArray(
			[8, 2]),
		cK: 'Rusty\'s Bootleggers',
		c3: _List_fromArray(
			[
				A2($author$project$Model$Sponsors$TeamPerk, 'Party Hard', 'At the end of this vehicle\'s Attack Step, if this vehicle has more Hazard Tokens than the sum of the Hazard Tokens on all other enemy vehicles within Medium range combined, this vehicle\'s controller gains 1 Audience Vote for each enemy vehicle within Medium range of this vehicle.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Dutch Courage', 'Vehicles in this team only Wipeput when they have 8 Hazard Tokens.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'As Straight as I\'m Able', 'This vehicle does not gain a Hazard Token from the articulated rule if it selects a template that is not a Straight.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Over the Limit', 'This vehicle never considers any of the Straight movement templates to be permitted. This vehicle considers Veer to be permitted and Trivial in any Gear.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Trailer Trash', 'This team may purchase Trailers. This team must contain either: one or more Medium or Heavyweight vehicles equipped with a trailer upgrade, or a War Rig.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Haulage', 'Each vehicle on this team equipped with a trailer upgrade, and • each War Rig on this team, may equip a single trailer cargo upgrade for free. ')
			])
	});
var $author$project$Model$Sponsors$rutherford = _Utils_update(
	$author$project$Model$Sponsors$defaultSponsor,
	{
		ap: 'Grant Rutherford is the son of a militaristic American oil baron. He is aggressive, rich and uncompromising. His beaming face, beneath his trademark cream Stetson, adorns billboard advertisements for his high-quality and high-priced Rutherford brand weaponry. Teams sponsored by Rutherford get access to military surplus, missile launchers, tanks and helicopters and as much ammo as they can carry. After his team won in 2016, he was only too happy to kiss the Earth goodbye and now runs his company from his highly exclusive Martian office.',
		cv: _List_fromArray(
			[1, 5]),
		cK: 'Rutherford',
		c3: _List_fromArray(
			[
				A2($author$project$Model$Sponsors$TeamPerk, 'Military Hardware', 'This team may purchase a single Tank. This team may purchase a single Helicopter.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Well Stocked', 'This team considers any weapon with the ammo 3 special rule to instead have the ammo 4 special rule when purchased.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Might Is Right', 'This team may not purchase lightweight vehicles.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Televised Carnage', 'If a vehicle in this team causes 6 or more hits in a single attack step, before evades, this team gains +1 audience votes.')
			])
	});
var $author$project$Model$Sponsors$scarlett = _Utils_update(
	$author$project$Model$Sponsors$defaultSponsor,
	{
		ap: 'Gaslands is able to support a vast ecosystem of villainous and scurvy raiders, picking off richer teams as their rigs roll from one televised race to the next. Many of these self-styled pirate crews have gained renown, but none have rivalled the infamy or showmanship of Scarlett Annie. A dashing and flamboyant buccaneer, her cult following is likely more to do with her canny association with the long-running \"Death Valley Death Run\" documentary TV series than any particular skill at dust bowl piracy.',
		cv: _List_fromArray(
			[12, 0]),
		cK: 'Scarlett Annie',
		c3: _List_fromArray(
			[
				A2($author$project$Model$Sponsors$TeamPerk, 'Crew Quarters', 'This team may purchase the Extra Crewmember upgrade at half the listed cost.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Raiders', 'At the end of the attack step, this vehicle may permanently reduce its crew value by any number, to a minimum of 0 crew: remove 1 hull point from any vehicle in base contact for each crew removed in this way.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Raise the Sails', 'After rolling skid dice, this vehicle may permanently  reduce its crew value by 1, to a minimum of 0 crew to add 1 free shift result to the skid dice result.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Press Gang or Keelhaul', 'When another vehicle in contact with this vehicle is wrecked, this vehicle may gain either 1 crew or 2 audience votes.')
			])
	});
var $author$project$Model$Sponsors$slime = _Utils_update(
	$author$project$Model$Sponsors$defaultSponsor,
	{
		ap: 'Slime rules a wild and feral city in the Australian wastes known as Anarchy. Young people crawled out of the wreckage of the scorched earth in their thousands to rally round her ragged banner. The wild-eyed and whooping joyful gangs of Anarchy are led by Slime\'s henchwomen, the Chooks, who seek fame and adoration from the global Gaslands audience.',
		cv: _List_fromArray(
			[0, 9]),
		cK: 'Slime',
		c3: _List_fromArray(
			[
				A2($author$project$Model$Sponsors$TeamPerk, 'Live Fast', 'If a vehicle in this tam begins the wipeout step with more hazard tokens than hull points during its own activation this team gains +1 audience vote.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Pinball', 'If a vehicle in this team is involved in a sideswipe smash attack during its activation, immediately resolve another movement step with that vehicle after the current movement step.')
			])
	});
var $author$project$Model$Sponsors$verney = _Utils_update(
	$author$project$Model$Sponsors$defaultSponsor,
	{
		ap: 'Many have taken the bent deal offered by Warden Cadeila but only one has ever earned their freedom. As skilled an engineer as he is a driver, the newly-freed Verney now specialised in building unique Frankenstein\'s monsters of vehicles for anyone who can afford his high-quality customs.',
		cv: _List_fromArray(
			[10, 2]),
		cK: 'Verney',
		c3: _List_fromArray(
			[
				A2($author$project$Model$Sponsors$TeamPerk, 'Trunk of Junk', 'You may attack with any number of dropped weapons in a single activation.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Tombstone', 'If the shooting template of a shooting attack touches the rear • edge of this vehicle, this vehicle gains +1 to its Evade rolls. During this vehicle\'s Attack Step, this vehicle may gain 2 Hazard Tokens. If it does, all Collisions involving this vehicle are considered to be Head-on until the start of its next activation.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'That\'s Entertainment', 'Whenever a dropped weapon template that was placed by this team is removed from play, this team gains 1 Audience Vote. ')
			])
	});
var $author$project$Model$Sponsors$warden = _Utils_update(
	$author$project$Model$Sponsors$defaultSponsor,
	{
		ap: 'Warden Cadeila is proud to live in Sao Paulo, a shining hub of humanity and relatively untouched by the war. The Sao Paulo People\'s Penitentiary has three of Gaslands\' top ten teams in the past decade, and the Warden continues to grant her prisoners a chance at freedom as long as the Gaslands franchise continues to deliver the sponsorship deals. The deal isn\'t great from the damned souls who are welded into the Warden\'s solid steel \"coffin cars\", but it\'s better than the alternative.',
		cv: _List_fromArray(
			[0, 1, 11]),
		cK: 'Warden',
		c3: _List_fromArray(
			[
				A2($author$project$Model$Sponsors$TeamPerk, 'Prison Cars', 'Vehicles in this team may purchase the Prison Cars upgrade.'),
				A2($author$project$Model$Sponsors$TeamPerk, 'Fireworks', 'If a vehicle belonging to this team explodes, gain +1 audience vote if it was middleweight or +2 audience votes if it was heavyweight in addition to any votes gained for being wrecked, and then discard all ammo tokens from the wreck.')
			])
	});
var $author$project$Model$Sponsors$allSponsors = _List_fromArray(
	[$author$project$Model$Sponsors$rutherford, $author$project$Model$Sponsors$miyazaki, $author$project$Model$Sponsors$mishkin, $author$project$Model$Sponsors$idris, $author$project$Model$Sponsors$slime, $author$project$Model$Sponsors$warden, $author$project$Model$Sponsors$scarlett, $author$project$Model$Sponsors$highwayPatrol, $author$project$Model$Sponsors$verney, $author$project$Model$Sponsors$maxxine, $author$project$Model$Sponsors$orderOfTheInferno, $author$project$Model$Sponsors$beverly, $author$project$Model$Sponsors$rustysBootleggers]);
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$Sponsors$stringToSponsor = function (name) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (sp) {
				return _Utils_eq(sp.cK, name);
			},
			$author$project$Model$Sponsors$allSponsors));
};
var $author$project$Model$Decoders$Shared$requiredSponsorDecoderHelper = function (str) {
	var mSponsor = $author$project$Model$Sponsors$stringToSponsor(str);
	if (!mSponsor.$) {
		var sponsor = mSponsor.a;
		return $elm$json$Json$Decode$succeed(
			$elm$core$Maybe$Just(sponsor));
	} else {
		return $elm$json$Json$Decode$fail(str + ' is not a valid sponsor type');
	}
};
var $author$project$Model$Shared$Ammo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Decoders$Shared$ammoDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Model$Shared$Ammo,
	A2(
		$elm$json$Json$Decode$field,
		'clip',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$bool)));
var $author$project$Model$Shared$Blast = {$: 3};
var $author$project$Model$Decoders$Shared$blastDecoder = $elm$json$Json$Decode$succeed($author$project$Model$Shared$Blast);
var $author$project$Model$Shared$Blitz = {$: 6};
var $author$project$Model$Decoders$Shared$blitzDecoder = $elm$json$Json$Decode$succeed($author$project$Model$Shared$Blitz);
var $author$project$Model$Shared$CrewMod = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$Decoders$Shared$crewModDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Model$Shared$CrewMod,
	A2($elm$json$Json$Decode$field, 'modifier', $elm$json$Json$Decode$int));
var $author$project$Model$Shared$Electrical = {$: 7};
var $author$project$Model$Decoders$Shared$electricalDecoder = $elm$json$Json$Decode$succeed($author$project$Model$Shared$Electrical);
var $author$project$Model$Shared$Fire = {$: 5};
var $author$project$Model$Decoders$Shared$fireDecoder = $elm$json$Json$Decode$succeed($author$project$Model$Shared$Fire);
var $author$project$Model$Shared$GearMod = function (a) {
	return {$: 10, a: a};
};
var $author$project$Model$Decoders$Shared$gearModDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Model$Shared$GearMod,
	A2($elm$json$Json$Decode$field, 'modifier', $elm$json$Json$Decode$int));
var $author$project$Model$Shared$HandlingMod = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$Decoders$Shared$handlingModDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Model$Shared$HandlingMod,
	A2($elm$json$Json$Decode$field, 'modifier', $elm$json$Json$Decode$int));
var $author$project$Model$Shared$HullMod = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$Decoders$Shared$hullModDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Model$Shared$HullMod,
	A2($elm$json$Json$Decode$field, 'modifier', $elm$json$Json$Decode$int));
var $author$project$Model$Shared$NamedSpecialRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Model$Decoders$Shared$namedSpecialRuleDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Model$Shared$NamedSpecialRule,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'text', $elm$json$Json$Decode$string));
var $author$project$Model$Shared$SpecialRule = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Decoders$Shared$specialRuleDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Model$Shared$SpecialRule,
	A2($elm$json$Json$Decode$field, 'text', $elm$json$Json$Decode$string));
var $author$project$Model$Decoders$Shared$specialDecoderHelper = function (str) {
	switch (str) {
		case 'Ammo':
			return $author$project$Model$Decoders$Shared$ammoDecoder;
		case 'SpecialRule':
			return $author$project$Model$Decoders$Shared$specialRuleDecoder;
		case 'NamedSpecialRule':
			return $author$project$Model$Decoders$Shared$namedSpecialRuleDecoder;
		case 'Blast':
			return $author$project$Model$Decoders$Shared$blastDecoder;
		case 'Fire':
			return $author$project$Model$Decoders$Shared$fireDecoder;
		case 'Blitz':
			return $author$project$Model$Decoders$Shared$blitzDecoder;
		case 'Electrical':
			return $author$project$Model$Decoders$Shared$electricalDecoder;
		case 'HandlingMod':
			return $author$project$Model$Decoders$Shared$handlingModDecoder;
		case 'HullMod':
			return $author$project$Model$Decoders$Shared$hullModDecoder;
		case 'GearMod':
			return $author$project$Model$Decoders$Shared$gearModDecoder;
		case 'CrewMod':
			return $author$project$Model$Decoders$Shared$crewModDecoder;
		default:
			return $elm$json$Json$Decode$fail(str + ' is not a valid special type');
	}
};
var $author$project$Model$Decoders$Shared$specialDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Model$Decoders$Shared$specialDecoderHelper,
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Model$Upgrade$Upgrade = F5(
	function (name, slots, specials, cost, requiredSponsor) {
		return {cb: cost, cK: name, da: requiredSponsor, di: slots, dj: specials};
	});
var $author$project$Model$Decoders$Upgrades$upgradeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'requiredSponsor',
	A2($elm$json$Json$Decode$andThen, $author$project$Model$Decoders$Shared$requiredSponsorDecoderHelper, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'cost',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'specials',
			$elm$json$Json$Decode$list($author$project$Model$Decoders$Shared$specialDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'slots',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$Upgrade$Upgrade))))));
var $author$project$Model$Sponsors$VehiclePerk = F3(
	function (name, cost, description) {
		return {cb: cost, ap: description, cK: name};
	});
var $author$project$Model$Decoders$Sponsors$vehiclePerkDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'cost',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Model$Sponsors$VehiclePerk))));
var $author$project$Model$Weapon$Weapon = function (name) {
	return function (mountPoint) {
		return function (attack) {
			return function (attackRoll) {
				return function (range) {
					return function (slots) {
						return function (specials) {
							return function (cost) {
								return function (status) {
									return function (requiredSponsor) {
										return function (category) {
											return {b2: attack, b3: attackRoll, b6: category, cb: cost, cJ: mountPoint, cK: name, c8: range, da: requiredSponsor, di: slots, dj: specials, dm: status};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$Weapon$WeaponReady = 0;
var $author$project$Model$Weapon$Dice = F2(
	function (number, die) {
		return {ce: die, cV: number};
	});
var $author$project$Model$Decoders$Weapons$diceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'die',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'number',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Model$Weapon$Dice)));
var $author$project$Model$Weapon$CrewFired = 5;
var $author$project$Model$Weapon$Front = 1;
var $author$project$Model$Weapon$Full = 0;
var $author$project$Model$Weapon$LeftSide = 2;
var $author$project$Model$Weapon$Rear = 4;
var $author$project$Model$Weapon$RightSide = 3;
var $author$project$Model$Decoders$Weapons$mountPointDecoderHelper = function (mountPointString) {
	switch (mountPointString) {
		case '360° mounted':
			return $elm$json$Json$Decode$succeed(0);
		case 'Front mounted':
			return $elm$json$Json$Decode$succeed(1);
		case 'Left mounted':
			return $elm$json$Json$Decode$succeed(2);
		case 'Right mounted':
			return $elm$json$Json$Decode$succeed(3);
		case 'Rear mounted':
			return $elm$json$Json$Decode$succeed(4);
		case 'Crew fired':
			return $elm$json$Json$Decode$succeed(5);
		default:
			return $elm$json$Json$Decode$fail(mountPointString + ' is not a valid mount point type');
	}
};
var $author$project$Model$Decoders$Weapons$mountPointDecoder = A2($elm$json$Json$Decode$andThen, $author$project$Model$Decoders$Weapons$mountPointDecoderHelper, $elm$json$Json$Decode$string);
var $author$project$Model$Weapon$BurstRange = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$Weapon$Double = {$: 3};
var $author$project$Model$Shared$Large = 1;
var $author$project$Model$Weapon$Medium = {$: 1};
var $author$project$Model$Weapon$Short = {$: 0};
var $author$project$Model$Shared$Small = 0;
var $author$project$Model$Weapon$SmashRange = {$: 6};
var $author$project$Model$Weapon$TemplateLarge = {$: 4};
var $author$project$Model$Decoders$Weapons$rangeHelper = function (str) {
	switch (str) {
		case 'Short':
			return $elm$json$Json$Decode$succeed($author$project$Model$Weapon$Short);
		case 'Medium':
			return $elm$json$Json$Decode$succeed($author$project$Model$Weapon$Medium);
		case 'Double':
			return $elm$json$Json$Decode$succeed($author$project$Model$Weapon$Double);
		case 'Large':
			return $elm$json$Json$Decode$succeed($author$project$Model$Weapon$TemplateLarge);
		case 'Large Burst':
			return $elm$json$Json$Decode$succeed(
				$author$project$Model$Weapon$BurstRange(1));
		case 'Small Burst':
			return $elm$json$Json$Decode$succeed(
				$author$project$Model$Weapon$BurstRange(0));
		case 'Smash':
			return $elm$json$Json$Decode$succeed($author$project$Model$Weapon$SmashRange);
		default:
			return $elm$json$Json$Decode$fail(str + ' is not a valid range type');
	}
};
var $author$project$Model$Decoders$Weapons$rangeDecoder = A2($elm$json$Json$Decode$andThen, $author$project$Model$Decoders$Weapons$rangeHelper, $elm$json$Json$Decode$string);
var $author$project$Model$Decoders$Weapons$weaponDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'category',
	A2($elm$json$Json$Decode$andThen, $author$project$Model$Decoders$Shared$categoryDecoderHelper, $elm$json$Json$Decode$string),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'requiredSponsor',
		A2($elm$json$Json$Decode$andThen, $author$project$Model$Decoders$Shared$requiredSponsorDecoderHelper, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			0,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'cost',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'specials',
					$elm$json$Json$Decode$list($author$project$Model$Decoders$Shared$specialDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'slots',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'range',
							$author$project$Model$Decoders$Weapons$rangeDecoder,
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
								0,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'attack',
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Model$Decoders$Weapons$diceDecoder),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'mountPoint',
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Model$Decoders$Weapons$mountPointDecoder),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'name',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Model$Weapon$Weapon))))))))))));
var $author$project$Model$Vehicle$Heavy = 2;
var $author$project$Model$Vehicle$Light = 0;
var $author$project$Model$Vehicle$Middle = 1;
var $author$project$Model$Decoders$Vehicles$weightDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'Light':
				return $elm$json$Json$Decode$succeed(0);
			case 'Middle':
				return $elm$json$Json$Decode$succeed(1);
			case 'Heavy':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail(str + ' is not a valid weight.');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Decoders$Vehicles$vehicleDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'requiredSponsor',
	A2($elm$json$Json$Decode$andThen, $author$project$Model$Decoders$Shared$requiredSponsorDecoderHelper, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'perks',
		$elm$json$Json$Decode$list($author$project$Model$Decoders$Sponsors$vehiclePerkDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'specials',
			$elm$json$Json$Decode$list($author$project$Model$Decoders$Shared$specialDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'key',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'cost',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'notes',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'upgrades',
							$elm$json$Json$Decode$list($author$project$Model$Decoders$Upgrades$upgradeDecoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'weapons',
								$elm$json$Json$Decode$list($author$project$Model$Decoders$Weapons$weaponDecoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'activated',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'weight',
										$author$project$Model$Decoders$Vehicles$weightDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'equipment',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'crew',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'hull',
													$author$project$Model$Decoders$Vehicles$hullDecoder,
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
														_List_Nil,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'handling',
															$elm$json$Json$Decode$int,
															A2(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																0,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'gear',
																	$author$project$Model$Decoders$Vehicles$gearDecoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'type_',
																		$elm$json$Json$Decode$string,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'photo',
																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																			$elm$core$Maybe$Nothing,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'category',
																				A2($elm$json$Json$Decode$andThen, $author$project$Model$Decoders$Shared$categoryDecoderHelper, $elm$json$Json$Decode$string),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'name',
																					$elm$json$Json$Decode$string,
																					$elm$json$Json$Decode$succeed($author$project$Model$Vehicle$Vehicle))))))))))))))))))))));
var $author$project$Model$Decoders$Model$modelDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'storageKey',
	$elm$json$Json$Decode$string,
	'',
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		$author$project$Model$Features$flags,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'settings',
			$author$project$Model$Decoders$Settings$settingsDecoder,
			$author$project$Model$Model$defaultModel.dd,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				_List_Nil,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					_List_Nil,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						'',
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
							_List_Nil,
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
								$elm$core$Maybe$Nothing,
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
									$elm$core$Maybe$Nothing,
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'sponsor',
											$elm$json$Json$Decode$nullable($author$project$Model$Decoders$Sponsors$sponsorDecoder),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'vehicles',
												$elm$json$Json$Decode$dict($author$project$Model$Decoders$Vehicles$vehicleDecoder),
												$author$project$Model$Model$defaultModel.dE,
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													1,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'pointsAllowed',
														$elm$json$Json$Decode$int,
														$author$project$Model$Model$defaultModel.c5,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'teamName',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															$elm$core$Maybe$Nothing,
															A2(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																$elm$core$Maybe$Nothing,
																A2(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																	$author$project$Model$Views$ViewDashboard,
																	A2(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																		false,
																		$elm$json$Json$Decode$succeed($author$project$Model$Model$Model)))))))))))))))))));
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Update$Data$import_ = F3(
	function (model, key, jsonModel) {
		var decodeRes = A2($elm$json$Json$Decode$decodeString, $author$project$Model$Decoders$Model$modelDecoder, jsonModel);
		var newModel = function () {
			if (!decodeRes.$) {
				var m = decodeRes.a;
				return m;
			} else {
				var s = decodeRes.a;
				return _Utils_update(
					model,
					{
						cj: _List_fromArray(
							[
								$author$project$Model$Model$JsonDecodeError(
								$elm$json$Json$Decode$errorToString(s))
							])
					});
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{cj: newModel.cj, cE: newModel.cE, c5: newModel.c5, dl: newModel.dl, $7: newModel.$7, dv: newModel.dv, dx: newModel.dx, dy: newModel.dy, dz: newModel.dz, dE: newModel.dE, dF: newModel.dF}),
			$elm$core$Platform$Cmd$none);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $author$project$Ports$Storage$StorageEntry = F3(
	function (key, name, value) {
		return {cH: key, cK: name, N: value};
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Model$Encoders$Settings$spinResultEncoder = function (spinResults) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'summary',
			$elm$json$Json$Encode$string(spinResults.dr)),
			_Utils_Tuple2(
			'cost',
			$elm$json$Json$Encode$int(spinResults.cb))
		]);
};
var $author$project$Model$Encoders$Settings$settingsEncoder = function (settings) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'percentVehicles',
			$elm$json$Json$Encode$int(settings.c1)),
			_Utils_Tuple2(
			'percentWeapons',
			$elm$json$Json$Encode$int(settings.c2)),
			_Utils_Tuple2(
			'percentUpgrades',
			$elm$json$Json$Encode$int(settings.c0)),
			_Utils_Tuple2(
			'percentPerks',
			$elm$json$Json$Encode$int(settings.c$)),
			_Utils_Tuple2(
			'pointsAllowed',
			$elm$json$Json$Encode$int(settings.c5)),
			_Utils_Tuple2(
			'spinResults',
			A2(
				$elm$json$Json$Encode$list,
				$elm$json$Json$Encode$object,
				A2($elm$core$List$map, $author$project$Model$Encoders$Settings$spinResultEncoder, settings.dk)))
		]);
};
var $author$project$Model$Sponsors$fromPerkClass = function (perkClass) {
	switch (perkClass) {
		case 0:
			return 'Aggression';
		case 1:
			return 'Badass';
		case 2:
			return 'Built';
		case 3:
			return 'Daring';
		case 4:
			return 'Horror';
		case 5:
			return 'Military';
		case 6:
			return 'Precision';
		case 7:
			return 'Pursuit';
		case 8:
			return 'Reckless';
		case 9:
			return 'Speed';
		case 10:
			return 'Technology';
		case 11:
			return 'PrisonCars';
		default:
			return 'Tuning';
	}
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Model$Encoders$Sponsors$teamPerkEncoder = function (perk) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'name',
			$elm$json$Json$Encode$string(perk.cK)),
			_Utils_Tuple2(
			'description',
			$elm$json$Json$Encode$string(perk.ap))
		]);
};
var $author$project$Model$Encoders$Sponsors$sponsorEncoder = function (msponsor) {
	if (msponsor.$ === 1) {
		return $elm$json$Json$Encode$null;
	} else {
		var sponsor = msponsor.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(sponsor.cK)),
					_Utils_Tuple2(
					'description',
					$elm$json$Json$Encode$string(sponsor.ap)),
					_Utils_Tuple2(
					'perks',
					A2(
						$elm$json$Json$Encode$list,
						$elm$json$Json$Encode$object,
						A2($elm$core$List$map, $author$project$Model$Encoders$Sponsors$teamPerkEncoder, sponsor.c3))),
					_Utils_Tuple2(
					'grantedClasses',
					A2(
						$elm$json$Json$Encode$list,
						$elm$json$Json$Encode$string,
						A2(
							$elm$core$List$map,
							function (s) {
								return $author$project$Model$Sponsors$fromPerkClass(s);
							},
							sponsor.cv)))
				]));
	}
};
var $author$project$Model$Encoders$Model$teamNameEncoder = function (ms) {
	if (ms.$ === 1) {
		return $elm$json$Json$Encode$null;
	} else {
		var s = ms.a;
		return $elm$json$Json$Encode$string(s);
	}
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Model$Encoders$Shared$categoryEncoder = function (category) {
	var categoryText = function () {
		if (!category) {
			return 'Basic';
		} else {
			return 'Advanced';
		}
	}();
	return $elm$json$Json$Encode$string(categoryText);
};
var $author$project$Model$Vehicle$Common$fromVehicleWeight = function (weight) {
	switch (weight) {
		case 0:
			return 'Light';
		case 1:
			return 'Middle';
		default:
			return 'Heavy';
	}
};
var $author$project$Model$Encoders$Vehicles$gearEncoder = function (gear) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'current',
			$elm$json$Json$Encode$int(gear.a2)),
			_Utils_Tuple2(
			'max',
			$elm$json$Json$Encode$int(gear.bo))
		]);
};
var $author$project$Model$Encoders$Vehicles$hullEncoder = function (hull) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'current',
			$elm$json$Json$Encode$int(hull.a2)),
			_Utils_Tuple2(
			'max',
			$elm$json$Json$Encode$int(hull.bo))
		]);
};
var $author$project$Model$Encoders$Vehicles$photoEncoder = function (ms) {
	if (ms.$ === 1) {
		return $elm$json$Json$Encode$null;
	} else {
		var s = ms.a;
		return $elm$json$Json$Encode$string(s);
	}
};
var $author$project$Model$Encoders$Shared$requiredSponsorEncoder = function (mSponsor) {
	if (mSponsor.$ === 1) {
		return $elm$json$Json$Encode$null;
	} else {
		var sponsor = mSponsor.a;
		return $elm$json$Json$Encode$string(sponsor.cK);
	}
};
var $author$project$Model$Encoders$Shared$ammoEncoder = function (clip) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'type',
			$elm$json$Json$Encode$string('Ammo')),
			_Utils_Tuple2(
			'clip',
			A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$bool, clip))
		]);
};
var $author$project$Model$Shared$stringFromSize = function (size) {
	if (!size) {
		return 'Small';
	} else {
		return 'Large';
	}
};
var $author$project$Model$Shared$fromSpecial = function (special) {
	switch (special.$) {
		case 0:
			var count = special.a;
			return 'Ammo ' + $elm$core$String$fromInt(
				$elm$core$List$length(count));
		case 1:
			var s = special.a;
			return 'SpecialRule ' + s;
		case 2:
			var title = special.a;
			var desc = special.b;
			return 'NamedSpecialRule ' + (title + (' ' + desc));
		case 3:
			return 'Blast';
		case 4:
			var size = special.a;
			return $author$project$Model$Shared$stringFromSize(size) + ' Burst';
		case 5:
			return 'Fire';
		case 6:
			return 'Blitz';
		case 7:
			return 'Electrical';
		case 8:
			var i = special.a;
			return 'HandlingMod ' + $elm$core$String$fromInt(i);
		case 9:
			var i = special.a;
			return 'HullMod ' + $elm$core$String$fromInt(i);
		case 10:
			var i = special.a;
			return 'GearMod ' + $elm$core$String$fromInt(i);
		case 11:
			var i = special.a;
			return 'CrewMod ' + $elm$core$String$fromInt(i);
		case 12:
			var i = special.a;
			return 'SlotMod ' + $elm$core$String$fromInt(i);
		case 13:
			return 'Indirect';
		case 14:
			return 'Splash';
		default:
			return 'Full Fire Arc';
	}
};
var $author$project$Model$Encoders$Shared$genericEncoder = function (s) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'type',
			$elm$json$Json$Encode$string(
				$author$project$Model$Shared$fromSpecial(s)))
		]);
};
var $author$project$Model$Encoders$Shared$modEncoderHelper = function (s) {
	switch (s.$) {
		case 8:
			return 'HandlingMod';
		case 9:
			return 'HullMod';
		case 10:
			return 'GearMod';
		case 11:
			return 'CrewMod';
		default:
			return '';
	}
};
var $author$project$Model$Encoders$Shared$modEncoder = F2(
	function (s, i) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(
					$author$project$Model$Encoders$Shared$modEncoderHelper(s))),
				_Utils_Tuple2(
				'modifier',
				$elm$json$Json$Encode$int(i))
			]);
	});
var $author$project$Model$Encoders$Shared$namedSpecialRuleEncoder = F2(
	function (name, text) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('NamedSpecialRule')),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(name)),
				_Utils_Tuple2(
				'text',
				$elm$json$Json$Encode$string(text))
			]);
	});
var $author$project$Model$Encoders$Shared$specialRuleEncoder = function (t) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'type',
			$elm$json$Json$Encode$string('SpecialRule')),
			_Utils_Tuple2(
			'text',
			$elm$json$Json$Encode$string(t))
		]);
};
var $author$project$Model$Encoders$Shared$specialEncoder = function (s) {
	switch (s.$) {
		case 0:
			var ammo = s.a;
			return $author$project$Model$Encoders$Shared$ammoEncoder(ammo);
		case 1:
			var t = s.a;
			return $author$project$Model$Encoders$Shared$specialRuleEncoder(t);
		case 2:
			var t1 = s.a;
			var t2 = s.b;
			return A2($author$project$Model$Encoders$Shared$namedSpecialRuleEncoder, t1, t2);
		case 8:
			var i = s.a;
			return A2($author$project$Model$Encoders$Shared$modEncoder, s, i);
		case 9:
			var i = s.a;
			return A2($author$project$Model$Encoders$Shared$modEncoder, s, i);
		case 10:
			var i = s.a;
			return A2($author$project$Model$Encoders$Shared$modEncoder, s, i);
		case 11:
			var i = s.a;
			return A2($author$project$Model$Encoders$Shared$modEncoder, s, i);
		default:
			return $author$project$Model$Encoders$Shared$genericEncoder(s);
	}
};
var $author$project$Model$Encoders$Upgrades$upgradeEncoder = function (u) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'name',
			$elm$json$Json$Encode$string(u.cK)),
			_Utils_Tuple2(
			'slots',
			$elm$json$Json$Encode$int(u.di)),
			_Utils_Tuple2(
			'specials',
			A2(
				$elm$json$Json$Encode$list,
				$elm$json$Json$Encode$object,
				A2($elm$core$List$map, $author$project$Model$Encoders$Shared$specialEncoder, u.dj))),
			_Utils_Tuple2(
			'cost',
			$elm$json$Json$Encode$int(u.cb)),
			_Utils_Tuple2(
			'requiredSponsor',
			$author$project$Model$Encoders$Shared$requiredSponsorEncoder(u.da))
		]);
};
var $author$project$Model$Encoders$Sponsors$vehiclePerkEncoder = function (perk) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'name',
			$elm$json$Json$Encode$string(perk.cK)),
			_Utils_Tuple2(
			'cost',
			$elm$json$Json$Encode$int(perk.cb)),
			_Utils_Tuple2(
			'description',
			$elm$json$Json$Encode$string(perk.ap))
		]);
};
var $author$project$Model$Encoders$Weapons$diceEncoder = function (maybeDice) {
	if (maybeDice.$ === 1) {
		return $elm$json$Json$Encode$null;
	} else {
		var dice = maybeDice.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'number',
					$elm$json$Json$Encode$int(dice.cV)),
					_Utils_Tuple2(
					'die',
					$elm$json$Json$Encode$int(dice.ce))
				]));
	}
};
var $author$project$Model$Weapon$Common$fromWeaponRange = function (range) {
	switch (range.$) {
		case 0:
			return 'Short';
		case 1:
			return 'Medium';
		case 2:
			return 'Long';
		case 3:
			return 'Double';
		case 4:
			return 'Large';
		case 5:
			var size = range.a;
			return $author$project$Model$Shared$stringFromSize(size) + ' Burst';
		case 6:
			return 'Smash';
		case 7:
			var s = range.a;
			return 'Special: ' + s;
		default:
			return 'Dropped';
	}
};
var $author$project$Model$Weapon$Common$fromWeaponMounting = function (point) {
	switch (point) {
		case 0:
			return '360° mounted';
		case 1:
			return 'Front mounted';
		case 2:
			return 'Left mounted';
		case 3:
			return 'Right mounted';
		case 4:
			return 'Rear mounted';
		default:
			return 'Crew fired';
	}
};
var $author$project$Model$Encoders$Weapons$mountPointEncoder = function (maybePoint) {
	if (maybePoint.$ === 1) {
		return $elm$json$Json$Encode$null;
	} else {
		var point = maybePoint.a;
		return $elm$json$Json$Encode$string(
			$author$project$Model$Weapon$Common$fromWeaponMounting(point));
	}
};
var $author$project$Model$Weapon$Common$fromWeaponStatus = function (status) {
	if (!status) {
		return 'Ready';
	} else {
		return 'Fired';
	}
};
var $author$project$Model$Encoders$Weapons$weaponStatusEncoder = function (ws) {
	return $elm$json$Json$Encode$string(
		$author$project$Model$Weapon$Common$fromWeaponStatus(ws));
};
var $author$project$Model$Encoders$Weapons$weaponEncoder = function (w) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'name',
			$elm$json$Json$Encode$string(w.cK)),
			_Utils_Tuple2(
			'mountPoint',
			$author$project$Model$Encoders$Weapons$mountPointEncoder(w.cJ)),
			_Utils_Tuple2(
			'attack',
			$author$project$Model$Encoders$Weapons$diceEncoder(w.b2)),
			_Utils_Tuple2(
			'range',
			$elm$json$Json$Encode$string(
				$author$project$Model$Weapon$Common$fromWeaponRange(w.c8))),
			_Utils_Tuple2(
			'slots',
			$elm$json$Json$Encode$int(w.di)),
			_Utils_Tuple2(
			'specials',
			A2(
				$elm$json$Json$Encode$list,
				$elm$json$Json$Encode$object,
				A2($elm$core$List$map, $author$project$Model$Encoders$Shared$specialEncoder, w.dj))),
			_Utils_Tuple2(
			'cost',
			$elm$json$Json$Encode$int(w.cb)),
			_Utils_Tuple2(
			'status',
			$author$project$Model$Encoders$Weapons$weaponStatusEncoder(w.dm)),
			_Utils_Tuple2(
			'requiredSponsor',
			$author$project$Model$Encoders$Shared$requiredSponsorEncoder(w.da)),
			_Utils_Tuple2(
			'category',
			$author$project$Model$Encoders$Shared$categoryEncoder(w.b6))
		]);
};
var $author$project$Model$Encoders$Vehicles$vehicleEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(v.cK)),
				_Utils_Tuple2(
				'category',
				$author$project$Model$Encoders$Shared$categoryEncoder(v.b6)),
				_Utils_Tuple2(
				'photo',
				$author$project$Model$Encoders$Vehicles$photoEncoder(v.c4)),
				_Utils_Tuple2(
				'type_',
				$elm$json$Json$Encode$string(v.dB)),
				_Utils_Tuple2(
				'gear',
				$elm$json$Json$Encode$object(
					$author$project$Model$Encoders$Vehicles$gearEncoder(v.ct))),
				_Utils_Tuple2(
				'handling',
				$elm$json$Json$Encode$int(v.cw)),
				_Utils_Tuple2(
				'hull',
				$elm$json$Json$Encode$object(
					$author$project$Model$Encoders$Vehicles$hullEncoder(v.cB))),
				_Utils_Tuple2(
				'crew',
				$elm$json$Json$Encode$int(v.cc)),
				_Utils_Tuple2(
				'equipment',
				$elm$json$Json$Encode$int(v.ci)),
				_Utils_Tuple2(
				'weight',
				$elm$json$Json$Encode$string(
					$author$project$Model$Vehicle$Common$fromVehicleWeight(v.dH))),
				_Utils_Tuple2(
				'activated',
				$elm$json$Json$Encode$bool(v.b$)),
				_Utils_Tuple2(
				'weapons',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$object,
					A2($elm$core$List$map, $author$project$Model$Encoders$Weapons$weaponEncoder, v.dG))),
				_Utils_Tuple2(
				'upgrades',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$object,
					A2($elm$core$List$map, $author$project$Model$Encoders$Upgrades$upgradeEncoder, v.dD))),
				_Utils_Tuple2(
				'notes',
				$elm$json$Json$Encode$string(v.cU)),
				_Utils_Tuple2(
				'cost',
				$elm$json$Json$Encode$int(v.cb)),
				_Utils_Tuple2(
				'key',
				$elm$json$Json$Encode$string(v.cH)),
				_Utils_Tuple2(
				'specials',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$object,
					A2($elm$core$List$map, $author$project$Model$Encoders$Shared$specialEncoder, v.dj))),
				_Utils_Tuple2(
				'perks',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$object,
					A2($elm$core$List$map, $author$project$Model$Encoders$Sponsors$vehiclePerkEncoder, v.c3))),
				_Utils_Tuple2(
				'requiredSponsor',
				$author$project$Model$Encoders$Shared$requiredSponsorEncoder(v.da))
			]));
};
var $author$project$Model$Encoders$Model$modelEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'pointsAllowed',
				$elm$json$Json$Encode$int(model.c5)),
				_Utils_Tuple2(
				'teamName',
				$author$project$Model$Encoders$Model$teamNameEncoder(model.dv)),
				_Utils_Tuple2(
				'vehicles',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Model$Encoders$Vehicles$vehicleEncoder, model.dE)),
				_Utils_Tuple2(
				'sponsor',
				$author$project$Model$Encoders$Sponsors$sponsorEncoder(model.dl)),
				_Utils_Tuple2(
				'settings',
				$elm$json$Json$Encode$object(
					$author$project$Model$Encoders$Settings$settingsEncoder(model.dd))),
				_Utils_Tuple2(
				'storageKey',
				$elm$json$Json$Encode$string(model.$7))
			]));
};
var $author$project$Ports$Storage$set = _Platform_outgoingPort(
	'set',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'key',
					$elm$json$Json$Encode$string($.cH)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string($.cK)),
					_Utils_Tuple2(
					'value',
					$elm$json$Json$Encode$string($.N))
				]));
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Update$Data$saveModel = function (model) {
	var storageEntry = A3(
		$author$project$Ports$Storage$StorageEntry,
		model.$7,
		A2($elm$core$Maybe$withDefault, '', model.dv),
		A2(
			$elm$json$Json$Encode$encode,
			2,
			$author$project$Model$Encoders$Model$modelEncoder(model)));
	return _Utils_Tuple2(
		model,
		$author$project$Ports$Storage$set(storageEntry));
};
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$Update$Sponsor$set = F2(
	function (model, s) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					dl: s,
					dE: A2(
						$elm$core$Dict$map,
						F2(
							function (k, v) {
								return _Utils_update(
									v,
									{c3: _List_Nil});
							}),
						model.dE)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Ports$Storage$setLastTeam = _Platform_outgoingPort('setLastTeam', $elm$json$Json$Encode$string);
var $author$project$Ports$Storage$share = _Platform_outgoingPort('share', $elm$json$Json$Encode$string);
var $author$project$Update$Data$share = F3(
	function (model, key, jsonModel) {
		var value = A2(
			$elm$json$Json$Encode$encode,
			2,
			$author$project$Model$Encoders$Model$modelEncoder(model));
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{cE: value}),
			$author$project$Ports$Storage$share(value));
	});
var $author$project$Update$Settings$update = F2(
	function (model, event) {
		switch (event.$) {
			case 4:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					model,
					A2($elm$core$Task$perform, $author$project$Model$Model$CurrentTimeCallback, $elm$time$Time$now));
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Views$ViewDetails = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $author$project$Model$Model$ViewMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Update$Utils$goTo = function (viewEvent) {
	return $author$project$Update$UtilsGeneric$do(
		$author$project$Model$Model$ViewMsg(viewEvent));
};
var $author$project$Model$Model$ViewTab = function (a) {
	return {$: 2, a: a};
};
var $author$project$Update$Utils$goToTab = function (viewEvent) {
	return $author$project$Update$UtilsGeneric$do(
		$author$project$Model$Model$ViewTab(viewEvent));
};
var $author$project$Update$Upgrade$addUpgrade = F3(
	function (model, key, u) {
		var _v0 = A2($elm$core$Dict$get, key, model.dE);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var vehicle = _v0.a;
			var upgradeList = _Utils_ap(
				vehicle.dD,
				_List_fromArray(
					[u]));
			var nv = _Utils_update(
				vehicle,
				{dD: upgradeList});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						cj: _List_Nil,
						dx: $elm$core$Maybe$Nothing,
						dE: A3($elm$core$Dict$insert, key, nv, model.dE)
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							$author$project$Update$Utils$goToTab(
							$author$project$Model$Views$ViewDetails(key)),
							$author$project$Update$Utils$goTo($author$project$Model$Views$ViewDashboard)
						])));
		}
	});
var $elm_community$list_extra$List$Extra$remove = F2(
	function (x, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var y = xs.a;
			var ys = xs.b;
			return _Utils_eq(x, y) ? ys : A2(
				$elm$core$List$cons,
				y,
				A2($elm_community$list_extra$List$Extra$remove, x, ys));
		}
	});
var $author$project$Update$Upgrade$deleteUpgrade = F3(
	function (model, key, u) {
		var _v0 = A2($elm$core$Dict$get, key, model.dE);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var vehicle = _v0.a;
			var upgradesNew = A2($elm_community$list_extra$List$Extra$remove, u, vehicle.dD);
			var nv = _Utils_update(
				vehicle,
				{dD: upgradesNew});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dE: A3($elm$core$Dict$insert, key, nv, model.dE)
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							$author$project$Update$Utils$goToTab(
							$author$project$Model$Views$ViewDetails(key)),
							$author$project$Update$Utils$goTo($author$project$Model$Views$ViewDashboard)
						])));
		}
	});
var $author$project$Model$Upgrade$defaultUpgrade = A5($author$project$Model$Upgrade$Upgrade, 'TODO', 0, _List_Nil, 0, $elm$core$Maybe$Nothing);
var $author$project$Model$Upgrade$Data$armourPlating = _Utils_update(
	$author$project$Model$Upgrade$defaultUpgrade,
	{
		cb: 4,
		cK: 'Armour Plating',
		di: 1,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$HullMod(2),
				$author$project$Model$Shared$SpecialRule('The vehicle has been loaded with additional plates and shielding, raising its hull value by 2.'),
				$author$project$Model$Shared$SpecialRule('A single vehicle may be fitted with multiple Armour Plating upgrades for further +2 hull points each time.')
			])
	});
var $author$project$Model$Upgrade$Data$experimentalNuclearEngine = _Utils_update(
	$author$project$Model$Upgrade$defaultUpgrade,
	{
		cb: 5,
		cK: 'Experimental Nuclear Engine',
		da: $author$project$Model$Sponsors$stringToSponsor('Mishkin'),
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$Electrical,
				$author$project$Model$Shared$GearMod(2),
				$author$project$Model$Shared$SpecialRule('This vehicle considers the Long Straight movement to be permistted in any Gear. The Long Straight is not considered either Hazardous or Trivial in any Gar.'),
				$author$project$Model$Shared$SpecialRule('If this vehicle ever fails a Flip check, it is immediately Wrecked and automatically Explodes. When this vehicle Explodes, it counts as Heavyweight.'),
				$author$project$Model$Shared$SpecialRule('This upgrade my not be purchases for lightweight vehicles. A vehicle may purchase this upgrade once.')
			])
	});
var $author$project$Model$Upgrade$Data$experimentalTeleporter = _Utils_update(
	$author$project$Model$Upgrade$defaultUpgrade,
	{
		cb: 7,
		cK: 'Experimental Teleporter',
		da: $author$project$Model$Sponsors$stringToSponsor('Mishkin'),
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$Electrical,
				$author$project$Model$Shared$SpecialRule('At the start of this vehicle\'s activation this vehicle may choose to activate the Experimental Teleporter prior to (and in addition to) its normal Movement Step. When the Experimental Teleporter is activated, this vehicle gains 3 Hazard Tokens, and then rolsl a single Skid Die.'),
				$author$project$Model$Shared$SpecialRule('If the Skid Die result is any result other than a Hazard, place this vehicle anywhere within Medium range of its current position, not touching any obstructions or terrain, without altering the vehicles facing. This does not cause a Collision. This vehicle then begins its normal Movement Step from this new location.'),
				$author$project$Model$Shared$SpecialRule('If the Skid Dice result is a Hazard, the player to the left of the controller of the vehicle places this vehicle wnywhere within Long range of it\'s current Position, not touching an obstruction or terrain, without altering it\'s facing. This does not cause a Collision.'),
				$author$project$Model$Shared$SpecialRule('A vehicle may purchase this upgrade once.')
			])
	});
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Model$Shared$ammoInit = function (clip) {
	return $author$project$Model$Shared$Ammo(
		A2($elm$core$List$repeat, clip, false));
};
var $author$project$Model$Upgrade$Data$explodingRam = _Utils_update(
	$author$project$Model$Upgrade$defaultUpgrade,
	{
		cb: 3,
		cK: 'Exploding Ram',
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(1),
				$author$project$Model$Shared$SpecialRule('When purchasing this upgrade, a facing must be declared for it, as if it was a weapon. A vehicle may only purchase this upgrade once. Lightweight vehicles may not purchase this upgrade.'),
				$author$project$Model$Shared$SpecialRule('The first time this vehicle is involved in a Collision on the declared facing in a game, this vehicle must declare a Smash Attack (even if the Collision is a Tailgate). During this Smash Attack this vehicle gains +6 attack dice. If any 1s or 2s are rolled on this vehicle\'s attack dice during this Smash Attack, this vehicle immediately loses on hull point for each 1 or 2 rolled.'),
				$author$project$Model$Shared$SpecialRule('A vehicle may equip both a Ram and an Exploding Ram on the same facing, and their effects are cumulative.'),
				$author$project$Model$Shared$SpecialRule('A vehicle may only purchase one explosive ram. Bikes may not purchase this weapon.')
			])
	});
var $author$project$Model$Upgrade$Data$extraCrewmember = _Utils_update(
	$author$project$Model$Upgrade$defaultUpgrade,
	{
		cb: 4,
		cK: 'Extra Crewmember',
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$CrewMod(1),
				$author$project$Model$Shared$SpecialRule('Up to a maximum of twice the vehicle\'s starting Crew Value')
			])
	});
var $author$project$Model$Upgrade$Data$improvisedSludgeThrower = _Utils_update(
	$author$project$Model$Upgrade$defaultUpgrade,
	{
		cb: 2,
		cK: 'Improvised Sludge Thrower',
		di: 1,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$SpecialRule('This vehicle may place the burst templates for its dropped weapons anywhere within a 360° arc of fire that is at least partially within medium range of this vehicle.')
			])
	});
var $author$project$Model$Upgrade$Data$louderSiren = _Utils_update(
	$author$project$Model$Upgrade$defaultUpgrade,
	{
		cb: 2,
		cK: 'Louder Siren',
		da: $author$project$Model$Sponsors$stringToSponsor('Highway Patrol'),
		di: 0,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$SpecialRule('Replace \"bogey\" with \"any enemy vehicle\" for the purposes of the Siren special rules.')
			])
	});
var $author$project$Model$Upgrade$Data$microPlateArmour = _Utils_update(
	$author$project$Model$Upgrade$defaultUpgrade,
	{
		cb: 6,
		cK: 'MicroPlate Armour',
		da: $author$project$Model$Sponsors$stringToSponsor('Verney'),
		di: 0,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$HullMod(2)
			])
	});
var $author$project$Model$Upgrade$Data$nitroBooster = _Utils_update(
	$author$project$Model$Upgrade$defaultUpgrade,
	{
		cb: 6,
		cK: 'Nitro Booster',
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(1),
				$author$project$Model$Shared$SpecialRule('Once per activation, at the start of a Movement Step, this vehicle may declare that it is using a Nitro Booster. If it does, this vehicle makes an immediate forced, Long Straight move forward, and then gains Hazard Tokens until it has 5 Hazard Tokens. It then resolves its Movement Step as normal, except that the vehicle may not reverse. At the end of a Movement Step in which this vehicle used Nitro Booster, it gains Hazard Tokens until it has 5 Hazard Tokens.')
			])
	});
var $author$project$Model$Upgrade$Data$ram = _Utils_update(
	$author$project$Model$Upgrade$defaultUpgrade,
	{
		cb: 4,
		cK: 'Ram',
		di: 1,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$SpecialRule('The ram can represent a ram, a bulldozer blade, a cow-catcher, a buzz saw, a wreaking ball on a chain, spiked or scythed wheels, metal spikes, or any other vicious or dangerous close combat weapon attached to the vehicle.'),
				$author$project$Model$Shared$SpecialRule('When purchasing this upgrade, a facing must be declared for it, as if it was a weapon. A vehicle may only purchase a single Ram on each facing.'),
				$author$project$Model$Shared$SpecialRule('When involved in a collision on the declared facing, this vehicle may add +2 attack dice to its Smash Attack, and this vehicle does not gain any hazard tokens as a result of the collision.')
			])
	});
var $author$project$Model$Upgrade$Data$rollCage = _Utils_update(
	$author$project$Model$Upgrade$defaultUpgrade,
	{
		cb: 4,
		cK: 'Roll Cage',
		di: 1,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$SpecialRule('When this vehicle suffers a Flip, this vehicle may choose to ignore the 2 hits it received from the Flip.')
			])
	});
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $author$project$Model$Upgrade$Data$tankTracks = _Utils_update(
	$author$project$Model$Upgrade$defaultUpgrade,
	{
		cb: 4,
		cK: 'Tank Tracks',
		di: 1,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$GearMod(-1),
				$author$project$Model$Shared$HandlingMod(1),
				$author$project$Model$Shared$SpecialRule('The vehicle with tank tracks has had its wheels replaced with caterpillar tracks. It increases its Handling by 1 but reduces its max Gear by 1. This vehicle may also ignore rough and treacherous surfaces.'),
				$author$project$Model$Shared$SpecialRule('A vehicle may on purchase this upgrade once. Tanks, Helicopters, and Gyrocopers may not purchase tank tracks.')
			])
	});
var $author$project$Model$Shared$SlotMod = function (a) {
	return {$: 12, a: a};
};
var $author$project$Model$Upgrade$Data$trailer = function (weightClass) {
	var baseUpgrade = _Utils_update(
		$author$project$Model$Upgrade$defaultUpgrade,
		{
			cK: 'Trailer',
			da: $author$project$Model$Sponsors$stringToSponsor('Rusty\'s Bootleggers'),
			dj: _List_fromArray(
				[
					A2($author$project$Model$Shared$NamedSpecialRule, 'Stowage', 'Middleweight trailers provide 1 additional build slot to the towing vehicle. Heavyweight trailers provide 3 additional build slots to the towing vehicle. When purchasing a weapon for a vehicle with a trailer, the player must declare whether that weapons is installed on the cab or the trailer. When measuring range, place the shooting template touching either the cab or the trailer, depending on where the weapon is mounted, as per the Articulated rules (see War Rig, page 118).')
				])
		});
	switch (weightClass) {
		case 0:
			return _Utils_update(
				baseUpgrade,
				{cb: 4});
		case 1:
			return _Utils_update(
				baseUpgrade,
				{
					cb: 8,
					dj: A2(
						$elm$core$List$cons,
						$author$project$Model$Shared$SlotMod(1),
						baseUpgrade.dj)
				});
		default:
			return _Utils_update(
				baseUpgrade,
				{
					cb: 8,
					dj: A2(
						$elm$core$List$cons,
						$author$project$Model$Shared$SlotMod(3),
						baseUpgrade.dj)
				});
	}
};
var $author$project$Model$Upgrade$Data$upgrades = _List_fromArray(
	[
		$author$project$Model$Upgrade$Data$armourPlating,
		$author$project$Model$Upgrade$Data$experimentalNuclearEngine,
		$author$project$Model$Upgrade$Data$experimentalTeleporter,
		$author$project$Model$Upgrade$Data$explodingRam,
		$author$project$Model$Upgrade$Data$extraCrewmember,
		$author$project$Model$Upgrade$Data$improvisedSludgeThrower,
		$author$project$Model$Upgrade$Data$nitroBooster,
		$author$project$Model$Upgrade$Data$ram,
		$author$project$Model$Upgrade$Data$rollCage,
		$author$project$Model$Upgrade$Data$tankTracks,
		$author$project$Model$Upgrade$Data$louderSiren,
		$author$project$Model$Upgrade$Data$microPlateArmour,
		$author$project$Model$Upgrade$Data$trailer(0),
		$author$project$Model$Upgrade$Data$trailer(1),
		$author$project$Model$Upgrade$Data$trailer(2)
	]);
var $author$project$Model$Upgrade$Common$allUpgradesList = $author$project$Model$Upgrade$Data$upgrades;
var $author$project$Model$Upgrade$Common$nameToUpgrade = function (name) {
	return A2(
		$elm$core$Dict$get,
		name,
		$elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (u) {
					return _Utils_Tuple2(u.cK, u);
				},
				$author$project$Model$Upgrade$Common$allUpgradesList)));
};
var $author$project$Update$Upgrade$update = F2(
	function (model, event) {
		switch (event.$) {
			case 0:
				var v = event.a;
				var u = event.b;
				return A3($author$project$Update$Upgrade$addUpgrade, model, v, u);
			case 1:
				var v = event.a;
				var u = event.b;
				return A3($author$project$Update$Upgrade$deleteUpgrade, model, v, u);
			default:
				var name = event.a;
				var u = $author$project$Model$Upgrade$Common$nameToUpgrade(name);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dx: u}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Model$VehicleNameError = {$: 0};
var $author$project$Update$Utils$doSaveModel = $author$project$Update$UtilsGeneric$do($author$project$Model$Model$SaveModel);
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $author$project$Update$Vehicle$addVehicle = F2(
	function (model, vehicle) {
		var key = _Utils_ap(
			vehicle.cK,
			$elm$core$String$fromInt(
				$elm$core$Dict$size(model.dE)));
		var newDict = A3(
			$elm$core$Dict$insert,
			key,
			_Utils_update(
				vehicle,
				{cH: key}),
			model.dE);
		var _v0 = vehicle.cK;
		if (_v0 === '') {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						cj: A2($elm$core$List$cons, $author$project$Model$Model$VehicleNameError, model.cj)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{cj: _List_Nil, dy: $elm$core$Maybe$Nothing, dE: newDict}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							$author$project$Update$Utils$goToTab(
							$author$project$Model$Views$ViewDetails(key)),
							$author$project$Update$Utils$doSaveModel
						])));
		}
	});
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $author$project$Update$Vehicle$deleteVehicle = F2(
	function (model, key) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					ds: $elm$core$Maybe$Nothing,
					dE: A2($elm$core$Dict$remove, key, model.dE)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Ports$Photo$getStream = _Platform_outgoingPort('getStream', $elm$json$Json$Encode$string);
var $author$project$Update$Vehicle$discardPhoto = F2(
	function (model, key) {
		var _v0 = A2($elm$core$Dict$get, key, model.dE);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var vehicle = _v0.a;
			var nv = _Utils_update(
				vehicle,
				{c4: $elm$core$Maybe$Nothing});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dE: A3($elm$core$Dict$insert, key, nv, model.dE),
						dF: $author$project$Model$Views$ViewDetails(nv.cH)
					}),
				$author$project$Ports$Photo$getStream(''));
		}
	});
var $author$project$Update$Vehicle$getStream = F2(
	function (model, key) {
		return _Utils_Tuple2(
			model,
			$author$project$Ports$Photo$getStream(''));
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$Update$Vehicle$setPerkInVehicle = F4(
	function (model, key, perk, isSet) {
		var _v0 = A2($elm$core$Dict$get, key, model.dE);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var vehicle = _v0.a;
			var perkList = function () {
				var _v1 = _Utils_Tuple2(
					isSet,
					A2($elm$core$List$member, perk, vehicle.c3));
				if (_v1.a) {
					if (!_v1.b) {
						return A2($elm$core$List$cons, perk, vehicle.c3);
					} else {
						return vehicle.c3;
					}
				} else {
					return A2(
						$elm$core$List$filter,
						function (s) {
							return !_Utils_eq(s, perk);
						},
						vehicle.c3);
				}
			}();
			var nv = _Utils_update(
				vehicle,
				{c3: perkList});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dE: A3($elm$core$Dict$insert, key, nv, model.dE)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Vehicle$defaultVehicle = $author$project$Model$Vehicle$Vehicle('')(0)($elm$core$Maybe$Nothing)('')(
	A2($author$project$Model$Vehicle$GearTracker, 1, 0))(0)(0)(_List_Nil)(
	A2($author$project$Model$Vehicle$HullHolder, 0, 0))(0)(0)(0)(false)(_List_Nil)(_List_Nil)('')(0)('')(_List_Nil)(_List_Nil)($elm$core$Maybe$Nothing);
var $author$project$Model$Vehicle$Data$ambulance = _Utils_update(
	$author$project$Model$Vehicle$defaultVehicle,
	{
		cb: 20,
		cc: 3,
		ci: 3,
		ct: A2($author$project$Model$Vehicle$GearTracker, 1, 5),
		cw: 2,
		cB: A2($author$project$Model$Vehicle$HullHolder, 0, 12),
		dj: _List_fromArray(
			[
				A2($author$project$Model$Shared$NamedSpecialRule, 'Uppers', 'If this vehicle is involved in a Collision in which both vehicles declare an Evade, both vehicles must declare a single change Gear up immediately after the Collision is resolved (gaining a Hazard Token as normal). If either vehicle is already at its max Gear, the change of Gear does not affect that vehicle\'s current Gar, but that vehicles does gain a Hazard Token.'),
				A2($author$project$Model$Shared$NamedSpecialRule, 'Downers', 'When this vehicle is involved in a Collision during its activation in which it delcares a Smash Attack, the target vehicle does not gain any Hazard Tokens from the Colision and instead discards 2 Hazard Tokens. Then reduce the target vehicle\'s Crew Valuby 1 until the end of the Gear Phase.')
			]),
		dB: 'Ambulance',
		dH: 1
	});
var $author$project$Model$Vehicle$Data$pivot = A2($author$project$Model$Shared$NamedSpecialRule, 'Pivot', 'At the start of this vehicle\'s activation, if this vehicle\'s current gar is 1, this vehicle may make a pivot about its centre to face any direction. This pivot cannot cause a collision, and cannot leave this vehicle touching an obstruction.');
var $author$project$Model$Vehicle$Data$bike = _Utils_update(
	$author$project$Model$Vehicle$defaultVehicle,
	{
		cb: 5,
		cc: 1,
		ci: 1,
		ct: A2($author$project$Model$Vehicle$GearTracker, 1, 6),
		cw: 5,
		cB: A2($author$project$Model$Vehicle$HullHolder, 0, 4),
		dj: _List_fromArray(
			[
				A2($author$project$Model$Shared$NamedSpecialRule, 'Full Throttle', 'This vehicle considers the long straight maneuver template to be permitted in any gear. The long straight is not considered either hazardous or trivial in any gear.'),
				$author$project$Model$Vehicle$Data$pivot
			]),
		dB: 'Bike',
		dH: 0
	});
var $author$project$Model$Vehicle$Data$bikeWithSidecar = _Utils_update(
	$author$project$Model$Vehicle$Data$bike,
	{cb: 8, cc: 2, dB: 'Bike with Sidecar'});
var $author$project$Model$Vehicle$Data$buggy = _Utils_update(
	$author$project$Model$Vehicle$defaultVehicle,
	{
		cb: 6,
		cc: 2,
		ci: 2,
		ct: A2($author$project$Model$Vehicle$GearTracker, 1, 6),
		cw: 4,
		cB: A2($author$project$Model$Vehicle$HullHolder, 0, 6),
		dj: _List_fromArray(
			[
				A2($author$project$Model$Shared$NamedSpecialRule, 'Roll Cage', 'When this vehicle suffers a flip, this vehicle may choose to ignore the 2 hits received from the flip.')
			]),
		dB: 'Buggy',
		dH: 0
	});
var $author$project$Model$Vehicle$Data$bus = _Utils_update(
	$author$project$Model$Vehicle$defaultVehicle,
	{
		cb: 30,
		cc: 8,
		ci: 3,
		ct: A2($author$project$Model$Vehicle$GearTracker, 1, 3),
		cw: 2,
		cB: A2($author$project$Model$Vehicle$HullHolder, 0, 16),
		dB: 'Bus',
		dH: 2
	});
var $author$project$Model$Vehicle$Data$car = _Utils_update(
	$author$project$Model$Vehicle$defaultVehicle,
	{
		cb: 12,
		cc: 2,
		ci: 2,
		ct: A2($author$project$Model$Vehicle$GearTracker, 1, 5),
		cw: 3,
		cB: A2($author$project$Model$Vehicle$HullHolder, 0, 10),
		dB: 'Car',
		dH: 1
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $author$project$Model$Vehicle$Data$dragRacer = _Utils_update(
	$author$project$Model$Vehicle$defaultVehicle,
	{
		cb: 5,
		cc: 1,
		ci: 2,
		ct: A2($author$project$Model$Vehicle$GearTracker, 1, 6),
		cw: 4,
		cB: A2($author$project$Model$Vehicle$HullHolder, 0, 4),
		dj: _List_fromArray(
			[
				A2($author$project$Model$Shared$NamedSpecialRule, 'Jet Engine', 'A vehicle with a jet engine counts as having a Nitro Booster with infinite ammo tokens. This means this vehicle automatically Explodes when it is Wrecked. A vehicle with jet engine must use Nitro Booster every time it activates.')
			]),
		dB: 'Drag Racer',
		dH: 0
	});
var $author$project$Model$Vehicle$Data$flyingSpecials = _List_fromArray(
	[
		A2($author$project$Model$Shared$NamedSpecialRule, 'Airborne', 'This vehicle ignores obstructions, dropped weapons and terrain at all times, except that this vehicle may target other vehicles in its attack step.'),
		$author$project$Model$Shared$SpecialRule('Other vehicles ignore this vehicle at all times, except that other vehicles may target this vehicle during their attack steps. This vehicle cannot be involved in collisions.'),
		A2($author$project$Model$Shared$NamedSpecialRule, 'Air Wolf', 'At the start of this vehicle\'s activation, this vehicle may make a single pivot about its centre point, up to 90 degrees.'),
		A2($author$project$Model$Shared$NamedSpecialRule, 'Bombs Away', 'When purchasing weapons, this vehicle may count dropped weapons as requiring 0 build slots.')
	]);
var $author$project$Model$Vehicle$Data$gyrocopter = _Utils_update(
	$author$project$Model$Vehicle$defaultVehicle,
	{
		cb: 10,
		cc: 1,
		ci: 0,
		ct: A2($author$project$Model$Vehicle$GearTracker, 1, 3),
		cw: 4,
		cB: A2($author$project$Model$Vehicle$HullHolder, 0, 4),
		dj: $author$project$Model$Vehicle$Data$flyingSpecials,
		dB: 'Gyrocopter',
		dH: 2
	});
var $author$project$Model$Vehicle$Data$heavyTruck = _Utils_update(
	$author$project$Model$Vehicle$defaultVehicle,
	{
		cb: 25,
		cc: 4,
		ci: 5,
		ct: A2($author$project$Model$Vehicle$GearTracker, 1, 3),
		cw: 2,
		cB: A2($author$project$Model$Vehicle$HullHolder, 0, 14),
		dB: 'Heavy Truck',
		dH: 2
	});
var $author$project$Model$Vehicle$Data$helicopter = _Utils_update(
	$author$project$Model$Vehicle$defaultVehicle,
	{
		cb: 30,
		cc: 2,
		ci: 4,
		ct: A2($author$project$Model$Vehicle$GearTracker, 1, 4),
		cw: 3,
		cB: A2($author$project$Model$Vehicle$HullHolder, 0, 8),
		da: $author$project$Model$Sponsors$stringToSponsor('Rutherford'),
		dj: $author$project$Model$Vehicle$Data$flyingSpecials,
		dB: 'Helicopter',
		dH: 2
	});
var $author$project$Model$Vehicle$Data$iceCreamTruck = _Utils_update(
	$author$project$Model$Vehicle$defaultVehicle,
	{
		cb: 8,
		cc: 2,
		ci: 2,
		ct: A2($author$project$Model$Vehicle$GearTracker, 1, 4),
		cw: 2,
		cB: A2($author$project$Model$Vehicle$HullHolder, 0, 10),
		dj: _List_fromArray(
			[
				A2($author$project$Model$Shared$NamedSpecialRule, 'Infuriating Jingle', 'Vehicles that target this vehicle with a Smash Attack during a Collision gain no Hazard Tokens during step 6 of the Collision resolution.')
			]),
		dB: 'Ice Cream Truck',
		dH: 1
	});
var $author$project$Model$Vehicle$Data$allTerrain = A2($author$project$Model$Shared$NamedSpecialRule, 'All Terrain', 'This vehicle may ignore the penalties for rough and treacherous surfaces.');
var $author$project$Model$Vehicle$Data$upAndOver = A2($author$project$Model$Shared$NamedSpecialRule, 'Up and Over', 'During this vehicle\'s Movement Step, after resolving a Collision with an obstruction of a lower weight class, this vehicle may delcare that it is going \"Up and Over\". If ti does, it may ignore the obstruction for the remainder of its Movement STep, as it drives right over the top of it. This vehicle cannot use htis ability to ignore another vehicle with the \"Up and Over\" special rule.');
var $author$project$Model$Vehicle$Data$monsterTruck = _Utils_update(
	$author$project$Model$Vehicle$defaultVehicle,
	{
		cb: 25,
		cc: 2,
		ci: 2,
		ct: A2($author$project$Model$Vehicle$GearTracker, 1, 4),
		cw: 3,
		cB: A2($author$project$Model$Vehicle$HullHolder, 0, 10),
		dj: _List_fromArray(
			[$author$project$Model$Vehicle$Data$allTerrain, $author$project$Model$Vehicle$Data$upAndOver]),
		dB: 'Monster Truck',
		dH: 2
	});
var $author$project$Model$Vehicle$Data$performanceCar = _Utils_update(
	$author$project$Model$Vehicle$defaultVehicle,
	{
		cb: 15,
		cc: 1,
		ci: 2,
		ct: A2($author$project$Model$Vehicle$GearTracker, 1, 6),
		cw: 4,
		cB: A2($author$project$Model$Vehicle$HullHolder, 0, 8),
		dj: _List_fromArray(
			[
				A2($author$project$Model$Shared$NamedSpecialRule, 'Slip Away', 'If this vehicle is targeted wtih a Tailgate or T-bone Smash Attack, and this vehicle declares Evade as its reaction, this vehicle may perform a free activation immediately after the active vehicle completes its activation. This free activation does not count as the vehicle\'s activation this gear phase.')
			]),
		dB: 'Performance Car',
		dH: 1
	});
var $author$project$Model$Shared$setCategory = F2(
	function (toSet, thing) {
		return _Utils_update(
			thing,
			{b6: toSet});
	});
var $author$project$Model$Vehicle$Data$tank = _Utils_update(
	$author$project$Model$Vehicle$defaultVehicle,
	{
		cb: 40,
		cc: 3,
		ci: 4,
		ct: A2($author$project$Model$Vehicle$GearTracker, 1, 3),
		cw: 4,
		cB: A2($author$project$Model$Vehicle$HullHolder, 0, 20),
		da: $author$project$Model$Sponsors$stringToSponsor('Rutherford'),
		dj: _List_fromArray(
			[
				$author$project$Model$Vehicle$Data$allTerrain,
				$author$project$Model$Vehicle$Data$pivot,
				A2($author$project$Model$Shared$NamedSpecialRule, 'Turret', 'This vehicle may count one weapon as a turren-mounted weapon without paying for the upgrade.'),
				$author$project$Model$Vehicle$Data$upAndOver
			]),
		dB: 'Tank',
		dH: 2
	});
var $author$project$Model$Vehicle$Data$truck = _Utils_update(
	$author$project$Model$Vehicle$defaultVehicle,
	{
		cb: 15,
		cc: 3,
		ci: 3,
		ct: A2($author$project$Model$Vehicle$GearTracker, 1, 4),
		cw: 2,
		cB: A2($author$project$Model$Vehicle$HullHolder, 0, 12),
		dB: 'Truck',
		dH: 1
	});
var $author$project$Model$Vehicle$Data$warRig = _Utils_update(
	$author$project$Model$Vehicle$defaultVehicle,
	{
		cb: 40,
		cc: 5,
		ci: 5,
		ct: A2($author$project$Model$Vehicle$GearTracker, 1, 4),
		cw: 2,
		cB: A2($author$project$Model$Vehicle$HullHolder, 0, 20),
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$SpecialRule('See War Rig rules.')
			]),
		dB: 'WarRig',
		dH: 2
	});
var $author$project$Model$Vehicle$Data$vehicles = $elm$core$List$concat(
	_List_fromArray(
		[
			A2(
			$elm$core$List$map,
			$author$project$Model$Shared$setCategory(0),
			_List_fromArray(
				[$author$project$Model$Vehicle$Data$buggy, $author$project$Model$Vehicle$Data$car, $author$project$Model$Vehicle$Data$performanceCar, $author$project$Model$Vehicle$Data$truck, $author$project$Model$Vehicle$Data$heavyTruck, $author$project$Model$Vehicle$Data$bus])),
			A2(
			$elm$core$List$map,
			$author$project$Model$Shared$setCategory(1),
			_List_fromArray(
				[$author$project$Model$Vehicle$Data$dragRacer, $author$project$Model$Vehicle$Data$bike, $author$project$Model$Vehicle$Data$bikeWithSidecar, $author$project$Model$Vehicle$Data$iceCreamTruck, $author$project$Model$Vehicle$Data$gyrocopter, $author$project$Model$Vehicle$Data$ambulance, $author$project$Model$Vehicle$Data$monsterTruck, $author$project$Model$Vehicle$Data$helicopter, $author$project$Model$Vehicle$Data$tank, $author$project$Model$Vehicle$Data$warRig]))
		]));
var $author$project$Model$Vehicle$Common$allVehicles = $author$project$Model$Vehicle$Data$vehicles;
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $author$project$View$Utils$sponsorFilter_ = F2(
	function (model, mst) {
		var _v0 = _Utils_Tuple2(model.dl, mst);
		if (_v0.b.$ === 1) {
			var _v1 = _v0.b;
			return true;
		} else {
			if (_v0.a.$ === 1) {
				var _v2 = _v0.a;
				return _Utils_eq($elm$core$Maybe$Nothing, mst);
			} else {
				var sponsor = _v0.a.a;
				var vehicleSponsor = _v0.b.a;
				return _Utils_eq(sponsor, vehicleSponsor);
			}
		}
	});
var $author$project$View$Utils$vehicleSponsorFilter = F2(
	function (model, v) {
		return A2($author$project$View$Utils$sponsorFilter_, model, v.da);
	});
var $author$project$Update$Vehicle$setTmpVehicleType = F2(
	function (model, index) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					dy: A2(
						$elm_community$list_extra$List$Extra$getAt,
						index,
						A2(
							$elm$core$List$filter,
							$author$project$View$Utils$vehicleSponsorFilter(model),
							$author$project$Model$Vehicle$Common$allVehicles))
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Ports$Photo$destroyStream = _Platform_outgoingPort('destroyStream', $elm$json$Json$Encode$string);
var $author$project$Update$Vehicle$setUrlForVehicle = F3(
	function (model, key, url) {
		var _v0 = A2($elm$core$Dict$get, key, model.dE);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var vehicle = _v0.a;
			var nv = _Utils_update(
				vehicle,
				{
					c4: $elm$core$Maybe$Just(url)
				});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dE: A3($elm$core$Dict$insert, key, nv, model.dE),
						dF: $author$project$Model$Views$ViewDetails(nv.cH)
					}),
				$author$project$Ports$Photo$destroyStream(''));
		}
	});
var $author$project$Ports$Photo$takePhoto = _Platform_outgoingPort('takePhoto', $elm$json$Json$Encode$string);
var $author$project$Update$Vehicle$takePhoto = F2(
	function (model, key) {
		return _Utils_Tuple2(
			model,
			$author$project$Ports$Photo$takePhoto(''));
	});
var $author$project$Update$Vehicle$updateActivated = F3(
	function (model, key, activated) {
		var _v0 = A2($elm$core$Dict$get, key, model.dE);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var vehicle = _v0.a;
			var nv = _Utils_update(
				vehicle,
				{b$: activated});
			var newView = function () {
				var _v1 = model.dF;
				if (_v1.$ === 2) {
					var currentVehicle = _v1.a;
					return $author$project$Model$Views$ViewDetails(nv.cH);
				} else {
					return model.dF;
				}
			}();
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dE: A3($elm$core$Dict$insert, key, nv, model.dE)
					}),
				$author$project$Update$Utils$goTo(newView));
		}
	});
var $author$project$Update$Vehicle$updateCrew = F3(
	function (model, key, strCurrent) {
		var _v0 = A2($elm$core$Dict$get, key, model.dE);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var vehicle = _v0.a;
			var current = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(strCurrent));
			var nv = _Utils_update(
				vehicle,
				{cc: current});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dE: A3($elm$core$Dict$insert, key, nv, model.dE)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Update$Vehicle$updateEquipment = F3(
	function (model, key, strCurrent) {
		var _v0 = A2($elm$core$Dict$get, key, model.dE);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var vehicle = _v0.a;
			var current = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(strCurrent));
			var nv = _Utils_update(
				vehicle,
				{ci: current});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dE: A3($elm$core$Dict$insert, key, nv, model.dE)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Update$Vehicle$updateGear = F3(
	function (model, key, newGear) {
		var _v0 = A2($elm$core$Dict$get, key, model.dE);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var vehicle = _v0.a;
			var nv = _Utils_update(
				vehicle,
				{
					ct: A2($author$project$Model$Vehicle$GearTracker, newGear, vehicle.ct.bo)
				});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dE: A3($elm$core$Dict$insert, key, nv, model.dE)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Update$Vehicle$updateHazards = F3(
	function (model, key, newHazards) {
		var _v0 = A2($elm$core$Dict$get, key, model.dE);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var vehicle = _v0.a;
			var nv = _Utils_update(
				vehicle,
				{cx: newHazards});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dE: A3($elm$core$Dict$insert, key, nv, model.dE)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Update$Vehicle$updateHull = F3(
	function (model, key, currentHull) {
		var _v0 = A2($elm$core$Dict$get, key, model.dE);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var vehicle = _v0.a;
			var nhull = vehicle.cB;
			var nv = _Utils_update(
				vehicle,
				{
					cB: _Utils_update(
						nhull,
						{a2: currentHull})
				});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dE: A3($elm$core$Dict$insert, key, nv, model.dE)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Update$Vehicle$updateNotes = F3(
	function (model, key, notes) {
		var _v0 = A2($elm$core$Dict$get, key, model.dE);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var vehicle = _v0.a;
			var newVehicle = _Utils_update(
				vehicle,
				{cU: notes});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dE: A3($elm$core$Dict$insert, key, newVehicle, model.dE)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Update$Vehicle$update = F2(
	function (model, event) {
		switch (event.$) {
			case 0:
				var vehicle = event.a;
				return A2($author$project$Update$Vehicle$addVehicle, model, vehicle);
			case 1:
				var key = event.a;
				return A2($author$project$Update$Vehicle$deleteVehicle, model, key);
			case 5:
				var weaponFunc = function (w) {
					return _Utils_update(
						w,
						{b3: 0, dm: 0});
				};
				var vehicleFunc = F2(
					function (k, v) {
						return _Utils_update(
							v,
							{
								dG: A2($elm$core$List$map, weaponFunc, v.dG)
							});
					});
				var vs = A2(
					$elm$core$Dict$map,
					F2(
						function (k, v) {
							return _Utils_update(
								v,
								{b$: false});
						}),
					A2($elm$core$Dict$map, vehicleFunc, model.dE));
				var gearPhase = function () {
					var _v1 = A2($elm$core$Basics$compare, model.cu, 6);
					if (!_v1) {
						return model.cu + 1;
					} else {
						return 1;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cu: gearPhase, dE: vs}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var name = event.a;
				var _v2 = model.dy;
				if (!_v2.$) {
					var v = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dy: $elm$core$Maybe$Just(
									_Utils_update(
										v,
										{cK: name}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 3:
				var indexString = event.a;
				if (indexString === '-1') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dy: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				} else {
					return A2(
						$author$project$Update$Vehicle$setTmpVehicleType,
						model,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(indexString)));
				}
			case 4:
				var notes = event.a;
				var _v4 = model.dy;
				if (!_v4.$) {
					var v = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dy: $elm$core$Maybe$Just(
									_Utils_update(
										v,
										{cU: notes}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 6:
				var key = event.a;
				var activated = event.b;
				return A3($author$project$Update$Vehicle$updateActivated, model, key, activated);
			case 7:
				var key = event.a;
				var strCurrent = event.b;
				return A3(
					$author$project$Update$Vehicle$updateGear,
					model,
					key,
					A2(
						$elm$core$Maybe$withDefault,
						1,
						$elm$core$String$toInt(strCurrent)));
			case 8:
				var key = event.a;
				var mod = event.b;
				var min = event.c;
				var max = event.d;
				var _v5 = A2($elm$core$Dict$get, key, model.dE);
				if (_v5.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var vehicle = _v5.a;
					return A3(
						$author$project$Update$Vehicle$updateGear,
						model,
						key,
						A3($elm$core$Basics$clamp, min, max, vehicle.ct.a2 + mod));
				}
			case 9:
				var v = event.a;
				var strCurrent = event.b;
				return A3(
					$author$project$Update$Vehicle$updateHazards,
					model,
					v,
					A2(
						$elm$core$Maybe$withDefault,
						1,
						$elm$core$String$toInt(strCurrent)));
			case 10:
				var key = event.a;
				var mod = event.b;
				var min = event.c;
				var max = event.d;
				var _v6 = A2($elm$core$Dict$get, key, model.dE);
				if (_v6.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var vehicle = _v6.a;
					return A3(
						$author$project$Update$Vehicle$updateHazards,
						model,
						key,
						A3($elm$core$Basics$clamp, min, max, vehicle.cx + mod));
				}
			case 11:
				var v = event.a;
				var strCurrent = event.b;
				return A3(
					$author$project$Update$Vehicle$updateHull,
					model,
					v,
					A2(
						$elm$core$Maybe$withDefault,
						1,
						$elm$core$String$toInt(strCurrent)));
			case 12:
				var key = event.a;
				var mod = event.b;
				var min = event.c;
				var max = event.d;
				var _v7 = A2($elm$core$Dict$get, key, model.dE);
				if (_v7.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var vehicle = _v7.a;
					return A3(
						$author$project$Update$Vehicle$updateHull,
						model,
						key,
						A3($elm$core$Basics$clamp, min, max, vehicle.cB.a2 + mod));
				}
			case 13:
				var vkey = event.a;
				var strCurrent = event.b;
				return A3($author$project$Update$Vehicle$updateCrew, model, vkey, strCurrent);
			case 14:
				var vkey = event.a;
				var strCurrent = event.b;
				return A3($author$project$Update$Vehicle$updateEquipment, model, vkey, strCurrent);
			case 15:
				var key = event.a;
				var notes = event.b;
				return A3($author$project$Update$Vehicle$updateNotes, model, key, notes);
			case 16:
				var vehicle = event.a;
				var perk = event.b;
				var isSet = event.c;
				return A4($author$project$Update$Vehicle$setPerkInVehicle, model, vehicle, perk, isSet);
			case 17:
				var key = event.a;
				return A2($author$project$Update$Vehicle$getStream, model, key);
			case 18:
				var key = event.a;
				return A2($author$project$Update$Vehicle$takePhoto, model, key);
			case 19:
				var url = event.a;
				var _v8 = model.dF;
				if (_v8.$ === 2) {
					var key = _v8.a;
					return A3($author$project$Update$Vehicle$setUrlForVehicle, model, key, url);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				var vehicle = event.a;
				return A2($author$project$Update$Vehicle$discardPhoto, model, vehicle);
		}
	});
var $author$project$Update$View$update = F2(
	function (model, currentView) {
		var changedView = _Utils_update(
			model,
			{dF: currentView});
		switch (currentView.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						changedView,
						{dx: $elm$core$Maybe$Nothing, dy: $elm$core$Maybe$Nothing, dz: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[$author$project$Update$Utils$doSaveModel, $author$project$Update$Utils$doNavClose])));
			case 2:
				var v = currentView.a;
				return _Utils_Tuple2(
					changedView,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$Photo$destroyStream(''),
								$author$project$Update$Utils$doSaveModel,
								$author$project$Update$Utils$doNavClose
							])));
			case 5:
				var v = currentView.a;
				return _Utils_Tuple2(changedView, $elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					changedView,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$Storage$getStorage(''),
								$author$project$Update$Utils$doNavClose
							])));
			case 3:
				return _Utils_Tuple2(changedView, $author$project$Update$Utils$doNavClose);
			case 4:
				return _Utils_Tuple2(changedView, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(changedView, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Model$WeaponMountPointError = {$: 3};
var $author$project$Update$Weapon$addWeapon = F3(
	function (model, key, w) {
		var _v0 = A2($elm$core$Dict$get, key, model.dE);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var vehicle = _v0.a;
			var weaponList = _Utils_ap(
				vehicle.dG,
				_List_fromArray(
					[w]));
			var nv = _Utils_update(
				vehicle,
				{dG: weaponList});
			var _v1 = w.cJ;
			if (_v1.$ === 1) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cj: _List_fromArray(
								[$author$project$Model$Model$WeaponMountPointError])
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				var mountPoint = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cj: _List_Nil,
							dz: $elm$core$Maybe$Nothing,
							dE: A3($elm$core$Dict$insert, key, nv, model.dE)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Update$Utils$goToTab(
								$author$project$Model$Views$ViewDetails(key)),
								$author$project$Update$Utils$goTo($author$project$Model$Views$ViewDashboard)
							])));
			}
		}
	});
var $author$project$Update$Weapon$deleteWeapon = F3(
	function (model, key, w) {
		var _v0 = A2($elm$core$Dict$get, key, model.dE);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var vehicle = _v0.a;
			var weaponsNew = A2($elm_community$list_extra$List$Extra$remove, w, vehicle.dG);
			var nv = _Utils_update(
				vehicle,
				{dG: weaponsNew});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dE: A3($elm$core$Dict$insert, key, nv, model.dE)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Weapon$defaultWeapon = $author$project$Model$Weapon$Weapon('')($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)(0)($author$project$Model$Weapon$Medium)(0)(_List_Nil)(0)(0)($elm$core$Maybe$Nothing)(0);
var $author$project$Model$Weapon$Data$arcLightningProjector = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 6, 6)),
		cb: 6,
		cK: 'Arc Lightning Projector',
		c8: $author$project$Model$Weapon$Double,
		da: $author$project$Model$Sponsors$stringToSponsor('Mishkin'),
		di: 2,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$Ammo(
				_List_fromArray(
					[false])),
				$author$project$Model$Shared$Electrical,
				$author$project$Model$Shared$SpecialRule('The Arc Lightning Projector is a dangerous electrical weapon that can arc electricity across multiple conductive targets. After damaging a target, this vehicle must immediately attack another target within Short range and a 360-degree Arc of Fire of the current target (including this vehicle). This chain-reaction continues until the weapon fails to damage a target, or there are nor further viable targets. This vehicle can target friendly vehicles with the Arc Lightning Projector. This vehicle cannot target the same vehicle twice in a single attack step with the Arc Lightning Projetor.')
			])
	});
var $author$project$Model$Weapon$Data$bazooka = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 3, 6)),
		cb: 4,
		cK: 'Bazooka',
		c8: $author$project$Model$Weapon$Double,
		di: 2,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$Ammo(
				_List_fromArray(
					[false, false, false])),
				$author$project$Model$Shared$Blast
			])
	});
var $author$project$Model$Weapon$Data$bfg = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 10, 6)),
		cb: 1,
		cK: 'BFG',
		c8: $author$project$Model$Weapon$Double,
		di: 3,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$Ammo(
				_List_fromArray(
					[false])),
				$author$project$Model$Shared$SpecialRule('When this weapon is fired, the vehicle makes an immediately forced move medium straight backwards, is reduced to Gear 1, and receives 3 Hazard Tokens. Front mounted only (Ed: Another Battlehammer special).')
			])
	});
var $author$project$Model$Shared$Splash = {$: 14};
var $author$project$Model$Weapon$Data$blunderbuss = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		cb: 2,
		cJ: $elm$core$Maybe$Just(5),
		cK: 'Blunderbuss',
		c8: $author$project$Model$Weapon$BurstRange(0),
		dj: _List_fromArray(
			[$author$project$Model$Shared$Splash])
	});
var $author$project$Model$Shared$BurstSpecial = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Weapon$Dropped = {$: 8};
var $author$project$Model$Weapon$Data$caltropDropper = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 2, 6)),
		cb: 1,
		cK: 'Caltrop Dropper',
		c8: $author$project$Model$Weapon$Dropped,
		di: 1,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(3),
				$author$project$Model$Shared$BurstSpecial(0),
				$author$project$Model$Shared$SpecialRule('If any part of a vehicle\'s maneuver template or final position overlaps the caltrops burst template, that vehicle immediately loses 2 hull points and then that caltrops template is removed.')
			])
	});
var $author$project$Model$Weapon$Data$combatLaser = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 3, 6)),
		cb: 5,
		cK: 'Combat Laser',
		c8: $author$project$Model$Weapon$Double,
		di: 1,
		dj: _List_fromArray(
			[$author$project$Model$Shared$Splash])
	});
var $author$project$Model$Weapon$Data$deathRay = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 3, 6)),
		cb: 3,
		cK: 'Death Ray',
		c8: $author$project$Model$Weapon$Double,
		da: $author$project$Model$Sponsors$stringToSponsor('Mishkin'),
		di: 1,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(1),
				$author$project$Model$Shared$Electrical,
				$author$project$Model$Shared$SpecialRule('If this weapon scores five or more un-cancelled hits on the target, instead of causing damage, the target car is immediately removed from play (although it counts as having been Wrecked for the purposes of Audience Votes, scenario rules, etc.).')
			])
	});
var $author$project$Model$Shared$Indirect = {$: 13};
var $author$project$Model$Weapon$Data$flamethrower = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 6, 6)),
		cb: 4,
		cK: 'Flamethrower',
		c8: $author$project$Model$Weapon$TemplateLarge,
		di: 2,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(3),
				$author$project$Model$Shared$Splash,
				$author$project$Model$Shared$Fire,
				$author$project$Model$Shared$Indirect
			])
	});
var $author$project$Model$Weapon$Data$gasGrenades = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 1, 6)),
		cb: 1,
		cJ: $elm$core$Maybe$Just(5),
		cK: 'Gas Grenades',
		c8: $author$project$Model$Weapon$Medium,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(5),
				$author$project$Model$Shared$Indirect,
				$author$project$Model$Shared$Blitz,
				$author$project$Model$Shared$SpecialRule('If this weapons scores one or more un-cancelled hitson the target, instead of causing damage, reduce the target\'s Crew Value by 1 for each un-cancelled hit, to a minimum of 0, until the end of the Gear Phase.')
			])
	});
var $author$project$Model$Weapon$Data$glueDropper = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		cb: 1,
		cK: 'Glue Dropper',
		c8: $author$project$Model$Weapon$Dropped,
		di: 1,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(1),
				$author$project$Model$Shared$BurstSpecial(1),
				$author$project$Model$Shared$SpecialRule('Any vehicle that either starts its activation touching the template, or whose maneuver template or final position overlaps the dropped weapon template during its activation, reduces its current gear by 2 at the end of their activation.')
			])
	});
var $author$project$Model$Weapon$Data$grabberArm = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 3, 6)),
		cb: 6,
		cK: 'Grabber Arm',
		c8: $author$project$Model$Weapon$Short,
		di: 1,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$SpecialRule('If this vehicle attacks a target vehicle of the same weight class or lighter with the Grabber Arm and scors one or more un-cancelled hits, the controller of the active vehicle may place the target vehicle anywhere within Short range of the target vehicle\'s original position. The target vehicle may be pivoted to face any direction. This movement causes a Collision Window.')
			])
	});
var $author$project$Model$Weapon$Data$gravGun = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 6, 6)),
		cb: 2,
		cK: 'Grav Gun',
		c8: $author$project$Model$Weapon$Double,
		da: $author$project$Model$Sponsors$stringToSponsor('Mishkin'),
		di: 1,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(1),
				$author$project$Model$Shared$Electrical,
				$author$project$Model$Shared$SpecialRule('If this weapon scores one or more un-cancelled hits on the target, instead of causing damage the attacking vehicle\'s controller must choose one of the following: until the end of the target\'s next activation the target counts as one weight class heavier or until the end of the target\'s next activation the target counts as one weight class lighter.')
			])
	});
var $author$project$Model$Weapon$Data$grenades = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 1, 6)),
		cb: 1,
		cJ: $elm$core$Maybe$Just(5),
		cK: 'Grenades',
		c8: $author$project$Model$Weapon$Medium,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(5),
				$author$project$Model$Shared$Blast,
				$author$project$Model$Shared$Indirect,
				$author$project$Model$Shared$Blitz
			])
	});
var $author$project$Model$Weapon$Data$handgun = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 1, 6)),
		cJ: $elm$core$Maybe$Just(5),
		cK: 'Handgun',
		c8: $author$project$Model$Weapon$Medium
	});
var $author$project$Model$Weapon$Data$harpoon = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 5, 6)),
		cb: 2,
		cK: 'Harpoon',
		c8: $author$project$Model$Weapon$Double,
		di: 1,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$SpecialRule('This weapon\'s hits do not cause damage. Instead, the first un-cancelled hit on the target spins the target vehicle on the spot to either face directly away from or directly towards the attacking vehicle, whichever requires the smalled degree of rotation, as the harpoon catches and the chain goes taut. This triggers a Collision Window.'),
				$author$project$Model$Shared$SpecialRule('The second and subsequent un-cancelled hits on the target then each cause the target to make a forced Short Straight move towards the attacker, as the harpoon reels the target in.'),
				$author$project$Model$Shared$SpecialRule('If the target is a heavier weight class than the attacker, it is the attacking vehicle that is spun and moved towards the target vehicle instead.')
			])
	});
var $author$project$Model$Weapon$Data$heavyMachineGun = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 3, 6)),
		cb: 3,
		cK: 'Heavy Machine Gun',
		c8: $author$project$Model$Weapon$Double,
		di: 1
	});
var $author$project$Model$Weapon$Data$kineticSuperBooster = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 1, 6)),
		cb: 6,
		cK: 'Kinetic Super Booster',
		c8: $author$project$Model$Weapon$Double,
		da: $author$project$Model$Sponsors$stringToSponsor('Mishkin'),
		di: 2,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(1),
				$author$project$Model$Shared$Electrical,
				$author$project$Model$Shared$SpecialRule('The Kinetic Super Booster is a bizarre electrical weapon that transfers a jolt of kinetic energy to the target. The target of a Super Booster attack suffers no damage, but instread immediately increases its current Gear by one for every successful hit, without gaining hazard tokens. The Super Booster may not increase a vehicle\'s current Gear beyond its max Gear.')
			])
	});
var $author$project$Model$Weapon$Data$machineGun = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 2, 6)),
		cb: 2,
		cK: 'Machine Gun',
		c8: $author$project$Model$Weapon$Double,
		di: 1
	});
var $author$project$Model$Weapon$Data$magneticJammer = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		cb: 2,
		cK: 'Magnetic Jammer',
		c8: $author$project$Model$Weapon$Double,
		da: $author$project$Model$Sponsors$stringToSponsor('Mishkin'),
		di: 0,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$Electrical,
				$author$project$Model$Shared$SpecialRule('The target vehicle may not discard ammo tokens during its next activation.')
			])
	});
var $author$project$Model$Weapon$Data$magnum = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 1, 6)),
		cb: 3,
		cJ: $elm$core$Maybe$Just(5),
		cK: 'Magnum',
		c8: $author$project$Model$Weapon$Double,
		dj: _List_fromArray(
			[$author$project$Model$Shared$Blast])
	});
var $author$project$Model$Weapon$Data$mineDropper = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 1, 6)),
		cb: 1,
		cK: 'Mine Dropper',
		c8: $author$project$Model$Weapon$Dropped,
		di: 1,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(1),
				$author$project$Model$Shared$BurstSpecial(0),
				$author$project$Model$Shared$Blast,
				$author$project$Model$Shared$SpecialRule('The first vehicle affected by this weapon is attacked with a 4D6 attack with Blast, then remove the Mine\'s template from play.')
			])
	});
var $author$project$Model$Weapon$Data$miniGun = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 4, 6)),
		cb: 5,
		cK: 'Mini-Gun',
		c8: $author$project$Model$Weapon$Double,
		di: 1
	});
var $author$project$Model$Weapon$Data$molotovCocktails = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 1, 6)),
		cb: 1,
		cJ: $elm$core$Maybe$Just(5),
		cK: 'Molotov Cocktails',
		c8: $author$project$Model$Weapon$Medium,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(5),
				$author$project$Model$Shared$Fire,
				$author$project$Model$Shared$Indirect,
				$author$project$Model$Shared$Blitz
			])
	});
var $author$project$Model$Weapon$Data$mortar = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 4, 6)),
		cb: 4,
		cK: 'Mortar',
		c8: $author$project$Model$Weapon$Double,
		di: 1,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(3),
				$author$project$Model$Shared$Indirect,
				$author$project$Model$Shared$SpecialRule('When making a shooting attack with the Mortar, the vehicle may ignore terrain and cover during the attack.')
			])
	});
var $author$project$Model$Weapon$Data$napalmDropper = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 4, 6)),
		cb: 1,
		cK: 'Napalm Dropper',
		c8: $author$project$Model$Weapon$Dropped,
		di: 1,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(3),
				$author$project$Model$Shared$BurstSpecial(0),
				$author$project$Model$Shared$Fire,
				$author$project$Model$Shared$SpecialRule('The first vehicle affected by this weapon is attacked with a 4D6 attack with Fire, then remove the Napalm template from play.')
			])
	});
var $author$project$Model$Weapon$Data$oilSlickDropper = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		cb: 2,
		cK: 'Oil Slick Dropper',
		c8: $author$project$Model$Weapon$Dropped,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(3),
				$author$project$Model$Shared$BurstSpecial(1),
				$author$project$Model$Shared$SpecialRule('The dropped weapon template for the Oil Slick Dropper counts as a treacherous surface, (see Terrain, page 86).')
			])
	});
var $author$project$Model$Weapon$Data$oneTwentyFiveMMCannon = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 8, 6)),
		cb: 6,
		cK: '125mm Cannon',
		c8: $author$project$Model$Weapon$Double,
		di: 3,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$Ammo(
				_List_fromArray(
					[false, false, false])),
				$author$project$Model$Shared$Blast,
				$author$project$Model$Shared$SpecialRule('A tank gun is a ridiculous weapon for a civilian vehicle to carry. When fired, the active vehicle immediately gains 2 Hazard Tokens if it is not a Tank.')
			])
	});
var $author$project$Model$Weapon$Data$rcCarBombs = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 4, 6)),
		cb: 3,
		cK: 'RC Car Bombs',
		c8: $author$project$Model$Weapon$Dropped,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(3),
				$author$project$Model$Shared$BurstSpecial(1),
				$author$project$Model$Shared$SpecialRule('Bombs are taped to remote-controlled cars, which are dropped from a vehicle and then piloted to impact.'),
				$author$project$Model$Shared$SpecialRule('When attack with this dropped weapon, place a RC Car (use a tiny car miniature, no larger than 20mm square) so that it is within Short range of the attacking vehicle, and facing in any direction. This placement triggers a Collision Window.'),
				$author$project$Model$Shared$SpecialRule('The RC Car counts as a lightweight vehicle in current Gear 3 with 1 Hull Point, 1 Crew, and 0 Handling. This tiny car can make shooting attacks but cannot change Gear. Although controlled by the player that dropped it, the RC Car does not count as part of the player\'s team, and so cannot be used for the purposes of scenario rules, Audience Votes, or perks.'),
				$author$project$Model$Shared$SpecialRule('The RC Car is involved in a Collision, it suffers one damage before the Collision is resolved. When the RC Car would be Wrecked it instead explodes. When the RC Car explodes, it rolls 4D6 attack dice, as if it were a middleweight vehicle.'),
				$author$project$Model$Shared$SpecialRule('If the RC Car wipes out, it suffers one damage before the Wipeout is resolved.')
			])
	});
var $author$project$Model$Weapon$Data$rockets = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 6, 6)),
		cb: 5,
		cK: 'Rockets',
		c8: $author$project$Model$Weapon$Double,
		di: 2,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(3)
			])
	});
var $author$project$Model$Weapon$Data$sentryGun = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		cb: 3,
		cK: 'Sentry Gun',
		c8: $author$project$Model$Weapon$Dropped,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(2),
				$author$project$Model$Shared$BurstSpecial(1),
				$author$project$Model$Shared$SpecialRule('When attacking with this dropped weapon, place a Sentry Gun so that it is within Short range of the attacking vehicle.'),
				$author$project$Model$Shared$SpecialRule('The Sentry Gun remains in play as a lightweight destructible obstacle. They may be targeted with shooting attacks and have 2 Hull Points.'),
				$author$project$Model$Shared$SpecialRule('This Sentry Gun automatically makes a 2D6 shooting attack against any vehicle that ends their Movement Step within Medium range of the Sentry Gun in a 360-degree Arc of Fire. The target may Evade as normal. This Sentry Gun will never target vehicles from the team of the vehicle that dropped it.'),
				$author$project$Model$Shared$SpecialRule('Although controlled by the player that dropped it, the Sentry Gun does not count as part of the player\'s team, and so cannot be used for the purposes of scenario rules, Audience Votes, or perks.')
			])
	});
var $author$project$Model$Weapon$Long = {$: 2};
var $author$project$Model$Weapon$Data$shotgun = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Nothing,
		cb: 4,
		cJ: $elm$core$Maybe$Just(5),
		cK: 'Shotgun',
		c8: $author$project$Model$Weapon$Long,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$SpecialRule('When attacking with this weapon, roll 3D6 attack dice if the target is within Short range, 2D6 attack dice if the target is within Medium range, and 1D6 attack dice if the target is within Long range.')
			])
	});
var $author$project$Model$Weapon$Data$smokeDropper = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		cb: 1,
		cK: 'Smoke Dropper',
		c8: $author$project$Model$Weapon$Dropped,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(3),
				$author$project$Model$Shared$BurstSpecial(1),
				$author$project$Model$Shared$SpecialRule('This dropped weapon template counts as an obstruction for the purposes of determining Cover.'),
				$author$project$Model$Shared$SpecialRule('Whilst a vehicle is in contact with this dropped weapon template, that vehicle counts as distracted.'),
				$author$project$Model$Shared$SpecialRule('If any part of a vehicle\'s movement template or Final Position touches this dropped weapon template, the vehicle gains 1 Hazard Token at the end of its Movement Step.')
			])
	});
var $author$project$Model$Weapon$Data$steelNets = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 3, 6)),
		cb: 2,
		cJ: $elm$core$Maybe$Just(5),
		cK: 'Steel Nets',
		c8: $author$project$Model$Weapon$Medium,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$Blast,
				$author$project$Model$Shared$SpecialRule('This weapon\'s hits do not cause damage. Hits will add Hazard Tokens as a result of the Blast special rule as normal.')
			])
	});
var $author$project$Model$Weapon$Data$submachineGuns = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		b2: $elm$core$Maybe$Just(
			A2($author$project$Model$Weapon$Dice, 3, 6)),
		cb: 5,
		cJ: $elm$core$Maybe$Just(5),
		cK: 'Submachine Guns',
		c8: $author$project$Model$Weapon$Medium
	});
var $author$project$Model$Shared$FullFireArc = {$: 15};
var $author$project$Model$Weapon$Data$thumper = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		cb: 4,
		cK: 'Thumper',
		c8: $author$project$Model$Weapon$Medium,
		da: $author$project$Model$Sponsors$stringToSponsor('Mishkin'),
		di: 3,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(1),
				$author$project$Model$Shared$Electrical,
				$author$project$Model$Shared$Indirect,
				$author$project$Model$Shared$FullFireArc,
				$author$project$Model$Shared$SpecialRule('This weapon does not need to declare a facing when purchased.'),
				$author$project$Model$Shared$SpecialRule('The Thumper is a powerful sonic device that emits a shock wave that hurls nearby vehicles into the air. When this vehicle declares an attack with the Thumper, every other vehicle (friend or foe) within Medium range of this vehicle in a 360-degree Arc of Fire immeditaly makes a Flip check, in which they count their current Gear as 2 higher, up to a maximum of 6.')
			])
	});
var $author$project$Model$Weapon$Data$wallOfAmplifiers = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		cb: 4,
		cK: 'Wall of Amplifiers',
		c8: $author$project$Model$Weapon$Medium,
		di: 4,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$FullFireArc,
				$author$project$Model$Shared$SpecialRule('This weapon does not require a target. When fired, this weapon automatically cuases on hit to every vehicle within Medium range and within a 36-degree Arc of Fire. These hits do not cause damage and may be Evaded. For each un-cancelled hit on a vehicle, choose one: either discard 1 Hazard Token from the vehicle or add 1 Hazard Token to the vehicle.')
			])
	});
var $author$project$Model$Weapon$SpecialRange = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$Weapon$Data$wreckLobber = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		cb: 4,
		cK: 'Wreck Lobber',
		c8: $author$project$Model$Weapon$SpecialRange('Double/Dropped'),
		di: 4,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$ammoInit(3),
				$author$project$Model$Shared$SpecialRule('It was inevitable that someone would invent a gun that shoots cars instead of bullets.'),
				A2($author$project$Model$Shared$NamedSpecialRule, 'Trebuchet', 'The Wreck Lobber does not require a target. When it is fired, place a marker the size of a penny within Double range of the Wreck Lobber\'s fire arc. Roll a Skid Die.'),
				$author$project$Model$Shared$SpecialRule('On a Shift result: place the wreck of a Car touching the marker and trigger a Collision Window.'),
				$author$project$Model$Shared$SpecialRule('On a Spin or Slide result: the player to the left of the active player must place a wreck anywhere within Short range of the marker and trigger a Collision Window.'),
				$author$project$Model$Shared$SpecialRule('On a Hazard Result: the player to the left of the active player must place the wreck touching the active vehicle and trigger a Collision Window.'),
				A2($author$project$Model$Shared$NamedSpecialRule, 'Low-Loader', 'If this vehicle collides with a wreck, it may gain 1 Ammo Token for the Wreck Lobber.'),
				A2($author$project$Model$Shared$NamedSpecialRule, 'Dumper', 'This vehicle may fire the Wreck Lobber as a rear-mounted dropped weapon instead of using the Trebuchet rules above. In this case, the wreck of a car is placed touching the rear of the active vehicle, and no Collision Window is triggered.')
			])
	});
var $author$project$Model$Weapon$Data$wreckingBall = _Utils_update(
	$author$project$Model$Weapon$defaultWeapon,
	{
		cb: 4,
		cK: 'Wrecking Ball',
		c8: $author$project$Model$Weapon$SpecialRange('Collision'),
		di: 1,
		dj: _List_fromArray(
			[
				$author$project$Model$Shared$SpecialRule('This weapon does not require a target. When fired, this vehicle must immediately engage in a T-Bone Collision with every vehicle and Destructible obstacle within Short range of it, in a 360-degree Arc of Fire, in any order chosedn by this vehicle\'s controller.'),
				$author$project$Model$Shared$SpecialRule('During these Collisions, all vehicles involved count as having no weapons or perks except this one and all other vehicles must declare an Evade reaction. During each of these Collisions this vehicle gains 2 Smash Attack dice. this vehicle does not gain Hazard Tokens during these Collisions. Collisions triggered by the Wrecking Ball do not benefit from effects from upgrades, such as Rams or Exploding Rams.')
			])
	});
var $author$project$Model$Weapon$Data$weapons = _List_fromArray(
	[$author$project$Model$Weapon$Data$handgun, $author$project$Model$Weapon$Data$machineGun, $author$project$Model$Weapon$Data$heavyMachineGun, $author$project$Model$Weapon$Data$miniGun, $author$project$Model$Weapon$Data$arcLightningProjector, $author$project$Model$Weapon$Data$bazooka, $author$project$Model$Weapon$Data$bfg, $author$project$Model$Weapon$Data$combatLaser, $author$project$Model$Weapon$Data$deathRay, $author$project$Model$Weapon$Data$flamethrower, $author$project$Model$Weapon$Data$grabberArm, $author$project$Model$Weapon$Data$gravGun, $author$project$Model$Weapon$Data$harpoon, $author$project$Model$Weapon$Data$kineticSuperBooster, $author$project$Model$Weapon$Data$magneticJammer, $author$project$Model$Weapon$Data$mortar, $author$project$Model$Weapon$Data$oneTwentyFiveMMCannon, $author$project$Model$Weapon$Data$rockets, $author$project$Model$Weapon$Data$thumper, $author$project$Model$Weapon$Data$wallOfAmplifiers, $author$project$Model$Weapon$Data$wreckLobber, $author$project$Model$Weapon$Data$wreckingBall, $author$project$Model$Weapon$Data$blunderbuss, $author$project$Model$Weapon$Data$gasGrenades, $author$project$Model$Weapon$Data$grenades, $author$project$Model$Weapon$Data$magnum, $author$project$Model$Weapon$Data$molotovCocktails, $author$project$Model$Weapon$Data$shotgun, $author$project$Model$Weapon$Data$steelNets, $author$project$Model$Weapon$Data$submachineGuns, $author$project$Model$Weapon$Data$caltropDropper, $author$project$Model$Weapon$Data$glueDropper, $author$project$Model$Weapon$Data$mineDropper, $author$project$Model$Weapon$Data$napalmDropper, $author$project$Model$Weapon$Data$oilSlickDropper, $author$project$Model$Weapon$Data$rcCarBombs, $author$project$Model$Weapon$Data$sentryGun, $author$project$Model$Weapon$Data$smokeDropper]);
var $author$project$Model$Weapon$Common$allWeaponsList = $author$project$Model$Weapon$Data$weapons;
var $author$project$Model$Weapon$Common$nameToWeapon = function (s) {
	return A2(
		$elm$core$Dict$get,
		s,
		$elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (w) {
					return _Utils_Tuple2(w.cK, w);
				},
				$author$project$Model$Weapon$Common$allWeaponsList)));
};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm_community$list_extra$List$Extra$updateIf = F3(
	function (predicate, update, list) {
		return A2(
			$elm$core$List$map,
			function (item) {
				return predicate(item) ? update(item) : item;
			},
			list);
	});
var $elm_community$list_extra$List$Extra$setIf = F3(
	function (predicate, replacement, list) {
		return A3(
			$elm_community$list_extra$List$Extra$updateIf,
			predicate,
			$elm$core$Basics$always(replacement),
			list);
	});
var $author$project$Update$Weapon$rollWeaponDie = F4(
	function (model, key, w, result) {
		var _v0 = A2($elm$core$Dict$get, key, model.dE);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var vehicle = _v0.a;
			var weaponUpdated = _Utils_update(
				w,
				{b3: result});
			var newWeapons = A3(
				$elm_community$list_extra$List$Extra$setIf,
				function (wil) {
					return _Utils_eq(w, wil);
				},
				weaponUpdated,
				vehicle.dG);
			var nv = _Utils_update(
				vehicle,
				{dG: newWeapons});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dE: A3($elm$core$Dict$insert, key, nv, model.dE)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Weapon$RollWeaponDie = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Model$Weapon$WeaponFired = 1;
var $author$project$Model$Model$WeaponMsg = function (a) {
	return {$: 4, a: a};
};
var $elm$random$Random$Generate = $elm$core$Basics$identity;
var $elm$random$Random$Seed = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$random$Random$next = function (_v0) {
	var state0 = _v0.a;
	var incr = _v0.b;
	return A2($elm$random$Random$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
};
var $elm$random$Random$initialSeed = function (x) {
	var _v0 = $elm$random$Random$next(
		A2($elm$random$Random$Seed, 0, 1013904223));
	var state1 = _v0.a;
	var incr = _v0.b;
	var state2 = (state1 + x) >>> 0;
	return $elm$random$Random$next(
		A2($elm$random$Random$Seed, state2, incr));
};
var $elm$random$Random$init = A2(
	$elm$core$Task$andThen,
	function (time) {
		return $elm$core$Task$succeed(
			$elm$random$Random$initialSeed(
				$elm$time$Time$posixToMillis(time)));
	},
	$elm$time$Time$now);
var $elm$random$Random$step = F2(
	function (_v0, seed) {
		var generator = _v0;
		return generator(seed);
	});
var $elm$random$Random$onEffects = F3(
	function (router, commands, seed) {
		if (!commands.b) {
			return $elm$core$Task$succeed(seed);
		} else {
			var generator = commands.a;
			var rest = commands.b;
			var _v1 = A2($elm$random$Random$step, generator, seed);
			var value = _v1.a;
			var newSeed = _v1.b;
			return A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$random$Random$onEffects, router, rest, newSeed);
				},
				A2($elm$core$Platform$sendToApp, router, value));
		}
	});
var $elm$random$Random$onSelfMsg = F3(
	function (_v0, _v1, seed) {
		return $elm$core$Task$succeed(seed);
	});
var $elm$random$Random$Generator = $elm$core$Basics$identity;
var $elm$random$Random$map = F2(
	function (func, _v0) {
		var genA = _v0;
		return function (seed0) {
			var _v1 = genA(seed0);
			var a = _v1.a;
			var seed1 = _v1.b;
			return _Utils_Tuple2(
				func(a),
				seed1);
		};
	});
var $elm$random$Random$cmdMap = F2(
	function (func, _v0) {
		var generator = _v0;
		return A2($elm$random$Random$map, func, generator);
	});
_Platform_effectManagers['Random'] = _Platform_createManager($elm$random$Random$init, $elm$random$Random$onEffects, $elm$random$Random$onSelfMsg, $elm$random$Random$cmdMap);
var $elm$random$Random$command = _Platform_leaf('Random');
var $elm$random$Random$generate = F2(
	function (tagger, generator) {
		return $elm$random$Random$command(
			A2($elm$random$Random$map, tagger, generator));
	});
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $elm$random$Random$peel = function (_v0) {
	var state = _v0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var $elm$random$Random$int = F2(
	function (a, b) {
		return function (seed0) {
			var _v0 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
			var lo = _v0.a;
			var hi = _v0.b;
			var range = (hi - lo) + 1;
			if (!((range - 1) & range)) {
				return _Utils_Tuple2(
					(((range - 1) & $elm$random$Random$peel(seed0)) >>> 0) + lo,
					$elm$random$Random$next(seed0));
			} else {
				var threshhold = (((-range) >>> 0) % range) >>> 0;
				var accountForBias = function (seed) {
					accountForBias:
					while (true) {
						var x = $elm$random$Random$peel(seed);
						var seedN = $elm$random$Random$next(seed);
						if (_Utils_cmp(x, threshhold) < 0) {
							var $temp$seed = seedN;
							seed = $temp$seed;
							continue accountForBias;
						} else {
							return _Utils_Tuple2((x % range) + lo, seedN);
						}
					}
				};
				return accountForBias(seed0);
			}
		};
	});
var $author$project$Update$Weapon$setWeaponFired = F3(
	function (model, key, w) {
		var _v0 = A2($elm$core$Dict$get, key, model.dE);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var vehicle = _v0.a;
			var weaponUpdated = _Utils_update(
				w,
				{dm: 1});
			var weaponsNew = A3(
				$elm_community$list_extra$List$Extra$setIf,
				function (wil) {
					return _Utils_eq(w, wil);
				},
				weaponUpdated,
				vehicle.dG);
			var nv = _Utils_update(
				vehicle,
				{dG: weaponsNew});
			var minRoll = function () {
				var _v2 = weaponUpdated.b2;
				if (!_v2.$) {
					var dice = _v2.a;
					return dice.cV;
				} else {
					return 0;
				}
			}();
			var maxRoll = function () {
				var _v1 = weaponUpdated.b2;
				if (!_v1.$) {
					var dice = _v1.a;
					return dice.cV * dice.ce;
				} else {
					return 0;
				}
			}();
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dE: A3($elm$core$Dict$insert, key, nv, model.dE)
					}),
				A2(
					$elm$random$Random$generate,
					A2(
						$elm$core$Basics$composeL,
						$author$project$Model$Model$WeaponMsg,
						A2($author$project$Model$Weapon$RollWeaponDie, key, weaponUpdated)),
					A2($elm$random$Random$int, minRoll, maxRoll)));
		}
	});
var $author$project$Model$Weapon$Common$strToMountPoint = function (point) {
	switch (point) {
		case '360° mounted':
			return $elm$core$Maybe$Just(0);
		case 'Front mounted':
			return $elm$core$Maybe$Just(1);
		case 'Left mounted':
			return $elm$core$Maybe$Just(2);
		case 'Right mounted':
			return $elm$core$Maybe$Just(3);
		case 'Rear mounted':
			return $elm$core$Maybe$Just(4);
		case 'Crew fired':
			return $elm$core$Maybe$Just(5);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $author$project$Model$Shared$getAmmoClip = function (specials) {
	var ammoFinder = function (special) {
		if (!special.$) {
			return true;
		} else {
			return false;
		}
	};
	var mAmmoSpecial = A2($elm_community$list_extra$List$Extra$find, ammoFinder, specials);
	var mAmmoSpecialIndex = A2($elm_community$list_extra$List$Extra$findIndex, ammoFinder, specials);
	return _Utils_Tuple2(mAmmoSpecialIndex, mAmmoSpecial);
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm_community$list_extra$List$Extra$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			var head = A2($elm$core$List$take, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					head,
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $elm_community$list_extra$List$Extra$setAt = F2(
	function (index, value) {
		return A2(
			$elm_community$list_extra$List$Extra$updateAt,
			index,
			$elm$core$Basics$always(value));
	});
var $author$project$Update$Weapon$updateAmmoUsed = F5(
	function (model, key, weapon, index, check) {
		var _v0 = $author$project$Model$Shared$getAmmoClip(weapon.dj);
		var mAmmoSpecialIndex = _v0.a;
		var mAmmoSpecial = _v0.b;
		var _v1 = _Utils_Tuple3(
			mAmmoSpecial,
			mAmmoSpecialIndex,
			A2($elm$core$Dict$get, key, model.dE));
		if ((((!_v1.a.$) && (!_v1.a.a.$)) && (!_v1.b.$)) && (!_v1.c.$)) {
			var clip = _v1.a.a.a;
			var ammoIndex = _v1.b.a;
			var vehicle = _v1.c.a;
			var ammoUpdated = $author$project$Model$Shared$Ammo(
				A3($elm_community$list_extra$List$Extra$setAt, index, check, clip));
			var specialsUpdated = A3($elm_community$list_extra$List$Extra$setAt, ammoIndex, ammoUpdated, weapon.dj);
			var weaponUpdated = _Utils_update(
				weapon,
				{dj: specialsUpdated});
			var weaponsNew = A3(
				$elm_community$list_extra$List$Extra$setIf,
				function (wil) {
					return _Utils_eq(weapon, wil);
				},
				weaponUpdated,
				vehicle.dG);
			var nv = _Utils_update(
				vehicle,
				{dG: weaponsNew});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dE: A3($elm$core$Dict$insert, key, nv, model.dE)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Update$Weapon$update = F2(
	function (model, event) {
		switch (event.$) {
			case 0:
				var key = event.a;
				var w = event.b;
				return A3($author$project$Update$Weapon$addWeapon, model, key, w);
			case 1:
				var key = event.a;
				var w = event.b;
				return A3($author$project$Update$Weapon$deleteWeapon, model, key, w);
			case 2:
				var key = event.a;
				var w = event.b;
				var index = event.c;
				var check = event.d;
				return A5($author$project$Update$Weapon$updateAmmoUsed, model, key, w, index, check);
			case 3:
				var name = event.a;
				var w = $author$project$Model$Weapon$Common$nameToWeapon(name);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dz: w}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var mountPointStr = event.a;
				var mountPoint = $author$project$Model$Weapon$Common$strToMountPoint(mountPointStr);
				var w = function () {
					var _v1 = model.dz;
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var tmpWeapon = _v1.a;
						return $elm$core$Maybe$Just(
							_Utils_update(
								tmpWeapon,
								{cJ: mountPoint}));
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dz: w}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 6:
				var v = event.a;
				var w = event.b;
				return A3($author$project$Update$Weapon$setWeaponFired, model, v, w);
			default:
				var v = event.a;
				var w = event.b;
				var result = event.c;
				return A4($author$project$Update$Weapon$rollWeaponDie, model, v, w, result);
		}
	});
var $author$project$Update$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var toggle = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cM: toggle}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var viewEvent = msg.a;
				return A2($author$project$Update$View$update, model, viewEvent);
			case 2:
				var viewEvent = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ds: $elm$core$Maybe$Just(viewEvent)
						}),
					$author$project$Update$Utils$doNavClose);
			case 23:
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c5: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(s))
						}),
					$elm$core$Platform$Cmd$none);
			case 24:
				var s = msg.a;
				if (s === '') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dv: $elm$core$Maybe$Nothing}),
						$author$project$Update$UtilsGeneric$do(
							$author$project$Model$Model$SetLastTeam(s)));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dv: $elm$core$Maybe$Just(s)
							}),
						$elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$map,
								$author$project$Update$UtilsGeneric$do,
								_List_fromArray(
									[
										$author$project$Model$Model$SetLastTeam(s),
										$author$project$Model$Model$SaveModel
									]))));
				}
			case 3:
				var event = msg.a;
				return A2($author$project$Update$Vehicle$update, model, event);
			case 4:
				var event = msg.a;
				return A2($author$project$Update$Weapon$update, model, event);
			case 5:
				var event = msg.a;
				return A2($author$project$Update$Upgrade$update, model, event);
			case 6:
				var sponsorName = msg.a;
				return A2(
					$author$project$Update$Sponsor$set,
					model,
					$author$project$Model$Sponsors$stringToSponsor(sponsorName));
			case 7:
				var data = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dn: data}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var key = msg.a;
				var jsonModel = msg.b;
				return A3($author$project$Update$Data$import_, model, key, jsonModel);
			case 9:
				var json = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cE: json}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var key = msg.a;
				var jsonModel = msg.b;
				return A3($author$project$Update$Data$share, model, key, jsonModel);
			case 11:
				var storageEntry = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cE: storageEntry.N}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var entry = msg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$Storage$getStorage(''),
								A2(
								$elm$core$Task$perform,
								$author$project$Model$Model$SetImport,
								$elm$core$Task$succeed(entry.N))
							])));
			case 13:
				return $author$project$Update$Data$saveModel(model);
			case 14:
				var key = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Ports$Storage$get(key));
			case 15:
				var key = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Ports$Storage$delete(key));
			case 16:
				var deletedKey = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Ports$Storage$getStorage(''));
			case 17:
				return _Utils_Tuple2(
					model,
					$author$project$Ports$Storage$getLastTeam(''));
			case 18:
				var key = msg.a.cH;
				var value = msg.a.N;
				return _Utils_Tuple2(
					model,
					$author$project$Update$UtilsGeneric$do(
						A2($author$project$Model$Model$Import, key, value)));
			case 19:
				var teamName = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Ports$Storage$setLastTeam(model.$7));
			case 20:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 21:
				var posixTime = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							$7: $elm$core$String$fromInt(
								$elm$time$Time$posixToMillis(posixTime))
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var event = msg.a;
				return A2($author$project$Update$Settings$update, model, event);
		}
	});
var $elm$browser$Browser$Document = F2(
	function (title, body) {
		return {b4: body, dw: title};
	});
var $surprisetalk$elm_bulma$Bulma$Layout$NotSpaced = 0;
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $lattyware$elm_fontawesome$FontAwesome$Styles$css = A3(
	$elm$html$Html$node,
	'style',
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('svg:not(:root).svg-inline--fa {  overflow: visible;}.svg-inline--fa {  display: inline-block;  font-size: inherit;  height: 1em;  overflow: visible;  vertical-align: -0.125em;}.svg-inline--fa.fa-lg {  vertical-align: -0.225em;}.svg-inline--fa.fa-w-1 {  width: 0.0625em;}.svg-inline--fa.fa-w-2 {  width: 0.125em;}.svg-inline--fa.fa-w-3 {  width: 0.1875em;}.svg-inline--fa.fa-w-4 {  width: 0.25em;}.svg-inline--fa.fa-w-5 {  width: 0.3125em;}.svg-inline--fa.fa-w-6 {  width: 0.375em;}.svg-inline--fa.fa-w-7 {  width: 0.4375em;}.svg-inline--fa.fa-w-8 {  width: 0.5em;}.svg-inline--fa.fa-w-9 {  width: 0.5625em;}.svg-inline--fa.fa-w-10 {  width: 0.625em;}.svg-inline--fa.fa-w-11 {  width: 0.6875em;}.svg-inline--fa.fa-w-12 {  width: 0.75em;}.svg-inline--fa.fa-w-13 {  width: 0.8125em;}.svg-inline--fa.fa-w-14 {  width: 0.875em;}.svg-inline--fa.fa-w-15 {  width: 0.9375em;}.svg-inline--fa.fa-w-16 {  width: 1em;}.svg-inline--fa.fa-w-17 {  width: 1.0625em;}.svg-inline--fa.fa-w-18 {  width: 1.125em;}.svg-inline--fa.fa-w-19 {  width: 1.1875em;}.svg-inline--fa.fa-w-20 {  width: 1.25em;}.svg-inline--fa.fa-pull-left {  margin-right: 0.3em;  width: auto;}.svg-inline--fa.fa-pull-right {  margin-left: 0.3em;  width: auto;}.svg-inline--fa.fa-border {  height: 1.5em;}.svg-inline--fa.fa-li {  width: 2em;}.svg-inline--fa.fa-fw {  width: 1.25em;}.fa-layers svg.svg-inline--fa {  bottom: 0;  left: 0;  margin: auto;  position: absolute;  right: 0;  top: 0;}.fa-layers {  display: inline-block;  height: 1em;  position: relative;  text-align: center;  vertical-align: -0.125em;  width: 1em;}.fa-layers svg.svg-inline--fa {  -webkit-transform-origin: center center;          transform-origin: center center;}.fa-layers-counter, .fa-layers-text {  display: inline-block;  position: absolute;  text-align: center;}.fa-layers-text {  left: 50%;  top: 50%;  -webkit-transform: translate(-50%, -50%);          transform: translate(-50%, -50%);  -webkit-transform-origin: center center;          transform-origin: center center;}.fa-layers-counter {  background-color: #ff253a;  border-radius: 1em;  -webkit-box-sizing: border-box;          box-sizing: border-box;  color: #fff;  height: 1.5em;  line-height: 1;  max-width: 5em;  min-width: 1.5em;  overflow: hidden;  padding: 0.25em;  right: 0;  text-overflow: ellipsis;  top: 0;  -webkit-transform: scale(0.25);          transform: scale(0.25);  -webkit-transform-origin: top right;          transform-origin: top right;}.fa-layers-bottom-right {  bottom: 0;  right: 0;  top: auto;  -webkit-transform: scale(0.25);          transform: scale(0.25);  -webkit-transform-origin: bottom right;          transform-origin: bottom right;}.fa-layers-bottom-left {  bottom: 0;  left: 0;  right: auto;  top: auto;  -webkit-transform: scale(0.25);          transform: scale(0.25);  -webkit-transform-origin: bottom left;          transform-origin: bottom left;}.fa-layers-top-right {  right: 0;  top: 0;  -webkit-transform: scale(0.25);          transform: scale(0.25);  -webkit-transform-origin: top right;          transform-origin: top right;}.fa-layers-top-left {  left: 0;  right: auto;  top: 0;  -webkit-transform: scale(0.25);          transform: scale(0.25);  -webkit-transform-origin: top left;          transform-origin: top left;}.fa-lg {  font-size: 1.3333333333em;  line-height: 0.75em;  vertical-align: -0.0667em;}.fa-xs {  font-size: 0.75em;}.fa-sm {  font-size: 0.875em;}.fa-1x {  font-size: 1em;}.fa-2x {  font-size: 2em;}.fa-3x {  font-size: 3em;}.fa-4x {  font-size: 4em;}.fa-5x {  font-size: 5em;}.fa-6x {  font-size: 6em;}.fa-7x {  font-size: 7em;}.fa-8x {  font-size: 8em;}.fa-9x {  font-size: 9em;}.fa-10x {  font-size: 10em;}.fa-fw {  text-align: center;  width: 1.25em;}.fa-ul {  list-style-type: none;  margin-left: 2.5em;  padding-left: 0;}.fa-ul > li {  position: relative;}.fa-li {  left: -2em;  position: absolute;  text-align: center;  width: 2em;  line-height: inherit;}.fa-border {  border: solid 0.08em #eee;  border-radius: 0.1em;  padding: 0.2em 0.25em 0.15em;}.fa-pull-left {  float: left;}.fa-pull-right {  float: right;}.fa.fa-pull-left,.fas.fa-pull-left,.far.fa-pull-left,.fal.fa-pull-left,.fab.fa-pull-left {  margin-right: 0.3em;}.fa.fa-pull-right,.fas.fa-pull-right,.far.fa-pull-right,.fal.fa-pull-right,.fab.fa-pull-right {  margin-left: 0.3em;}.fa-spin {  -webkit-animation: fa-spin 2s infinite linear;          animation: fa-spin 2s infinite linear;}.fa-pulse {  -webkit-animation: fa-spin 1s infinite steps(8);          animation: fa-spin 1s infinite steps(8);}@-webkit-keyframes fa-spin {  0% {    -webkit-transform: rotate(0deg);            transform: rotate(0deg);  }  100% {    -webkit-transform: rotate(360deg);            transform: rotate(360deg);  }}@keyframes fa-spin {  0% {    -webkit-transform: rotate(0deg);            transform: rotate(0deg);  }  100% {    -webkit-transform: rotate(360deg);            transform: rotate(360deg);  }}.fa-rotate-90 {  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";  -webkit-transform: rotate(90deg);          transform: rotate(90deg);}.fa-rotate-180 {  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";  -webkit-transform: rotate(180deg);          transform: rotate(180deg);}.fa-rotate-270 {  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";  -webkit-transform: rotate(270deg);          transform: rotate(270deg);}.fa-flip-horizontal {  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";  -webkit-transform: scale(-1, 1);          transform: scale(-1, 1);}.fa-flip-vertical {  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";  -webkit-transform: scale(1, -1);          transform: scale(1, -1);}.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";  -webkit-transform: scale(-1, -1);          transform: scale(-1, -1);}:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270,:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-flip-both {  -webkit-filter: none;          filter: none;}.fa-stack {  display: inline-block;  height: 2em;  position: relative;  width: 2.5em;}.fa-stack-1x,.fa-stack-2x {  bottom: 0;  left: 0;  margin: auto;  position: absolute;  right: 0;  top: 0;}.svg-inline--fa.fa-stack-1x {  height: 1em;  width: 1.25em;}.svg-inline--fa.fa-stack-2x {  height: 2em;  width: 2.5em;}.fa-inverse {  color: #fff;}.sr-only {  border: 0;  clip: rect(0, 0, 0, 0);  height: 1px;  margin: -1px;  overflow: hidden;  padding: 0;  position: absolute;  width: 1px;}.sr-only-focusable:active, .sr-only-focusable:focus {  clip: auto;  height: auto;  margin: 0;  overflow: visible;  position: static;  width: auto;}.svg-inline--fa .fa-primary {  fill: var(--fa-primary-color, currentColor);  opacity: 1;  opacity: var(--fa-primary-opacity, 1);}.svg-inline--fa .fa-secondary {  fill: var(--fa-secondary-color, currentColor);  opacity: 0.4;  opacity: var(--fa-secondary-opacity, 0.4);}.svg-inline--fa.fa-swap-opacity .fa-primary {  opacity: 0.4;  opacity: var(--fa-secondary-opacity, 0.4);}.svg-inline--fa.fa-swap-opacity .fa-secondary {  opacity: 1;  opacity: var(--fa-primary-opacity, 1);}.svg-inline--fa mask .fa-primary,.svg-inline--fa mask .fa-secondary {  fill: black;}.fad.fa-inverse {  color: #fff;}')
		]));
var $surprisetalk$elm_bulma$Bulma$Modifiers$Danger = 10;
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $surprisetalk$elm_bulma$Bulma$Classes$container = $elm$html$Html$Attributes$class('container');
var $surprisetalk$elm_bulma$Helpers$node = F3(
	function (tag, attrs_, attrs) {
		return A2(
			$elm$html$Html$node,
			tag,
			_Utils_ap(attrs, attrs_));
	});
var $surprisetalk$elm_bulma$Bulma$Layout$container = A2(
	$surprisetalk$elm_bulma$Helpers$node,
	'div',
	_List_fromArray(
		[$surprisetalk$elm_bulma$Bulma$Classes$container]));
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Model$Model$errorToStr = function (e) {
	switch (e.$) {
		case 0:
			return 'Vehicle requires a name.';
		case 1:
			return 'Vehicle requires a type.';
		case 2:
			return 'Select a weapon from the dropdown to add.';
		case 3:
			return 'Select a mount point from the dropdown.';
		case 4:
			return 'Select an upgrade from the dropdown to add.';
		default:
			var s = e.a;
			return 'Json decode error: ' + s;
	}
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $surprisetalk$elm_bulma$Bulma$Classes$isBlack = $elm$html$Html$Attributes$class('is-black');
var $surprisetalk$elm_bulma$Bulma$Classes$isDanger = $elm$html$Html$Attributes$class('is-danger');
var $surprisetalk$elm_bulma$Bulma$Classes$isDark = $elm$html$Html$Attributes$class('is-dark');
var $surprisetalk$elm_bulma$Bulma$Classes$isInfo = $elm$html$Html$Attributes$class('is-info');
var $surprisetalk$elm_bulma$Bulma$Classes$isLarge = $elm$html$Html$Attributes$class('is-large');
var $surprisetalk$elm_bulma$Bulma$Classes$isLight = $elm$html$Html$Attributes$class('is-light');
var $surprisetalk$elm_bulma$Bulma$Classes$isLink = $elm$html$Html$Attributes$class('is-link');
var $surprisetalk$elm_bulma$Bulma$Classes$isMedium = $elm$html$Html$Attributes$class('is-medium');
var $surprisetalk$elm_bulma$Bulma$Classes$isPrimary = $elm$html$Html$Attributes$class('is-primary');
var $surprisetalk$elm_bulma$Bulma$Classes$isSmall = $elm$html$Html$Attributes$class('is-small');
var $surprisetalk$elm_bulma$Bulma$Classes$isSuccess = $elm$html$Html$Attributes$class('is-success');
var $surprisetalk$elm_bulma$Bulma$Classes$isWarning = $elm$html$Html$Attributes$class('is-warning');
var $surprisetalk$elm_bulma$Bulma$Classes$isWhite = $elm$html$Html$Attributes$class('is-white');
var $surprisetalk$elm_bulma$Bulma$Classes$message = $elm$html$Html$Attributes$class('message');
var $surprisetalk$elm_bulma$Bulma$Classes$none = $elm$html$Html$Attributes$class('');
var $surprisetalk$elm_bulma$Bulma$Components$message = function (_v0) {
	var color = _v0.b9;
	var size = _v0.dg;
	return A2(
		$surprisetalk$elm_bulma$Helpers$node,
		'article',
		_List_fromArray(
			[
				$surprisetalk$elm_bulma$Bulma$Classes$message,
				function () {
				switch (color) {
					case 0:
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					case 1:
						return $surprisetalk$elm_bulma$Bulma$Classes$isWhite;
					case 2:
						return $surprisetalk$elm_bulma$Bulma$Classes$isLight;
					case 3:
						return $surprisetalk$elm_bulma$Bulma$Classes$isDark;
					case 4:
						return $surprisetalk$elm_bulma$Bulma$Classes$isBlack;
					case 5:
						return $surprisetalk$elm_bulma$Bulma$Classes$isPrimary;
					case 6:
						return $surprisetalk$elm_bulma$Bulma$Classes$isLink;
					case 7:
						return $surprisetalk$elm_bulma$Bulma$Classes$isInfo;
					case 8:
						return $surprisetalk$elm_bulma$Bulma$Classes$isSuccess;
					case 9:
						return $surprisetalk$elm_bulma$Bulma$Classes$isWarning;
					default:
						return $surprisetalk$elm_bulma$Bulma$Classes$isDanger;
				}
			}(),
				function () {
				switch (size) {
					case 0:
						return $surprisetalk$elm_bulma$Bulma$Classes$isSmall;
					case 1:
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					case 2:
						return $surprisetalk$elm_bulma$Bulma$Classes$isMedium;
					default:
						return $surprisetalk$elm_bulma$Bulma$Classes$isLarge;
				}
			}()
			]));
};
var $surprisetalk$elm_bulma$Bulma$Classes$messageBody = $elm$html$Html$Attributes$class('message-body');
var $surprisetalk$elm_bulma$Bulma$Components$messageBody = A2(
	$surprisetalk$elm_bulma$Helpers$node,
	'div',
	_List_fromArray(
		[$surprisetalk$elm_bulma$Bulma$Classes$messageBody]));
var $surprisetalk$elm_bulma$Bulma$Modifiers$Default = 0;
var $surprisetalk$elm_bulma$Bulma$Modifiers$Standard = 1;
var $surprisetalk$elm_bulma$Bulma$Components$messageModifiers = {b9: 0, dg: 1};
var $author$project$View$View$displayAlert = function (model) {
	var msgBody = function (x) {
		return A2(
			$surprisetalk$elm_bulma$Bulma$Components$messageBody,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Model$Model$errorToStr(x))
				]));
	};
	var _v0 = $elm$core$List$isEmpty(model.cj);
	if (_v0) {
		return A2($elm$html$Html$div, _List_Nil, _List_Nil);
	} else {
		return function (m) {
			return A2(
				$surprisetalk$elm_bulma$Bulma$Layout$container,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('alert-section')
					]),
				_List_fromArray(
					[m]));
		}(
			A3(
				$surprisetalk$elm_bulma$Bulma$Components$message,
				_Utils_update(
					$surprisetalk$elm_bulma$Bulma$Components$messageModifiers,
					{b9: 10}),
				_List_Nil,
				A2($elm$core$List$map, msgBody, model.cj)));
	}
};
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $surprisetalk$elm_bulma$Bulma$Modifiers$Bottom = 1;
var $surprisetalk$elm_bulma$Bulma$Modifiers$Dark = 3;
var $author$project$Model$Vehicle$NextGearPhase = {$: 5};
var $surprisetalk$elm_bulma$Bulma$Modifiers$Success = 8;
var $surprisetalk$elm_bulma$Helpers$ls = function (x) {
	return _List_fromArray(
		[x]);
};
var $surprisetalk$elm_bulma$Bulma$Classes$tag = $elm$html$Html$Attributes$class('tag');
var $surprisetalk$elm_bulma$Bulma$Elements$tag = function (_v0) {
	var size = _v0.dg;
	var color = _v0.b9;
	var isLink = _v0.aA;
	return A2(
		$surprisetalk$elm_bulma$Helpers$node,
		isLink ? 'a' : 'span',
		_List_fromArray(
			[
				$surprisetalk$elm_bulma$Bulma$Classes$tag,
				function () {
				switch (size) {
					case 0:
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					case 1:
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					case 2:
						return $surprisetalk$elm_bulma$Bulma$Classes$isMedium;
					default:
						return $surprisetalk$elm_bulma$Bulma$Classes$isLarge;
				}
			}(),
				function () {
				switch (color) {
					case 0:
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					case 1:
						return $surprisetalk$elm_bulma$Bulma$Classes$isWhite;
					case 2:
						return $surprisetalk$elm_bulma$Bulma$Classes$isLight;
					case 3:
						return $surprisetalk$elm_bulma$Bulma$Classes$isDark;
					case 4:
						return $surprisetalk$elm_bulma$Bulma$Classes$isBlack;
					case 5:
						return $surprisetalk$elm_bulma$Bulma$Classes$isPrimary;
					case 7:
						return $surprisetalk$elm_bulma$Bulma$Classes$isInfo;
					case 8:
						return $surprisetalk$elm_bulma$Bulma$Classes$isSuccess;
					case 9:
						return $surprisetalk$elm_bulma$Bulma$Classes$isWarning;
					case 10:
						return $surprisetalk$elm_bulma$Bulma$Classes$isDanger;
					default:
						return $surprisetalk$elm_bulma$Bulma$Classes$isLink;
				}
			}()
			]));
};
var $surprisetalk$elm_bulma$Bulma$Elements$easyTag = F2(
	function (mods, attrs) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$html$Html$text,
			A2(
				$elm$core$Basics$composeR,
				$surprisetalk$elm_bulma$Helpers$ls,
				A2($surprisetalk$elm_bulma$Bulma$Elements$tag, mods, attrs)));
	});
var $surprisetalk$elm_bulma$Bulma$Classes$hasAddons = $elm$html$Html$Attributes$class('has-addons');
var $surprisetalk$elm_bulma$Bulma$Classes$tags = $elm$html$Html$Attributes$class('tags');
var $surprisetalk$elm_bulma$Bulma$Elements$multitag = A2(
	$surprisetalk$elm_bulma$Helpers$node,
	'div',
	_List_fromArray(
		[$surprisetalk$elm_bulma$Bulma$Classes$tags, $surprisetalk$elm_bulma$Bulma$Classes$hasAddons]));
var $surprisetalk$elm_bulma$Bulma$Components$navbarBrand = F3(
	function (attrs, burger, items) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('navbar-brand'),
				attrs),
			_Utils_ap(
				items,
				_List_fromArray(
					[burger])));
	});
var $surprisetalk$elm_bulma$Bulma$Classes$isActive = $elm$html$Html$Attributes$class('is-active');
var $surprisetalk$elm_bulma$Bulma$Classes$navbarBurger = $elm$html$Html$Attributes$class('navbar-burger');
var $surprisetalk$elm_bulma$Bulma$Components$navbarBurger = function (isActive) {
	return A2(
		$surprisetalk$elm_bulma$Helpers$node,
		'a',
		_List_fromArray(
			[
				$surprisetalk$elm_bulma$Bulma$Classes$navbarBurger,
				isActive ? $surprisetalk$elm_bulma$Bulma$Classes$isActive : $surprisetalk$elm_bulma$Bulma$Classes$none
			]));
};
var $surprisetalk$elm_bulma$Bulma$Classes$navbarItem = $elm$html$Html$Attributes$class('navbar-item');
var $surprisetalk$elm_bulma$Bulma$Components$navbarItemLink = function (isActive) {
	return A2(
		$surprisetalk$elm_bulma$Helpers$node,
		'a',
		_List_fromArray(
			[
				$surprisetalk$elm_bulma$Bulma$Classes$navbarItem,
				isActive ? $surprisetalk$elm_bulma$Bulma$Classes$isActive : $surprisetalk$elm_bulma$Bulma$Classes$none
			]));
};
var $elm$core$Basics$not = _Basics_not;
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $surprisetalk$elm_bulma$Bulma$Elements$tagModifiers = {b9: 0, aA: false, dg: 1};
var $author$project$View$Menu$brand = function (model) {
	var burger = A3(
		$surprisetalk$elm_bulma$Bulma$Components$navbarBurger,
		model.cM,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$Model$Model$NavToggle(!model.cM))
			]),
		_List_fromArray(
			[
				A2($elm$html$Html$span, _List_Nil, _List_Nil),
				A2($elm$html$Html$span, _List_Nil, _List_Nil),
				A2($elm$html$Html$span, _List_Nil, _List_Nil)
			]));
	return A3(
		$surprisetalk$elm_bulma$Bulma$Components$navbarBrand,
		_List_Nil,
		burger,
		_List_fromArray(
			[
				A3(
				$surprisetalk$elm_bulma$Bulma$Components$navbarItemLink,
				false,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Model$Model$ViewMsg($author$project$Model$Views$ViewDashboard))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Team ' + A2($elm$core$Maybe$withDefault, 'NoName', model.dv))
					])),
				A3(
				$surprisetalk$elm_bulma$Bulma$Components$navbarItemLink,
				false,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Model$Model$VehicleMsg($author$project$Model$Vehicle$NextGearPhase))
					]),
				_List_fromArray(
					[
						A2(
						$surprisetalk$elm_bulma$Bulma$Elements$multitag,
						_List_Nil,
						_List_fromArray(
							[
								A3($surprisetalk$elm_bulma$Bulma$Elements$easyTag, $surprisetalk$elm_bulma$Bulma$Elements$tagModifiers, _List_Nil, 'gear phase'),
								A3(
								$surprisetalk$elm_bulma$Bulma$Elements$easyTag,
								_Utils_update(
									$surprisetalk$elm_bulma$Bulma$Elements$tagModifiers,
									{b9: 8}),
								_List_Nil,
								$elm$core$String$fromInt(model.cu))
							]))
					]))
			]));
};
var $author$project$Model$Views$ViewPrintAll = {$: 4};
var $author$project$Model$Views$ViewSettings = {$: 6};
var $author$project$Model$Views$ViewSponsor = {$: 3};
var $surprisetalk$elm_bulma$Bulma$Modifiers$Warning = 9;
var $lattyware$elm_fontawesome$FontAwesome$Icon$Icon = F5(
	function (prefix, name, width, height, paths) {
		return {bc: height, cK: name, c_: paths, c6: prefix, bX: width};
	});
var $lattyware$elm_fontawesome$FontAwesome$Solid$coins = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'coins',
	512,
	512,
	_List_fromArray(
		['M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z']));
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $surprisetalk$elm_bulma$Bulma$Classes$navbarDivider = $elm$html$Html$Attributes$class('navbar-divider');
var $surprisetalk$elm_bulma$Bulma$Components$navbarDivider = A2(
	$surprisetalk$elm_bulma$Helpers$node,
	'hr',
	_List_fromArray(
		[$surprisetalk$elm_bulma$Bulma$Classes$navbarDivider]));
var $author$project$View$Menu$menuLayout = function (buttons) {
	return $elm$core$List$concat(
		A2(
			$elm$core$List$intersperse,
			_List_fromArray(
				[
					A2($surprisetalk$elm_bulma$Bulma$Components$navbarDivider, _List_Nil, _List_Nil)
				]),
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
				buttons)));
};
var $surprisetalk$elm_bulma$Bulma$Classes$navbarEnd = $elm$html$Html$Attributes$class('navbar-end');
var $surprisetalk$elm_bulma$Bulma$Components$navbarEnd = A2(
	$surprisetalk$elm_bulma$Helpers$node,
	'div',
	_List_fromArray(
		[$surprisetalk$elm_bulma$Bulma$Classes$navbarEnd]));
var $surprisetalk$elm_bulma$Bulma$Components$navbarItem = function (isActive) {
	return A2(
		$surprisetalk$elm_bulma$Helpers$node,
		'div',
		_List_fromArray(
			[
				$surprisetalk$elm_bulma$Bulma$Classes$navbarItem,
				isActive ? $surprisetalk$elm_bulma$Bulma$Classes$isActive : $surprisetalk$elm_bulma$Bulma$Classes$none
			]));
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$print = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'print',
	512,
	512,
	_List_fromArray(
		['M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z']));
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$View$Sponsor$renderBadge = function (ms) {
	var _v0 = function () {
		if (ms.$ === 1) {
			return _Utils_Tuple2('None', '');
		} else {
			var sponsor = ms.a;
			return _Utils_Tuple2(sponsor.cK, sponsor.ap);
		}
	}();
	var name = _v0.a;
	var description = _v0.b;
	return A2(
		$surprisetalk$elm_bulma$Bulma$Elements$multitag,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$title(description)
			]),
		_List_fromArray(
			[
				A3($surprisetalk$elm_bulma$Bulma$Elements$easyTag, $surprisetalk$elm_bulma$Bulma$Elements$tagModifiers, _List_Nil, 'sponsor'),
				A3(
				$surprisetalk$elm_bulma$Bulma$Elements$easyTag,
				_Utils_update(
					$surprisetalk$elm_bulma$Bulma$Elements$tagModifiers,
					{b9: 8}),
				_List_Nil,
				name)
			]));
};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Model$Weapon$Common$weaponCost = function (w) {
	var mountModifier = function () {
		var _v0 = w.cJ;
		if ((!_v0.$) && (!_v0.a)) {
			var _v1 = _v0.a;
			return $elm$core$Basics$mul(3);
		} else {
			return $elm$core$Basics$mul(1);
		}
	}();
	var totalModifier = A2(
		$elm$core$Basics$composeL,
		mountModifier,
		$elm$core$Basics$mul(1));
	var baseCost = w.cb;
	return totalModifier(baseCost);
};
var $author$project$Model$Vehicle$Common$vehicleCost = function (v) {
	return $elm$core$List$sum(
		_List_fromArray(
			[
				v.cb,
				$elm$core$List$sum(
				A2($elm$core$List$map, $author$project$Model$Weapon$Common$weaponCost, v.dG)),
				$elm$core$List$sum(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.cb;
					},
					v.dD)),
				$elm$core$List$sum(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.cb;
					},
					v.c3))
			]));
};
var $author$project$Model$Model$totalPoints = function (model) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			$author$project$Model$Vehicle$Common$vehicleCost,
			$elm$core$Dict$values(model.dE)));
};
var $lattyware$elm_fontawesome$FontAwesome$Icon$Presentation = $elm$core$Basics$identity;
var $lattyware$elm_fontawesome$FontAwesome$Icon$present = function (icon) {
	return {_: _List_Nil, bg: icon, ay: $elm$core$Maybe$Nothing, T: $elm$core$Maybe$Nothing, aL: 'img', dw: $elm$core$Maybe$Nothing, ah: _List_Nil};
};
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$add = F2(
	function (transform, combined) {
		switch (transform.$) {
			case 0:
				var direction = transform.a;
				var amount = function () {
					if (!direction.$) {
						var by = direction.a;
						return by;
					} else {
						var by = direction.a;
						return -by;
					}
				}();
				return _Utils_update(
					combined,
					{dg: combined.dg + amount});
			case 1:
				var direction = transform.a;
				var _v2 = function () {
					switch (direction.$) {
						case 0:
							var by = direction.a;
							return _Utils_Tuple2(0, -by);
						case 1:
							var by = direction.a;
							return _Utils_Tuple2(0, by);
						case 2:
							var by = direction.a;
							return _Utils_Tuple2(-by, 0);
						default:
							var by = direction.a;
							return _Utils_Tuple2(by, 0);
					}
				}();
				var x = _v2.a;
				var y = _v2.b;
				return _Utils_update(
					combined,
					{bY: combined.bY + x, bZ: combined.bZ + y});
			case 2:
				var rotation = transform.a;
				return _Utils_update(
					combined,
					{dc: combined.dc + rotation});
			default:
				if (!transform.a) {
					var _v4 = transform.a;
					return _Utils_update(
						combined,
						{cq: true});
				} else {
					var _v5 = transform.a;
					return _Utils_update(
						combined,
						{cr: true});
				}
		}
	});
var $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$baseSize = 16;
var $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$meaninglessTransform = {cq: false, cr: false, dc: 0, dg: $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$baseSize, bY: 0, bZ: 0};
var $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$combine = function (transforms) {
	return A3($elm$core$List$foldl, $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$add, $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$meaninglessTransform, transforms);
};
var $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$meaningfulTransform = function (transforms) {
	var combined = $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$combine(transforms);
	return _Utils_eq(combined, $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$meaninglessTransform) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(combined);
};
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$title = $elm$svg$Svg$trustedNode('title');
var $lattyware$elm_fontawesome$FontAwesome$Icon$titledContents = F3(
	function (titleId, contents, title) {
		return A2(
			$elm$core$List$cons,
			A2(
				$elm$svg$Svg$title,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id(titleId)
					]),
				_List_fromArray(
					[
						$elm$svg$Svg$text(title)
					])),
			contents);
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$transformForSvg = F3(
	function (containerWidth, iconWidth, transform) {
		var path = 'translate(' + ($elm$core$String$fromFloat((iconWidth / 2) * (-1)) + ' -256)');
		var outer = 'translate(' + ($elm$core$String$fromFloat(containerWidth / 2) + ' 256)');
		var innerTranslate = 'translate(' + ($elm$core$String$fromFloat(transform.bY * 32) + (',' + ($elm$core$String$fromFloat(transform.bZ * 32) + ') ')));
		var innerRotate = 'rotate(' + ($elm$core$String$fromFloat(transform.dc) + ' 0 0)');
		var flipY = transform.cr ? (-1) : 1;
		var scaleY = (transform.dg / $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$baseSize) * flipY;
		var flipX = transform.cq ? (-1) : 1;
		var scaleX = (transform.dg / $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$baseSize) * flipX;
		var innerScale = 'scale(' + ($elm$core$String$fromFloat(scaleX) + (', ' + ($elm$core$String$fromFloat(scaleY) + ') ')));
		return {
			bh: $elm$svg$Svg$Attributes$transform(
				_Utils_ap(
					innerTranslate,
					_Utils_ap(innerScale, innerRotate))),
			T: $elm$svg$Svg$Attributes$transform(outer),
			bt: $elm$svg$Svg$Attributes$transform(path)
		};
	});
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $lattyware$elm_fontawesome$FontAwesome$Icon$allSpace = _List_fromArray(
	[
		$elm$svg$Svg$Attributes$x('0'),
		$elm$svg$Svg$Attributes$y('0'),
		$elm$svg$Svg$Attributes$width('100%'),
		$elm$svg$Svg$Attributes$height('100%')
	]);
var $elm$svg$Svg$clipPath = $elm$svg$Svg$trustedNode('clipPath');
var $elm$svg$Svg$Attributes$clipPath = _VirtualDom_attribute('clip-path');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePath = F2(
	function (attrs, d) {
		return A2(
			$elm$svg$Svg$path,
			A2(
				$elm$core$List$cons,
				$elm$svg$Svg$Attributes$fill('currentColor'),
				A2(
					$elm$core$List$cons,
					$elm$svg$Svg$Attributes$d(d),
					attrs)),
			_List_Nil);
	});
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePaths = F2(
	function (attrs, icon) {
		var _v0 = icon.c_;
		if (!_v0.b) {
			return A2($lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePath, attrs, '');
		} else {
			if (!_v0.b.b) {
				var only = _v0.a;
				return A2($lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePath, attrs, only);
			} else {
				var secondary = _v0.a;
				var _v1 = _v0.b;
				var primary = _v1.a;
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('fa-group')
						]),
					_List_fromArray(
						[
							A2(
							$lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePath,
							A2(
								$elm$core$List$cons,
								$elm$svg$Svg$Attributes$class('fa-secondary'),
								attrs),
							secondary),
							A2(
							$lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePath,
							A2(
								$elm$core$List$cons,
								$elm$svg$Svg$Attributes$class('fa-primary'),
								attrs),
							primary)
						]));
			}
		}
	});
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $elm$svg$Svg$mask = $elm$svg$Svg$trustedNode('mask');
var $elm$svg$Svg$Attributes$mask = _VirtualDom_attribute('mask');
var $elm$svg$Svg$Attributes$maskContentUnits = _VirtualDom_attribute('maskContentUnits');
var $elm$svg$Svg$Attributes$maskUnits = _VirtualDom_attribute('maskUnits');
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $lattyware$elm_fontawesome$FontAwesome$Icon$viewMaskedWithTransform = F4(
	function (id, transforms, inner, outer) {
		var maskInnerGroup = A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[transforms.bh]),
			_List_fromArray(
				[
					A2(
					$lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePaths,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('black'),
							transforms.bt
						]),
					inner)
				]));
		var maskId = 'mask-' + (inner.cK + ('-' + id));
		var maskTag = A2(
			$elm$svg$Svg$mask,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id(maskId),
						$elm$svg$Svg$Attributes$maskUnits('userSpaceOnUse'),
						$elm$svg$Svg$Attributes$maskContentUnits('userSpaceOnUse')
					]),
				$lattyware$elm_fontawesome$FontAwesome$Icon$allSpace),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$rect,
					A2(
						$elm$core$List$cons,
						$elm$svg$Svg$Attributes$fill('white'),
						$lattyware$elm_fontawesome$FontAwesome$Icon$allSpace),
					_List_Nil),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[transforms.T]),
					_List_fromArray(
						[maskInnerGroup]))
				]));
		var clipId = 'clip-' + (outer.cK + ('-' + id));
		var defs = A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id(clipId)
						]),
					_List_fromArray(
						[
							A2($lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePaths, _List_Nil, outer)
						])),
					maskTag
				]));
		return _List_fromArray(
			[
				defs,
				A2(
				$elm$svg$Svg$rect,
				$elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								$elm$svg$Svg$Attributes$fill('currentColor'),
								$elm$svg$Svg$Attributes$clipPath('url(#' + (clipId + ')')),
								$elm$svg$Svg$Attributes$mask('url(#' + (maskId + ')'))
							]),
							$lattyware$elm_fontawesome$FontAwesome$Icon$allSpace
						])),
				_List_Nil)
			]);
	});
var $lattyware$elm_fontawesome$FontAwesome$Icon$viewWithTransform = F2(
	function (transforms, icon) {
		if (!transforms.$) {
			var ts = transforms.a;
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[ts.T]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[ts.bh]),
						_List_fromArray(
							[
								A2(
								$lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePaths,
								_List_fromArray(
									[ts.bt]),
								icon)
							]))
					]));
		} else {
			return A2($lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePaths, _List_Nil, icon);
		}
	});
var $lattyware$elm_fontawesome$FontAwesome$Icon$internalView = function (_v0) {
	var icon = _v0.bg;
	var attributes = _v0._;
	var transforms = _v0.ah;
	var role = _v0.aL;
	var id = _v0.ay;
	var title = _v0.dw;
	var outer = _v0.T;
	var alwaysId = A2($elm$core$Maybe$withDefault, icon.cK, id);
	var titleId = alwaysId + '-title';
	var semantics = A2(
		$elm$core$Maybe$withDefault,
		A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(
				A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', titleId)),
			title));
	var _v1 = A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple2(icon.bX, icon.bc),
		A2(
			$elm$core$Maybe$map,
			function (o) {
				return _Utils_Tuple2(o.bX, o.bc);
			},
			outer));
	var width = _v1.a;
	var height = _v1.b;
	var classes = _List_fromArray(
		[
			'svg-inline--fa',
			'fa-' + icon.cK,
			'fa-w-' + $elm$core$String$fromInt(
			$elm$core$Basics$ceiling((width / height) * 16))
		]);
	var svgTransform = A2(
		$elm$core$Maybe$map,
		A2($lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$transformForSvg, width, icon.bX),
		$lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$meaningfulTransform(transforms));
	var contents = function () {
		var resolvedSvgTransform = A2(
			$elm$core$Maybe$withDefault,
			A3($lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$transformForSvg, width, icon.bX, $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$meaninglessTransform),
			svgTransform);
		return A2(
			$elm$core$Maybe$withDefault,
			_List_fromArray(
				[
					A2($lattyware$elm_fontawesome$FontAwesome$Icon$viewWithTransform, svgTransform, icon)
				]),
			A2(
				$elm$core$Maybe$map,
				A3($lattyware$elm_fontawesome$FontAwesome$Icon$viewMaskedWithTransform, alwaysId, resolvedSvgTransform, icon),
				outer));
	}();
	var potentiallyTitledContents = A2(
		$elm$core$Maybe$withDefault,
		contents,
		A2(
			$elm$core$Maybe$map,
			A2($lattyware$elm_fontawesome$FontAwesome$Icon$titledContents, titleId, contents),
			title));
	return A2(
		$elm$svg$Svg$svg,
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'role', role),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						$elm$svg$Svg$Attributes$viewBox(
						'0 0 ' + ($elm$core$String$fromInt(width) + (' ' + $elm$core$String$fromInt(height)))),
						semantics
					]),
					A2($elm$core$List$map, $elm$svg$Svg$Attributes$class, classes),
					attributes
				])),
		potentiallyTitledContents);
};
var $lattyware$elm_fontawesome$FontAwesome$Icon$view = function (presentation) {
	return $lattyware$elm_fontawesome$FontAwesome$Icon$internalView(presentation);
};
var $lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon = A2($elm$core$Basics$composeR, $lattyware$elm_fontawesome$FontAwesome$Icon$present, $lattyware$elm_fontawesome$FontAwesome$Icon$view);
var $lattyware$elm_fontawesome$FontAwesome$Icon$styled = F2(
	function (attributes, _v0) {
		var presentation = _v0;
		return _Utils_update(
			presentation,
			{
				_: _Utils_ap(presentation._, attributes)
			});
	});
var $lattyware$elm_fontawesome$FontAwesome$Icon$viewStyled = function (styles) {
	return A2(
		$elm$core$Basics$composeR,
		$lattyware$elm_fontawesome$FontAwesome$Icon$present,
		A2(
			$elm$core$Basics$composeR,
			$lattyware$elm_fontawesome$FontAwesome$Icon$styled(styles),
			$lattyware$elm_fontawesome$FontAwesome$Icon$view));
};
var $author$project$Model$Features$withDefault = F3(
	function (feature, _default, actual) {
		var _v0 = A2($elm$core$Dict$get, feature, $author$project$Model$Features$flags);
		if (_v0.$ === 1) {
			return _default;
		} else {
			var onOff = _v0.a;
			if (onOff) {
				return actual;
			} else {
				return _default;
			}
		}
	});
var $lattyware$elm_fontawesome$FontAwesome$Solid$wrench = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'wrench',
	512,
	512,
	_List_fromArray(
		['M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z']));
var $author$project$View$Menu$end = function (model) {
	var maxPoints = model.c5;
	var currentPoints = $author$project$Model$Model$totalPoints(model);
	var pointsColor = function () {
		var _v0 = A2($elm$core$Basics$compare, currentPoints, maxPoints);
		switch (_v0) {
			case 0:
				return 9;
			case 1:
				return 8;
			default:
				return 10;
		}
	}();
	var pointsBadge = A3(
		$surprisetalk$elm_bulma$Bulma$Components$navbarItem,
		false,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$surprisetalk$elm_bulma$Bulma$Elements$multitag,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$title('Cans availabled')
					]),
				_List_fromArray(
					[
						A3(
						$surprisetalk$elm_bulma$Bulma$Elements$tag,
						_Utils_update(
							$surprisetalk$elm_bulma$Bulma$Elements$tagModifiers,
							{b9: pointsColor}),
						_List_Nil,
						_List_fromArray(
							[
								$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$coins)
							])),
						A3(
						$surprisetalk$elm_bulma$Bulma$Elements$tag,
						_Utils_update(
							$surprisetalk$elm_bulma$Bulma$Elements$tagModifiers,
							{b9: pointsColor}),
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(currentPoints) + (' of ' + $elm$core$String$fromInt(maxPoints)))
							]))
					]))
			]));
	var settingsButtons = _List_fromArray(
		[
			A3(
			$author$project$Model$Features$withDefault,
			'feature-printing',
			$elm$html$Html$text(''),
			A3(
				$surprisetalk$elm_bulma$Bulma$Components$navbarItemLink,
				false,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$disabled(
						$elm$core$Dict$isEmpty(model.dE)),
						$elm$html$Html$Events$onClick(
						$author$project$Model$Model$ViewMsg($author$project$Model$Views$ViewPrintAll))
					]),
				_List_fromArray(
					[
						$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$print)
					]))),
			A3(
			$surprisetalk$elm_bulma$Bulma$Components$navbarItemLink,
			false,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Model$Model$ViewMsg($author$project$Model$Views$ViewSponsor))
				]),
			_List_fromArray(
				[
					$author$project$View$Sponsor$renderBadge(model.dl)
				])),
			pointsBadge,
			A3(
			$surprisetalk$elm_bulma$Bulma$Components$navbarItemLink,
			false,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Back Button'),
					$elm$html$Html$Events$onClick(
					$author$project$Model$Model$ViewMsg($author$project$Model$Views$ViewSettings))
				]),
			_List_fromArray(
				[
					A2(
					$lattyware$elm_fontawesome$FontAwesome$Icon$viewStyled,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-right', '.5rem')
						]),
					$lattyware$elm_fontawesome$FontAwesome$Solid$wrench),
					$elm$html$Html$text('Settings')
				]))
		]);
	return A2(
		$surprisetalk$elm_bulma$Bulma$Components$navbarEnd,
		_List_Nil,
		$author$project$View$Menu$menuLayout(
			_List_fromArray(
				[settingsButtons])));
};
var $surprisetalk$elm_bulma$Bulma$Classes$isTransparent = $elm$html$Html$Attributes$class('is-transparent');
var $surprisetalk$elm_bulma$Bulma$Classes$navbar = $elm$html$Html$Attributes$class('navbar');
var $surprisetalk$elm_bulma$Bulma$Components$navbar = function (_v0) {
	var color = _v0.b9;
	var transparent = _v0.dA;
	return A2(
		$surprisetalk$elm_bulma$Helpers$node,
		'nav',
		_List_fromArray(
			[
				$surprisetalk$elm_bulma$Bulma$Classes$navbar,
				function () {
				if (transparent) {
					return $surprisetalk$elm_bulma$Bulma$Classes$isTransparent;
				} else {
					return $surprisetalk$elm_bulma$Bulma$Classes$none;
				}
			}(),
				function () {
				switch (color) {
					case 0:
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					case 1:
						return $surprisetalk$elm_bulma$Bulma$Classes$isWhite;
					case 2:
						return $surprisetalk$elm_bulma$Bulma$Classes$isLight;
					case 3:
						return $surprisetalk$elm_bulma$Bulma$Classes$isDark;
					case 4:
						return $surprisetalk$elm_bulma$Bulma$Classes$isBlack;
					case 5:
						return $surprisetalk$elm_bulma$Bulma$Classes$isPrimary;
					case 6:
						return $surprisetalk$elm_bulma$Bulma$Classes$isLink;
					case 7:
						return $surprisetalk$elm_bulma$Bulma$Classes$isInfo;
					case 8:
						return $surprisetalk$elm_bulma$Bulma$Classes$isSuccess;
					case 9:
						return $surprisetalk$elm_bulma$Bulma$Classes$isWarning;
					default:
						return $surprisetalk$elm_bulma$Bulma$Classes$isDanger;
				}
			}()
			]));
};
var $surprisetalk$elm_bulma$Bulma$Components$fixedNavbar = F2(
	function (dir, mods) {
		return A2(
			$elm$core$Basics$composeL,
			$surprisetalk$elm_bulma$Bulma$Components$navbar(mods),
			$elm$core$List$cons(
				function () {
					if (!dir) {
						return $elm$html$Html$Attributes$class('is-fixed-top');
					} else {
						return $elm$html$Html$Attributes$class('is-fixed-bottom');
					}
				}()));
	});
var $surprisetalk$elm_bulma$Bulma$Classes$navbarMenu = $elm$html$Html$Attributes$class('navbar-menu');
var $surprisetalk$elm_bulma$Bulma$Components$navbarMenu = F2(
	function (isActive, attrs) {
		return A3(
			$surprisetalk$elm_bulma$Helpers$node,
			'div',
			_List_fromArray(
				[
					$surprisetalk$elm_bulma$Bulma$Classes$navbarMenu,
					isActive ? $surprisetalk$elm_bulma$Bulma$Classes$isActive : $surprisetalk$elm_bulma$Bulma$Classes$none
				]),
			attrs);
	});
var $surprisetalk$elm_bulma$Bulma$Components$navbarModifiers = {b9: 0, dA: false};
var $author$project$Model$Vehicle$UpdateActivated = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Model$Views$ViewPrint = function (a) {
	return {$: 5, a: a};
};
var $surprisetalk$elm_bulma$Bulma$Modifiers$Blur = 0;
var $surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers = {b9: 0, cf: false, cC: $elm$core$Maybe$Nothing, ax: $elm$core$Maybe$Nothing, az: false, aH: false, aM: false, dg: 1, g: 0, aQ: false};
var $surprisetalk$elm_bulma$Bulma$Classes$button = $elm$html$Html$Attributes$class('button');
var $surprisetalk$elm_bulma$Bulma$Classes$icon = $elm$html$Html$Attributes$class('icon');
var $surprisetalk$elm_bulma$Bulma$Elements$icon = function (size) {
	return A2(
		$surprisetalk$elm_bulma$Helpers$node,
		'span',
		_List_fromArray(
			[
				$surprisetalk$elm_bulma$Bulma$Classes$icon,
				function () {
				switch (size) {
					case 0:
						return $surprisetalk$elm_bulma$Bulma$Classes$isSmall;
					case 1:
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					case 2:
						return $surprisetalk$elm_bulma$Bulma$Classes$isMedium;
					default:
						return $surprisetalk$elm_bulma$Bulma$Classes$isLarge;
				}
			}()
			]));
};
var $surprisetalk$elm_bulma$Bulma$Classes$isFocused = $elm$html$Html$Attributes$class('is-focused');
var $surprisetalk$elm_bulma$Bulma$Classes$isHovered = $elm$html$Html$Attributes$class('is-hovered');
var $surprisetalk$elm_bulma$Bulma$Classes$isInverted = $elm$html$Html$Attributes$class('is-inverted');
var $surprisetalk$elm_bulma$Bulma$Classes$isLoading = $elm$html$Html$Attributes$class('is-loading');
var $surprisetalk$elm_bulma$Bulma$Classes$isOutlined = $elm$html$Html$Attributes$class('is-outlined');
var $surprisetalk$elm_bulma$Bulma$Classes$isRounded = $elm$html$Html$Attributes$class('is-rounded');
var $surprisetalk$elm_bulma$Bulma$Classes$isSelected = $elm$html$Html$Attributes$class('is-selected');
var $surprisetalk$elm_bulma$Bulma$Classes$isStatic = $elm$html$Html$Attributes$class('is-static');
var $surprisetalk$elm_bulma$Bulma$Elements$button = F3(
	function (_v0, attrs, htmls) {
		var disabled = _v0.cf;
		var outlined = _v0.aH;
		var inverted = _v0.az;
		var rounded = _v0.aM;
		var size = _v0.dg;
		var state = _v0.g;
		var color = _v0.b9;
		var _static = _v0.aQ;
		var iconLeft = _v0.cC;
		var iconRight = _v0.ax;
		var iconRight_ = function () {
			if (!iconRight.$) {
				var _v13 = iconRight.a;
				var size_ = _v13.a;
				var attrs_ = _v13.b;
				var body = _v13.c;
				return _List_fromArray(
					[
						A3(
						$surprisetalk$elm_bulma$Bulma$Elements$icon,
						size_,
						attrs_,
						_List_fromArray(
							[body]))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var iconLeft_ = function () {
			if (!iconLeft.$) {
				var _v11 = iconLeft.a;
				var size_ = _v11.a;
				var attrs_ = _v11.b;
				var body = _v11.c;
				return _List_fromArray(
					[
						A3(
						$surprisetalk$elm_bulma$Bulma$Elements$icon,
						size_,
						attrs_,
						_List_fromArray(
							[body]))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var htmls_ = function () {
			if (!htmls.b) {
				return _Utils_ap(iconLeft_, iconRight_);
			} else {
				var htmls__ = htmls;
				return _Utils_ap(
					iconLeft_,
					_Utils_ap(
						_List_fromArray(
							[
								A2($elm$html$Html$span, _List_Nil, htmls__)
							]),
						iconRight_));
			}
		}();
		return A4(
			$surprisetalk$elm_bulma$Helpers$node,
			'button',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(disabled),
					$surprisetalk$elm_bulma$Bulma$Classes$button,
					function () {
					if (_static) {
						return $surprisetalk$elm_bulma$Bulma$Classes$isStatic;
					} else {
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					}
				}(),
					function () {
					if (outlined) {
						return $surprisetalk$elm_bulma$Bulma$Classes$isOutlined;
					} else {
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					}
				}(),
					function () {
					if (inverted) {
						return $surprisetalk$elm_bulma$Bulma$Classes$isInverted;
					} else {
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					}
				}(),
					function () {
					if (rounded) {
						return $surprisetalk$elm_bulma$Bulma$Classes$isRounded;
					} else {
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					}
				}(),
					function () {
					if (!color) {
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					} else {
						return $surprisetalk$elm_bulma$Bulma$Classes$isSelected;
					}
				}(),
					function () {
					switch (color) {
						case 0:
							return $surprisetalk$elm_bulma$Bulma$Classes$none;
						case 1:
							return $surprisetalk$elm_bulma$Bulma$Classes$isWhite;
						case 2:
							return $surprisetalk$elm_bulma$Bulma$Classes$isLight;
						case 3:
							return $surprisetalk$elm_bulma$Bulma$Classes$isDark;
						case 4:
							return $surprisetalk$elm_bulma$Bulma$Classes$isBlack;
						case 5:
							return $surprisetalk$elm_bulma$Bulma$Classes$isPrimary;
						case 6:
							return $surprisetalk$elm_bulma$Bulma$Classes$isLink;
						case 7:
							return $surprisetalk$elm_bulma$Bulma$Classes$isInfo;
						case 8:
							return $surprisetalk$elm_bulma$Bulma$Classes$isSuccess;
						case 9:
							return $surprisetalk$elm_bulma$Bulma$Classes$isWarning;
						default:
							return $surprisetalk$elm_bulma$Bulma$Classes$isDanger;
					}
				}(),
					function () {
					switch (size) {
						case 0:
							return $surprisetalk$elm_bulma$Bulma$Classes$isSmall;
						case 1:
							return $surprisetalk$elm_bulma$Bulma$Classes$none;
						case 2:
							return $surprisetalk$elm_bulma$Bulma$Classes$isMedium;
						default:
							return $surprisetalk$elm_bulma$Bulma$Classes$isLarge;
					}
				}(),
					function () {
					switch (state) {
						case 0:
							return $surprisetalk$elm_bulma$Bulma$Classes$none;
						case 1:
							return $surprisetalk$elm_bulma$Bulma$Classes$isHovered;
						case 2:
							return $surprisetalk$elm_bulma$Bulma$Classes$isFocused;
						case 3:
							return $surprisetalk$elm_bulma$Bulma$Classes$isActive;
						default:
							return $surprisetalk$elm_bulma$Bulma$Classes$isLoading;
					}
				}()
				]),
			attrs,
			htmls_);
	});
var $surprisetalk$elm_bulma$Bulma$Classes$control = $elm$html$Html$Attributes$class('control');
var $surprisetalk$elm_bulma$Bulma$Classes$hasIconsLeft = $elm$html$Html$Attributes$class('has-icons-left');
var $surprisetalk$elm_bulma$Bulma$Classes$hasIconsRight = $elm$html$Html$Attributes$class('has-icons-right');
var $surprisetalk$elm_bulma$Bulma$Classes$isExpanded = $elm$html$Html$Attributes$class('is-expanded');
var $surprisetalk$elm_bulma$Bulma$Form$control = F3(
	function (_v0, attrs, htmls) {
		var loading = _v0.J;
		var expanded = _v0.o;
		var iconLeft = _v0.cC;
		var iconRight = _v0.ax;
		return A4(
			$surprisetalk$elm_bulma$Helpers$node,
			'p',
			_List_fromArray(
				[
					$surprisetalk$elm_bulma$Bulma$Classes$control,
					function () {
					if (!loading.$) {
						return $surprisetalk$elm_bulma$Bulma$Classes$isLoading;
					} else {
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					}
				}(),
					function () {
					_v2$3:
					while (true) {
						if (!loading.$) {
							switch (loading.a) {
								case 0:
									var _v3 = loading.a;
									return $surprisetalk$elm_bulma$Bulma$Classes$isSmall;
								case 2:
									var _v4 = loading.a;
									return $surprisetalk$elm_bulma$Bulma$Classes$isMedium;
								case 3:
									var _v5 = loading.a;
									return $surprisetalk$elm_bulma$Bulma$Classes$isLarge;
								default:
									break _v2$3;
							}
						} else {
							break _v2$3;
						}
					}
					return $surprisetalk$elm_bulma$Bulma$Classes$none;
				}(),
					function () {
					if (expanded) {
						return $surprisetalk$elm_bulma$Bulma$Classes$isExpanded;
					} else {
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					}
				}(),
					function () {
					if (!iconLeft.$) {
						return $surprisetalk$elm_bulma$Bulma$Classes$hasIconsLeft;
					} else {
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					}
				}(),
					function () {
					if (!iconRight.$) {
						return $surprisetalk$elm_bulma$Bulma$Classes$hasIconsRight;
					} else {
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					}
				}()
				]),
			attrs,
			_Utils_ap(
				htmls,
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (_v9) {
								var size_ = _v9.a;
								var attrs_ = _v9.b;
								var iconBody = _v9.c;
								return _List_fromArray(
									[
										A3(
										$surprisetalk$elm_bulma$Bulma$Elements$icon,
										size_,
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('is-left'),
											attrs_),
										_List_fromArray(
											[iconBody]))
									]);
							},
							iconLeft)),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (_v10) {
									var size_ = _v10.a;
									var attrs_ = _v10.b;
									var iconBody = _v10.c;
									return _List_fromArray(
										[
											A3(
											$surprisetalk$elm_bulma$Bulma$Elements$icon,
											size_,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Attributes$class('is-right'),
												attrs_),
											_List_fromArray(
												[iconBody]))
										]);
								},
								iconRight)),
						_List_Nil))));
	});
var $surprisetalk$elm_bulma$Bulma$Form$controlModifiers = {o: false, cC: $elm$core$Maybe$Nothing, ax: $elm$core$Maybe$Nothing, J: $elm$core$Maybe$Nothing};
var $surprisetalk$elm_bulma$Bulma$Form$controlButton = F3(
	function (mods, attrs, attrs_) {
		return A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				A2($surprisetalk$elm_bulma$Bulma$Form$control, $surprisetalk$elm_bulma$Bulma$Form$controlModifiers, attrs),
				$surprisetalk$elm_bulma$Helpers$ls),
			A2($surprisetalk$elm_bulma$Bulma$Elements$button, mods, attrs_));
	});
var $surprisetalk$elm_bulma$Bulma$Classes$navbarStart = $elm$html$Html$Attributes$class('navbar-start');
var $surprisetalk$elm_bulma$Bulma$Components$navbarStart = A2(
	$surprisetalk$elm_bulma$Helpers$node,
	'div',
	_List_fromArray(
		[$surprisetalk$elm_bulma$Bulma$Classes$navbarStart]));
var $author$project$View$Menu$start = function (model) {
	var detailsButtons = function () {
		var _v0 = model.dF;
		if (_v0.$ === 2) {
			var key = _v0.a;
			var vehicle = A2(
				$elm$core$Maybe$withDefault,
				$author$project$Model$Vehicle$defaultVehicle,
				A2($elm$core$Dict$get, key, model.dE));
			var canActivate = _Utils_cmp(model.cu, vehicle.ct.a2) < 1;
			var activatedText = function () {
				var _v1 = _Utils_Tuple2(vehicle.b$, canActivate);
				if (_v1.a) {
					return 'Activated';
				} else {
					if (!_v1.b) {
						return 'Cannot be Activated';
					} else {
						return 'Activate';
					}
				}
			}();
			return _List_fromArray(
				[
					A3(
					$surprisetalk$elm_bulma$Bulma$Components$navbarItem,
					false,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							$surprisetalk$elm_bulma$Bulma$Form$controlButton,
							$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Model$Model$VehicleMsg(
										A2($author$project$Model$Vehicle$UpdateActivated, vehicle.cH, !vehicle.b$))),
									$elm$html$Html$Attributes$disabled((!canActivate) || vehicle.b$)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(activatedText)
								]))
						])),
					A3(
					$author$project$Model$Features$withDefault,
					'feature-printing',
					$elm$html$Html$text(''),
					A3(
						$surprisetalk$elm_bulma$Bulma$Components$navbarItemLink,
						false,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Model$Model$ViewMsg(
									$author$project$Model$Views$ViewPrint(vehicle.cH)))
							]),
						_List_fromArray(
							[
								$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$print)
							])))
				]);
		} else {
			return _List_Nil;
		}
	}();
	return A2(
		$surprisetalk$elm_bulma$Bulma$Components$navbarStart,
		_List_Nil,
		$author$project$View$Menu$menuLayout(
			_List_fromArray(
				[detailsButtons])));
};
var $author$project$View$View$nav = function (model) {
	return A4(
		$surprisetalk$elm_bulma$Bulma$Components$fixedNavbar,
		1,
		_Utils_update(
			$surprisetalk$elm_bulma$Bulma$Components$navbarModifiers,
			{b9: 3, dA: true}),
		_List_Nil,
		_List_fromArray(
			[
				$author$project$View$Menu$brand(model),
				A3(
				$surprisetalk$elm_bulma$Bulma$Components$navbarMenu,
				model.cM,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$View$Menu$start(model),
						$author$project$View$Menu$end(model)
					]))
			]));
};
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $author$project$Model$Weapon$Common$handgun = $author$project$Model$Weapon$Data$handgun;
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Model$Vehicle$Common$slotsUsed = function (v) {
	return $elm$core$List$sum(
		_Utils_ap(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.di;
				},
				v.dG),
			A2(
				$elm$core$List$map,
				function ($) {
					return $.di;
				},
				v.dD)));
};
var $author$project$Model$Vehicle$Common$slotsRemaining = function (v) {
	return v.ci - $author$project$Model$Vehicle$Common$slotsUsed(v);
};
var $author$project$Model$Model$vehicleFromKey = F2(
	function (model, key) {
		return A2($elm$core$Dict$get, key, model.dE);
	});
var $author$project$Model$Views$NewVehicle = {$: 0};
var $author$project$Model$Views$ViewNew = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$ge = _Utils_ge;
var $author$project$Model$Vehicle$Common$modToInt = function (s) {
	switch (s.$) {
		case 8:
			var i = s.a;
			return i;
		case 9:
			var i = s.a;
			return i;
		case 10:
			var i = s.a;
			return i;
		case 11:
			var i = s.a;
			return i;
		case 12:
			var i = s.a;
			return i;
		default:
			return 0;
	}
};
var $author$project$Model$Vehicle$Common$totalForModType = F2(
	function (upgradeList, modFilter) {
		return $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$author$project$Model$Vehicle$Common$modToInt,
				A2(
					$elm$core$List$filter,
					modFilter,
					$elm$core$List$concat(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.dj;
							},
							upgradeList)))));
	});
var $author$project$Model$Vehicle$Common$totalHull = function (v) {
	var hullFilter = function (m) {
		if (m.$ === 9) {
			return true;
		} else {
			return false;
		}
	};
	return v.cB.bo + A2($author$project$Model$Vehicle$Common$totalForModType, v.dD, hullFilter);
};
var $author$project$Model$Vehicle$Common$isWrecked = function (v) {
	return _Utils_cmp(
		v.cB.a2,
		$author$project$Model$Vehicle$Common$totalHull(v)) > -1;
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$plus = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'plus',
	448,
	512,
	_List_fromArray(
		['M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z']));
var $author$project$View$Vehicle$RenderConfig = function (showActivateButton) {
	return function (showPhoto) {
		return function (showPrintButton) {
			return function (showCounters) {
				return function (printCounters) {
					return function (printNotes) {
						return function (inputNotes) {
							return function (showAddonButton) {
								return function (showDetails) {
									return function (printDetails) {
										return function (showPerks) {
											return function (printPerks) {
												return function (previewPerks) {
													return function (showDetailsButton) {
														return {bi: inputNotes, bw: previewPerks, K: printCounters, x: printDetails, by: printNotes, aJ: printPerks, ae: showActivateButton, af: showAddonButton, U: showCounters, V: showDetails, bN: showDetailsButton, ag: showPerks, aO: showPhoto, bO: showPrintButton};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$View$Vehicle$config = $author$project$View$Vehicle$RenderConfig(false)(false)(false)(false)(false)(false)(false)(false)(false)(false)(false)(false)(false)(false);
var $author$project$Model$Weapon$AddWeapon = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $surprisetalk$elm_bulma$Bulma$Modifiers$Block = 0;
var $author$project$Model$Vehicle$DeleteVehicle = function (a) {
	return {$: 1, a: a};
};
var $surprisetalk$elm_bulma$Bulma$Elements$H3 = 2;
var $surprisetalk$elm_bulma$Bulma$Modifiers$Hidden = 2;
var $surprisetalk$elm_bulma$Bulma$Modifiers$Info = 7;
var $surprisetalk$elm_bulma$Bulma$Modifiers$Light = 2;
var $author$project$Model$Views$NewUpgrade = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Views$NewWeapon = function (a) {
	return {$: 1, a: a};
};
var $surprisetalk$elm_bulma$Bulma$Modifiers$Primary = 5;
var $author$project$View$Upgrade$RenderConfig = F4(
	function (previewSpecials, printSpecials, showDeleteButton, highlightRow) {
		return {bd: highlightRow, bx: previewSpecials, c7: printSpecials, de: showDeleteButton};
	});
var $author$project$Model$Vehicle$ShiftGear = F4(
	function (a, b, c, d) {
		return {$: 8, a: a, b: b, c: c, d: d};
	});
var $author$project$Model$Vehicle$ShiftHazards = F4(
	function (a, b, c, d) {
		return {$: 10, a: a, b: b, c: c, d: d};
	});
var $author$project$Model$Vehicle$ShiftHull = F4(
	function (a, b, c, d) {
		return {$: 12, a: a, b: b, c: c, d: d};
	});
var $surprisetalk$elm_bulma$Bulma$Modifiers$Small = 0;
var $lattyware$elm_fontawesome$FontAwesome$Solid$cogs = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'cogs',
	640,
	512,
	_List_fromArray(
		['M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z']));
var $surprisetalk$elm_bulma$Bulma$Classes$column = $elm$html$Html$Attributes$class('column');
var $surprisetalk$elm_bulma$Bulma$Classes$is01Desktop = $elm$html$Html$Attributes$class('is-1-desktop');
var $surprisetalk$elm_bulma$Bulma$Classes$is01FullHD = $elm$html$Html$Attributes$class('is-1-fullhd');
var $surprisetalk$elm_bulma$Bulma$Classes$is01Mobile = $elm$html$Html$Attributes$class('is-1-mobile');
var $surprisetalk$elm_bulma$Bulma$Classes$is01Tablet = $elm$html$Html$Attributes$class('is-1-tablet');
var $surprisetalk$elm_bulma$Bulma$Classes$is01Widescreen = $elm$html$Html$Attributes$class('is-1-widescreen');
var $surprisetalk$elm_bulma$Bulma$Classes$is02Desktop = $elm$html$Html$Attributes$class('is-2-desktop');
var $surprisetalk$elm_bulma$Bulma$Classes$is02FullHD = $elm$html$Html$Attributes$class('is-2-fullhd');
var $surprisetalk$elm_bulma$Bulma$Classes$is02Mobile = $elm$html$Html$Attributes$class('is-2-mobile');
var $surprisetalk$elm_bulma$Bulma$Classes$is02Tablet = $elm$html$Html$Attributes$class('is-2-tablet');
var $surprisetalk$elm_bulma$Bulma$Classes$is02Widescreen = $elm$html$Html$Attributes$class('is-2-widescreen');
var $surprisetalk$elm_bulma$Bulma$Classes$is03Desktop = $elm$html$Html$Attributes$class('is-3-desktop');
var $surprisetalk$elm_bulma$Bulma$Classes$is03FullHD = $elm$html$Html$Attributes$class('is-3-fullhd');
var $surprisetalk$elm_bulma$Bulma$Classes$is03Mobile = $elm$html$Html$Attributes$class('is-3-mobile');
var $surprisetalk$elm_bulma$Bulma$Classes$is03Tablet = $elm$html$Html$Attributes$class('is-3-tablet');
var $surprisetalk$elm_bulma$Bulma$Classes$is03Widescreen = $elm$html$Html$Attributes$class('is-3-widescreen');
var $surprisetalk$elm_bulma$Bulma$Classes$is04Desktop = $elm$html$Html$Attributes$class('is-4-desktop');
var $surprisetalk$elm_bulma$Bulma$Classes$is04FullHD = $elm$html$Html$Attributes$class('is-4-fullhd');
var $surprisetalk$elm_bulma$Bulma$Classes$is04Mobile = $elm$html$Html$Attributes$class('is-4-mobile');
var $surprisetalk$elm_bulma$Bulma$Classes$is04Tablet = $elm$html$Html$Attributes$class('is-4-tablet');
var $surprisetalk$elm_bulma$Bulma$Classes$is04Widescreen = $elm$html$Html$Attributes$class('is-4-widescreen');
var $surprisetalk$elm_bulma$Bulma$Classes$is05Desktop = $elm$html$Html$Attributes$class('is-5-desktop');
var $surprisetalk$elm_bulma$Bulma$Classes$is05FullHD = $elm$html$Html$Attributes$class('is-5-fullhd');
var $surprisetalk$elm_bulma$Bulma$Classes$is05Mobile = $elm$html$Html$Attributes$class('is-5-mobile');
var $surprisetalk$elm_bulma$Bulma$Classes$is05Tablet = $elm$html$Html$Attributes$class('is-5-tablet');
var $surprisetalk$elm_bulma$Bulma$Classes$is05Widescreen = $elm$html$Html$Attributes$class('is-5-widescreen');
var $surprisetalk$elm_bulma$Bulma$Classes$is06Desktop = $elm$html$Html$Attributes$class('is-6-desktop');
var $surprisetalk$elm_bulma$Bulma$Classes$is06FullHD = $elm$html$Html$Attributes$class('is-6-fullhd');
var $surprisetalk$elm_bulma$Bulma$Classes$is06Mobile = $elm$html$Html$Attributes$class('is-6-mobile');
var $surprisetalk$elm_bulma$Bulma$Classes$is06Tablet = $elm$html$Html$Attributes$class('is-6-tablet');
var $surprisetalk$elm_bulma$Bulma$Classes$is06Widescreen = $elm$html$Html$Attributes$class('is-6-widescreen');
var $surprisetalk$elm_bulma$Bulma$Classes$is07Desktop = $elm$html$Html$Attributes$class('is-7-desktop');
var $surprisetalk$elm_bulma$Bulma$Classes$is07FullHD = $elm$html$Html$Attributes$class('is-7-fullhd');
var $surprisetalk$elm_bulma$Bulma$Classes$is07Mobile = $elm$html$Html$Attributes$class('is-7-mobile');
var $surprisetalk$elm_bulma$Bulma$Classes$is07Tablet = $elm$html$Html$Attributes$class('is-7-tablet');
var $surprisetalk$elm_bulma$Bulma$Classes$is07Widescreen = $elm$html$Html$Attributes$class('is-7-widescreen');
var $surprisetalk$elm_bulma$Bulma$Classes$is08Desktop = $elm$html$Html$Attributes$class('is-8-desktop');
var $surprisetalk$elm_bulma$Bulma$Classes$is08FullHD = $elm$html$Html$Attributes$class('is-8-fullhd');
var $surprisetalk$elm_bulma$Bulma$Classes$is08Mobile = $elm$html$Html$Attributes$class('is-8-mobile');
var $surprisetalk$elm_bulma$Bulma$Classes$is08Tablet = $elm$html$Html$Attributes$class('is-8-tablet');
var $surprisetalk$elm_bulma$Bulma$Classes$is08Widescreen = $elm$html$Html$Attributes$class('is-8-widescreen');
var $surprisetalk$elm_bulma$Bulma$Classes$is09Desktop = $elm$html$Html$Attributes$class('is-9-desktop');
var $surprisetalk$elm_bulma$Bulma$Classes$is09FullHD = $elm$html$Html$Attributes$class('is-9-fullhd');
var $surprisetalk$elm_bulma$Bulma$Classes$is09Mobile = $elm$html$Html$Attributes$class('is-9-mobile');
var $surprisetalk$elm_bulma$Bulma$Classes$is09Tablet = $elm$html$Html$Attributes$class('is-9-tablet');
var $surprisetalk$elm_bulma$Bulma$Classes$is09Widescreen = $elm$html$Html$Attributes$class('is-9-widescreen');
var $surprisetalk$elm_bulma$Bulma$Classes$is10Desktop = $elm$html$Html$Attributes$class('is-10-desktop');
var $surprisetalk$elm_bulma$Bulma$Classes$is10FullHD = $elm$html$Html$Attributes$class('is-10-fullhd');
var $surprisetalk$elm_bulma$Bulma$Classes$is10Mobile = $elm$html$Html$Attributes$class('is-10-mobile');
var $surprisetalk$elm_bulma$Bulma$Classes$is10Tablet = $elm$html$Html$Attributes$class('is-10-tablet');
var $surprisetalk$elm_bulma$Bulma$Classes$is10Widescreen = $elm$html$Html$Attributes$class('is-10-widescreen');
var $surprisetalk$elm_bulma$Bulma$Classes$is11Desktop = $elm$html$Html$Attributes$class('is-11-desktop');
var $surprisetalk$elm_bulma$Bulma$Classes$is11FullHD = $elm$html$Html$Attributes$class('is-11-fullhd');
var $surprisetalk$elm_bulma$Bulma$Classes$is11Mobile = $elm$html$Html$Attributes$class('is-11-mobile');
var $surprisetalk$elm_bulma$Bulma$Classes$is11Tablet = $elm$html$Html$Attributes$class('is-11-tablet');
var $surprisetalk$elm_bulma$Bulma$Classes$is11Widescreen = $elm$html$Html$Attributes$class('is-11-widescreen');
var $surprisetalk$elm_bulma$Bulma$Classes$isNarrowDesktop = $elm$html$Html$Attributes$class('is-narrow-desktop');
var $surprisetalk$elm_bulma$Bulma$Classes$isNarrowFullHD = $elm$html$Html$Attributes$class('is-narrow-fullhd');
var $surprisetalk$elm_bulma$Bulma$Classes$isNarrowMobile = $elm$html$Html$Attributes$class('is-narrow-mobile');
var $surprisetalk$elm_bulma$Bulma$Classes$isNarrowTablet = $elm$html$Html$Attributes$class('is-narrow-tablet');
var $surprisetalk$elm_bulma$Bulma$Classes$isNarrowWidescreen = $elm$html$Html$Attributes$class('is-narrow-widescreen');
var $surprisetalk$elm_bulma$Bulma$Classes$isOffset01 = $elm$html$Html$Attributes$class('is-offset-1');
var $surprisetalk$elm_bulma$Bulma$Classes$isOffset02 = $elm$html$Html$Attributes$class('is-offset-2');
var $surprisetalk$elm_bulma$Bulma$Classes$isOffset03 = $elm$html$Html$Attributes$class('is-offset-3');
var $surprisetalk$elm_bulma$Bulma$Classes$isOffset04 = $elm$html$Html$Attributes$class('is-offset-4');
var $surprisetalk$elm_bulma$Bulma$Classes$isOffset05 = $elm$html$Html$Attributes$class('is-offset-5');
var $surprisetalk$elm_bulma$Bulma$Classes$isOffset06 = $elm$html$Html$Attributes$class('is-offset-6');
var $surprisetalk$elm_bulma$Bulma$Classes$isOffset07 = $elm$html$Html$Attributes$class('is-offset-7');
var $surprisetalk$elm_bulma$Bulma$Classes$isOffset08 = $elm$html$Html$Attributes$class('is-offset-8');
var $surprisetalk$elm_bulma$Bulma$Classes$isOffset09 = $elm$html$Html$Attributes$class('is-offset-9');
var $surprisetalk$elm_bulma$Bulma$Classes$isOffset10 = $elm$html$Html$Attributes$class('is-offset-10');
var $surprisetalk$elm_bulma$Bulma$Classes$isOffset11 = $elm$html$Html$Attributes$class('is-offset-11');
var $surprisetalk$elm_bulma$Bulma$Columns$column = function (_v0) {
	var widths = _v0.aj;
	var offset = _v0.b;
	return A2(
		$surprisetalk$elm_bulma$Helpers$node,
		'div',
		_List_fromArray(
			[
				$surprisetalk$elm_bulma$Bulma$Classes$column,
				function () {
				var _v1 = widths.aC;
				if (!_v1.$) {
					switch (_v1.a) {
						case 0:
							var _v2 = _v1.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$none;
						case 1:
							var _v3 = _v1.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is01Mobile;
						case 2:
							var _v4 = _v1.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is02Mobile;
						case 3:
							var _v5 = _v1.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is03Mobile;
						case 4:
							var _v6 = _v1.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is04Mobile;
						case 5:
							var _v7 = _v1.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is05Mobile;
						case 6:
							var _v8 = _v1.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is06Mobile;
						case 7:
							var _v9 = _v1.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is07Mobile;
						case 8:
							var _v10 = _v1.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is08Mobile;
						case 9:
							var _v11 = _v1.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is09Mobile;
						case 10:
							var _v12 = _v1.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is10Mobile;
						default:
							var _v13 = _v1.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is11Mobile;
					}
				} else {
					return $surprisetalk$elm_bulma$Bulma$Classes$isNarrowMobile;
				}
			}(),
				function () {
				var _v14 = widths.aU;
				if (!_v14.$) {
					switch (_v14.a) {
						case 0:
							var _v15 = _v14.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$none;
						case 1:
							var _v16 = _v14.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is01Tablet;
						case 2:
							var _v17 = _v14.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is02Tablet;
						case 3:
							var _v18 = _v14.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is03Tablet;
						case 4:
							var _v19 = _v14.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is04Tablet;
						case 5:
							var _v20 = _v14.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is05Tablet;
						case 6:
							var _v21 = _v14.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is06Tablet;
						case 7:
							var _v22 = _v14.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is07Tablet;
						case 8:
							var _v23 = _v14.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is08Tablet;
						case 9:
							var _v24 = _v14.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is09Tablet;
						case 10:
							var _v25 = _v14.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is10Tablet;
						default:
							var _v26 = _v14.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is11Tablet;
					}
				} else {
					return $surprisetalk$elm_bulma$Bulma$Classes$isNarrowTablet;
				}
			}(),
				function () {
				var _v27 = widths.aq;
				if (!_v27.$) {
					switch (_v27.a) {
						case 0:
							var _v28 = _v27.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$none;
						case 1:
							var _v29 = _v27.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is01Desktop;
						case 2:
							var _v30 = _v27.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is02Desktop;
						case 3:
							var _v31 = _v27.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is03Desktop;
						case 4:
							var _v32 = _v27.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is04Desktop;
						case 5:
							var _v33 = _v27.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is05Desktop;
						case 6:
							var _v34 = _v27.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is06Desktop;
						case 7:
							var _v35 = _v27.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is07Desktop;
						case 8:
							var _v36 = _v27.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is08Desktop;
						case 9:
							var _v37 = _v27.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is09Desktop;
						case 10:
							var _v38 = _v27.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is10Desktop;
						default:
							var _v39 = _v27.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is11Desktop;
					}
				} else {
					return $surprisetalk$elm_bulma$Bulma$Classes$isNarrowDesktop;
				}
			}(),
				function () {
				var _v40 = widths.aX;
				if (!_v40.$) {
					switch (_v40.a) {
						case 0:
							var _v41 = _v40.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$none;
						case 1:
							var _v42 = _v40.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is01Widescreen;
						case 2:
							var _v43 = _v40.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is02Widescreen;
						case 3:
							var _v44 = _v40.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is03Widescreen;
						case 4:
							var _v45 = _v40.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is04Widescreen;
						case 5:
							var _v46 = _v40.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is05Widescreen;
						case 6:
							var _v47 = _v40.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is06Widescreen;
						case 7:
							var _v48 = _v40.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is07Widescreen;
						case 8:
							var _v49 = _v40.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is08Widescreen;
						case 9:
							var _v50 = _v40.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is09Widescreen;
						case 10:
							var _v51 = _v40.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is10Widescreen;
						default:
							var _v52 = _v40.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is11Widescreen;
					}
				} else {
					return $surprisetalk$elm_bulma$Bulma$Classes$isNarrowWidescreen;
				}
			}(),
				function () {
				var _v53 = widths.as;
				if (!_v53.$) {
					switch (_v53.a) {
						case 0:
							var _v54 = _v53.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$none;
						case 1:
							var _v55 = _v53.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is01FullHD;
						case 2:
							var _v56 = _v53.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is02FullHD;
						case 3:
							var _v57 = _v53.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is03FullHD;
						case 4:
							var _v58 = _v53.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is04FullHD;
						case 5:
							var _v59 = _v53.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is05FullHD;
						case 6:
							var _v60 = _v53.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is06FullHD;
						case 7:
							var _v61 = _v53.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is07FullHD;
						case 8:
							var _v62 = _v53.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is08FullHD;
						case 9:
							var _v63 = _v53.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is09FullHD;
						case 10:
							var _v64 = _v53.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is10FullHD;
						default:
							var _v65 = _v53.a;
							return $surprisetalk$elm_bulma$Bulma$Classes$is11FullHD;
					}
				} else {
					return $surprisetalk$elm_bulma$Bulma$Classes$isNarrowFullHD;
				}
			}(),
				function () {
				switch (offset) {
					case 0:
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					case 1:
						return $surprisetalk$elm_bulma$Bulma$Classes$isOffset01;
					case 2:
						return $surprisetalk$elm_bulma$Bulma$Classes$isOffset02;
					case 3:
						return $surprisetalk$elm_bulma$Bulma$Classes$isOffset03;
					case 4:
						return $surprisetalk$elm_bulma$Bulma$Classes$isOffset04;
					case 5:
						return $surprisetalk$elm_bulma$Bulma$Classes$isOffset05;
					case 6:
						return $surprisetalk$elm_bulma$Bulma$Classes$isOffset06;
					case 7:
						return $surprisetalk$elm_bulma$Bulma$Classes$isOffset07;
					case 8:
						return $surprisetalk$elm_bulma$Bulma$Classes$isOffset08;
					case 9:
						return $surprisetalk$elm_bulma$Bulma$Classes$isOffset09;
					case 10:
						return $surprisetalk$elm_bulma$Bulma$Classes$isOffset10;
					default:
						return $surprisetalk$elm_bulma$Bulma$Classes$isOffset11;
				}
			}()
			]));
};
var $surprisetalk$elm_bulma$Bulma$Modifiers$Auto = 0;
var $surprisetalk$elm_bulma$Bulma$Columns$columnModifiers = {
	b: 0,
	aj: {
		aq: $elm$core$Maybe$Just(0),
		as: $elm$core$Maybe$Just(0),
		aC: $elm$core$Maybe$Just(0),
		aU: $elm$core$Maybe$Just(0),
		aX: $elm$core$Maybe$Just(0)
	}
};
var $surprisetalk$elm_bulma$Bulma$Classes$columns = $elm$html$Html$Attributes$class('columns');
var $surprisetalk$elm_bulma$Bulma$Classes$is0 = $elm$html$Html$Attributes$class('is-0');
var $surprisetalk$elm_bulma$Bulma$Classes$is1 = $elm$html$Html$Attributes$class('is-1');
var $surprisetalk$elm_bulma$Bulma$Classes$is2 = $elm$html$Html$Attributes$class('is-2');
var $surprisetalk$elm_bulma$Bulma$Classes$is4 = $elm$html$Html$Attributes$class('is-4');
var $surprisetalk$elm_bulma$Bulma$Classes$is5 = $elm$html$Html$Attributes$class('is-5');
var $surprisetalk$elm_bulma$Bulma$Classes$is6 = $elm$html$Html$Attributes$class('is-6');
var $surprisetalk$elm_bulma$Bulma$Classes$is7 = $elm$html$Html$Attributes$class('is-7');
var $surprisetalk$elm_bulma$Bulma$Classes$is8 = $elm$html$Html$Attributes$class('is-8');
var $surprisetalk$elm_bulma$Bulma$Classes$isCentered = $elm$html$Html$Attributes$class('is-centered');
var $surprisetalk$elm_bulma$Bulma$Classes$isDesktop = $elm$html$Html$Attributes$class('is-desktop');
var $surprisetalk$elm_bulma$Bulma$Classes$isGapless = $elm$html$Html$Attributes$class('is-gapless');
var $surprisetalk$elm_bulma$Bulma$Classes$isMobile = $elm$html$Html$Attributes$class('is-mobile');
var $surprisetalk$elm_bulma$Bulma$Classes$isMultiline = $elm$html$Html$Attributes$class('is-multiline');
var $surprisetalk$elm_bulma$Bulma$Columns$columns = function (_v0) {
	var centered = _v0.an;
	var multiline = _v0.aD;
	var gap = _v0.au;
	var display = _v0.ar;
	return A2(
		$surprisetalk$elm_bulma$Helpers$node,
		'div',
		_List_fromArray(
			[
				$surprisetalk$elm_bulma$Bulma$Classes$columns,
				function () {
				if (centered) {
					return $surprisetalk$elm_bulma$Bulma$Classes$isCentered;
				} else {
					return $surprisetalk$elm_bulma$Bulma$Classes$none;
				}
			}(),
				function () {
				if (multiline) {
					return $surprisetalk$elm_bulma$Bulma$Classes$isMultiline;
				} else {
					return $surprisetalk$elm_bulma$Bulma$Classes$none;
				}
			}(),
				function () {
				if (!gap) {
					return $surprisetalk$elm_bulma$Bulma$Classes$isGapless;
				} else {
					return $surprisetalk$elm_bulma$Bulma$Classes$none;
				}
			}(),
				function () {
				switch (gap) {
					case 0:
						return $surprisetalk$elm_bulma$Bulma$Classes$is0;
					case 1:
						return $surprisetalk$elm_bulma$Bulma$Classes$is1;
					case 2:
						return $surprisetalk$elm_bulma$Bulma$Classes$is2;
					case 3:
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					case 4:
						return $surprisetalk$elm_bulma$Bulma$Classes$is4;
					case 5:
						return $surprisetalk$elm_bulma$Bulma$Classes$is5;
					case 6:
						return $surprisetalk$elm_bulma$Bulma$Classes$is6;
					case 7:
						return $surprisetalk$elm_bulma$Bulma$Classes$is7;
					default:
						return $surprisetalk$elm_bulma$Bulma$Classes$is8;
				}
			}(),
				function () {
				switch (display) {
					case 0:
						return $surprisetalk$elm_bulma$Bulma$Classes$isMobile;
					case 1:
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					default:
						return $surprisetalk$elm_bulma$Bulma$Classes$isDesktop;
				}
			}()
			]));
};
var $surprisetalk$elm_bulma$Bulma$Columns$Gap3 = 3;
var $surprisetalk$elm_bulma$Bulma$Columns$TabletAndBeyond = 1;
var $surprisetalk$elm_bulma$Bulma$Columns$columnsModifiers = {an: false, ar: 1, au: 3, aD: false};
var $surprisetalk$elm_bulma$Bulma$Classes$level = $elm$html$Html$Attributes$class('level');
var $surprisetalk$elm_bulma$Bulma$Layout$level = A2(
	$surprisetalk$elm_bulma$Helpers$node,
	'nav',
	_List_fromArray(
		[$surprisetalk$elm_bulma$Bulma$Classes$level]));
var $surprisetalk$elm_bulma$Bulma$Classes$levelItem = $elm$html$Html$Attributes$class('level-item');
var $surprisetalk$elm_bulma$Bulma$Layout$levelItem = A2(
	$surprisetalk$elm_bulma$Helpers$node,
	'div',
	_List_fromArray(
		[$surprisetalk$elm_bulma$Bulma$Classes$levelItem]));
var $lattyware$elm_fontawesome$FontAwesome$Solid$minus = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'minus',
	448,
	512,
	_List_fromArray(
		['M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z']));
var $author$project$View$Vehicle$counterElement = F6(
	function (icon_, min, max, counterValue, decrementMsg, incrementMsg) {
		return A2(
			$surprisetalk$elm_bulma$Bulma$Layout$level,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-mobile')
				]),
			_List_fromArray(
				[
					A2(
					$surprisetalk$elm_bulma$Bulma$Layout$levelItem,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							$surprisetalk$elm_bulma$Bulma$Form$controlButton,
							_Utils_update(
								$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
								{
									cC: $elm$core$Maybe$Just(
										_Utils_Tuple3(1, _List_Nil, icon_)),
									dg: 0
								}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Model$Model$VehicleMsg(
										A2(decrementMsg, min, max))),
									$elm$html$Html$Attributes$disabled(
									_Utils_eq(min, counterValue))
								]),
							_List_fromArray(
								[
									$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$minus)
								]))
						])),
					A2(
					$surprisetalk$elm_bulma$Bulma$Layout$levelItem,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'min-width', '3rem')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(counterValue))
						])),
					A2(
					$surprisetalk$elm_bulma$Bulma$Layout$levelItem,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							$surprisetalk$elm_bulma$Bulma$Form$controlButton,
							_Utils_update(
								$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
								{dg: 0}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Model$Model$VehicleMsg(
										A2(incrementMsg, min, max))),
									$elm$html$Html$Attributes$disabled(
									_Utils_cmp(counterValue, max) > -1)
								]),
							_List_fromArray(
								[
									$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$plus)
								]))
						]))
				]));
	});
var $author$project$View$Utils$crewUsed = function (v) {
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			function (x) {
				return x.dm === 1;
			},
			v.dG));
};
var $author$project$View$Weapon$RenderConfig = F5(
	function (showFireButton, previewSpecials, printSpecials, showDeleteButton, highlightRow) {
		return {bd: highlightRow, bx: previewSpecials, c7: printSpecials, de: showDeleteButton, df: showFireButton};
	});
var $author$project$View$Weapon$defaultWeaponConfig = A5($author$project$View$Weapon$RenderConfig, true, true, false, true, false);
var $surprisetalk$elm_bulma$Bulma$Elements$H5 = 4;
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $surprisetalk$elm_bulma$Bulma$Classes$levelLeft = $elm$html$Html$Attributes$class('level-left');
var $surprisetalk$elm_bulma$Bulma$Layout$levelLeft = A2(
	$surprisetalk$elm_bulma$Helpers$node,
	'div',
	_List_fromArray(
		[$surprisetalk$elm_bulma$Bulma$Classes$levelLeft]));
var $surprisetalk$elm_bulma$Bulma$Classes$levelRight = $elm$html$Html$Attributes$class('level-right');
var $surprisetalk$elm_bulma$Bulma$Layout$levelRight = A2(
	$surprisetalk$elm_bulma$Helpers$node,
	'div',
	_List_fromArray(
		[$surprisetalk$elm_bulma$Bulma$Classes$levelRight]));
var $surprisetalk$elm_bulma$Bulma$Classes$is3 = $elm$html$Html$Attributes$class('is-3');
var $surprisetalk$elm_bulma$Bulma$Classes$title = $elm$html$Html$Attributes$class('title');
var $surprisetalk$elm_bulma$Bulma$Elements$title = function (size) {
	return A2(
		$surprisetalk$elm_bulma$Helpers$node,
		function () {
			switch (size) {
				case 0:
					return 'h1';
				case 1:
					return 'h2';
				case 2:
					return 'h3';
				case 3:
					return 'h4';
				case 4:
					return 'h5';
				default:
					return 'h6';
			}
		}(),
		_List_fromArray(
			[
				$surprisetalk$elm_bulma$Bulma$Classes$title,
				function () {
				switch (size) {
					case 0:
						return $surprisetalk$elm_bulma$Bulma$Classes$is1;
					case 1:
						return $surprisetalk$elm_bulma$Bulma$Classes$is2;
					case 2:
						return $surprisetalk$elm_bulma$Bulma$Classes$is3;
					case 3:
						return $surprisetalk$elm_bulma$Bulma$Classes$is4;
					case 4:
						return $surprisetalk$elm_bulma$Bulma$Classes$is5;
					default:
						return $surprisetalk$elm_bulma$Bulma$Classes$is6;
				}
			}()
			]));
};
var $author$project$View$Utils$detailSection = F3(
	function (titleString, detailButtons, bodyContents) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					A2(
					$surprisetalk$elm_bulma$Bulma$Layout$level,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-mobile')
						]),
					_List_fromArray(
						[
							A2(
							$surprisetalk$elm_bulma$Bulma$Layout$levelLeft,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$surprisetalk$elm_bulma$Bulma$Layout$levelItem,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$surprisetalk$elm_bulma$Bulma$Elements$title,
											4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(titleString)
												]))
										]))
								])),
							A2(
							$surprisetalk$elm_bulma$Bulma$Layout$levelRight,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'is-hidden',
											$elm$core$List$isEmpty(detailButtons))
										]))
								]),
							_List_fromArray(
								[
									A2($surprisetalk$elm_bulma$Bulma$Layout$levelItem, _List_Nil, detailButtons)
								]))
						])),
					A2($elm$html$Html$div, _List_Nil, bodyContents)
				]));
	});
var $surprisetalk$elm_bulma$Bulma$Classes$isBlock = $elm$html$Html$Attributes$class('is-block');
var $surprisetalk$elm_bulma$Bulma$Classes$isFlex = $elm$html$Html$Attributes$class('is-flex');
var $surprisetalk$elm_bulma$Bulma$Classes$isHidden = $elm$html$Html$Attributes$class('is-hidden');
var $surprisetalk$elm_bulma$Bulma$Classes$isInline = $elm$html$Html$Attributes$class('is-inline');
var $surprisetalk$elm_bulma$Bulma$Classes$isInlineBlock = $elm$html$Html$Attributes$class('is-inline-block');
var $surprisetalk$elm_bulma$Bulma$Classes$isInlineFlex = $elm$html$Html$Attributes$class('is-inline-flex');
var $surprisetalk$elm_bulma$Bulma$Modifiers$display = function (d) {
	switch (d) {
		case 0:
			return $surprisetalk$elm_bulma$Bulma$Classes$isBlock;
		case 1:
			return $surprisetalk$elm_bulma$Bulma$Classes$isFlex;
		case 3:
			return $surprisetalk$elm_bulma$Bulma$Classes$isInline;
		case 4:
			return $surprisetalk$elm_bulma$Bulma$Classes$isInlineBlock;
		case 5:
			return $surprisetalk$elm_bulma$Bulma$Classes$isInlineFlex;
		default:
			return $surprisetalk$elm_bulma$Bulma$Classes$isHidden;
	}
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$exclamationTriangle = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'exclamation-triangle',
	576,
	512,
	_List_fromArray(
		['M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z']));
var $elm$html$Html$Attributes$hidden = $elm$html$Html$Attributes$boolProperty('hidden');
var $elm$core$Basics$modBy = _Basics_modBy;
var $surprisetalk$elm_bulma$Bulma$Classes$field = $elm$html$Html$Attributes$class('field');
var $surprisetalk$elm_bulma$Bulma$Classes$isGrouped = $elm$html$Html$Attributes$class('is-grouped');
var $surprisetalk$elm_bulma$Bulma$Classes$isGroupedMultiline = $elm$html$Html$Attributes$class('is-grouped-multiline');
var $surprisetalk$elm_bulma$Bulma$Form$multilineFields = A2(
	$surprisetalk$elm_bulma$Helpers$node,
	'div',
	_List_fromArray(
		[$surprisetalk$elm_bulma$Bulma$Classes$field, $surprisetalk$elm_bulma$Bulma$Classes$isGrouped, $surprisetalk$elm_bulma$Bulma$Classes$isGroupedMultiline]));
var $author$project$Model$Upgrade$DeleteUpgrade = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Model$Model$UpgradeMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$View$Utils$plural = function (i) {
	if (i === 1) {
		return '';
	} else {
		return 's';
	}
};
var $surprisetalk$elm_bulma$Bulma$Elements$H6 = 5;
var $lattyware$elm_fontawesome$FontAwesome$Solid$times = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'times',
	352,
	512,
	_List_fromArray(
		['M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z']));
var $author$project$View$EquipmentLayout$render = F5(
	function (attrs, thing, mRemoveMsg, factsHolderBody, specialsBody) {
		var deleteButton = function () {
			if (mRemoveMsg.$ === 1) {
				return $elm$html$Html$text('');
			} else {
				var removeMsg = mRemoveMsg.a;
				return A4(
					$surprisetalk$elm_bulma$Bulma$Form$controlButton,
					_Utils_update(
						$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
						{
							b9: 10,
							cC: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									1,
									_List_Nil,
									$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$times))),
							dg: 0
						}),
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							removeMsg(thing)),
							A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
						]),
					_List_Nil);
			}
		}();
		return A2(
			$elm$html$Html$div,
			attrs,
			_List_fromArray(
				[
					A2(
					$surprisetalk$elm_bulma$Bulma$Layout$level,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-mobile')
						]),
					_List_fromArray(
						[
							A2(
							$surprisetalk$elm_bulma$Bulma$Layout$levelLeft,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$surprisetalk$elm_bulma$Bulma$Layout$levelItem,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$surprisetalk$elm_bulma$Bulma$Elements$title,
											5,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(thing.cK)
												]))
										]))
								])),
							A2(
							$surprisetalk$elm_bulma$Bulma$Layout$levelRight,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$surprisetalk$elm_bulma$Bulma$Layout$levelItem,
									_List_Nil,
									_List_fromArray(
										[deleteButton]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('facts-holder')
						]),
					factsHolderBody),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('special-holder')
						]),
					specialsBody)
				]));
	});
var $surprisetalk$elm_bulma$Bulma$Classes$label = $elm$html$Html$Attributes$class('label');
var $surprisetalk$elm_bulma$Bulma$Form$label = A2(
	$surprisetalk$elm_bulma$Helpers$node,
	'label',
	_List_fromArray(
		[$surprisetalk$elm_bulma$Bulma$Classes$label]));
var $surprisetalk$elm_bulma$Bulma$Form$controlLabel = $surprisetalk$elm_bulma$Bulma$Form$label;
var $surprisetalk$elm_bulma$Bulma$Form$field = A2(
	$surprisetalk$elm_bulma$Helpers$node,
	'div',
	_List_fromArray(
		[$surprisetalk$elm_bulma$Bulma$Classes$field]));
var $surprisetalk$elm_bulma$Bulma$Classes$fieldBody = $elm$html$Html$Attributes$class('field-body');
var $surprisetalk$elm_bulma$Bulma$Form$fieldBody = A2(
	$surprisetalk$elm_bulma$Helpers$node,
	'div',
	_List_fromArray(
		[$surprisetalk$elm_bulma$Bulma$Classes$fieldBody]));
var $surprisetalk$elm_bulma$Bulma$Classes$fieldLabel = $elm$html$Html$Attributes$class('field-label');
var $surprisetalk$elm_bulma$Bulma$Form$fieldLabel = function (size) {
	return A2(
		$surprisetalk$elm_bulma$Helpers$node,
		'div',
		_List_fromArray(
			[
				$surprisetalk$elm_bulma$Bulma$Classes$fieldLabel,
				function () {
				switch (size) {
					case 0:
						return $surprisetalk$elm_bulma$Bulma$Classes$isSmall;
					case 1:
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					case 2:
						return $surprisetalk$elm_bulma$Bulma$Classes$isMedium;
					default:
						return $surprisetalk$elm_bulma$Bulma$Classes$isLarge;
				}
			}()
			]));
};
var $surprisetalk$elm_bulma$Bulma$Classes$isHorizontal = $elm$html$Html$Attributes$class('is-horizontal');
var $surprisetalk$elm_bulma$Bulma$Form$horizontalFields = A2(
	$surprisetalk$elm_bulma$Helpers$node,
	'div',
	_List_fromArray(
		[$surprisetalk$elm_bulma$Bulma$Classes$field, $surprisetalk$elm_bulma$Bulma$Classes$isHorizontal]));
var $author$project$View$Utils$renderSpecialRow = function (mHeaderBody) {
	if (mHeaderBody.$ === 1) {
		return A2($elm$html$Html$div, _List_Nil, _List_Nil);
	} else {
		var _v1 = mHeaderBody.a;
		var label = _v1.a;
		var body = _v1.b;
		return A2(
			$surprisetalk$elm_bulma$Bulma$Form$horizontalFields,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$surprisetalk$elm_bulma$Bulma$Form$fieldLabel,
					1,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$surprisetalk$elm_bulma$Bulma$Form$controlLabel,
							_List_Nil,
							_List_fromArray(
								[label]))
						])),
					A2(
					$surprisetalk$elm_bulma$Bulma$Form$fieldBody,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$surprisetalk$elm_bulma$Bulma$Form$field,
							_List_Nil,
							_List_fromArray(
								[body]))
						]))
				]));
	}
};
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $surprisetalk$elm_bulma$Bulma$Classes$checkbox = $elm$html$Html$Attributes$class('checkbox');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $surprisetalk$elm_bulma$Bulma$Form$controlCheckBox = F5(
	function (disabled, attrs, attrs_, attrs__, htmls) {
		return A3(
			$surprisetalk$elm_bulma$Bulma$Form$control,
			$surprisetalk$elm_bulma$Bulma$Form$controlModifiers,
			attrs,
			$surprisetalk$elm_bulma$Helpers$ls(
				A4(
					$surprisetalk$elm_bulma$Helpers$node,
					'label',
					_List_fromArray(
						[
							$elm$html$Html$Attributes$disabled(disabled),
							$surprisetalk$elm_bulma$Bulma$Classes$checkbox
						]),
					attrs_,
					A2(
						$elm$core$List$cons,
						A4(
							$surprisetalk$elm_bulma$Helpers$node,
							'input',
							_List_fromArray(
								[
									$elm$html$Html$Attributes$disabled(disabled),
									$elm$html$Html$Attributes$type_('checkbox')
								]),
							attrs__,
							_List_Nil),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$text(' '),
							htmls)))));
	});
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$View$Utils$renderCountDown = F3(
	function (msg, event, checks) {
		var checkboxFunc = F2(
			function (index, check) {
				return A5(
					$surprisetalk$elm_bulma$Bulma$Form$controlCheckBox,
					false,
					_List_Nil,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(
							$elm$core$String$fromInt(index)),
							$elm$html$Html$Attributes$checked(check),
							$elm$html$Html$Events$onCheck(
							A2(
								$elm$core$Basics$composeL,
								msg,
								event(index)))
						]),
					_List_Nil);
			});
		return A2(
			$surprisetalk$elm_bulma$Bulma$Form$multilineFields,
			_List_Nil,
			A2($elm$core$List$indexedMap, checkboxFunc, checks));
	});
var $author$project$Model$Shared$needPlus = function (i) {
	var _v0 = A2($elm$core$Basics$compare, i, 0);
	if (!_v0) {
		return $elm$core$String$fromInt(i);
	} else {
		return '+' + $elm$core$String$fromInt(i);
	}
};
var $author$project$Model$Shared$specialToNamedSpecial = function (special) {
	switch (special.$) {
		case 0:
			var count = special.a;
			return A2(
				$author$project$Model$Shared$NamedSpecialRule,
				'Ammo',
				$elm$core$String$fromInt(
					$elm$core$List$length(count)));
		case 1:
			var rule = special.a;
			return A2($author$project$Model$Shared$NamedSpecialRule, 'Note', rule);
		case 2:
			var name = special.a;
			var rule = special.b;
			return A2($author$project$Model$Shared$NamedSpecialRule, name, rule);
		case 3:
			return A2($author$project$Model$Shared$NamedSpecialRule, 'Blast', 'For every un-cancelled hit caused by a weapon or effect with the Blast rule, the target immediately gains 1 Hazard Token.');
		case 6:
			return A2($author$project$Model$Shared$NamedSpecialRule, 'Blitz', 'This Vehicle counts as being armed with a number of copies of this weapon equal to this weapon\'s remaining Ammo Tokens, where each copy counts as having a single Ammo Token. this means that during its Attack Step, this vehicle may attack with this weapon any number of times, as long as it doesn\'t attack more times than it has Ammo Tokens, and doesn\'t attack more times than its Crew Value.');
		case 4:
			var size = special.a;
			return A2(
				$author$project$Model$Shared$NamedSpecialRule,
				$author$project$Model$Shared$stringFromSize(size) + ' Burst',
				'Burst templates based on size.');
		case 5:
			return A2($author$project$Model$Shared$NamedSpecialRule, 'Fire', 'If a vehicle suffers at least one damage from a weapon or effect with the first special rule, it gains the On-Fire rule in addition to suffering damage. A vehicle cannot gain the On-Fire rule a second time.\n\nOn Fire: At the start of this vehicle\'s activation, it loses 1 Hull Point. This vehile\'s Smash Attacks count as having the Fire special rule. If this vehicle ever has zero Hazard Tokens, the fire goes out and this vehicle loses the On-Fire rule.');
		case 7:
			return A2($author$project$Model$Shared$NamedSpecialRule, 'Electrical', 'This thing is electrical.');
		case 8:
			var i = special.a;
			return A2(
				$author$project$Model$Shared$NamedSpecialRule,
				'Handling Mod',
				$author$project$Model$Shared$needPlus(i) + ' modification to the vehicle\'s base Handling value.');
		case 9:
			var i = special.a;
			return A2(
				$author$project$Model$Shared$NamedSpecialRule,
				'Hull Mod',
				$author$project$Model$Shared$needPlus(i) + ' modification to the vehicle\'s base Hull value.');
		case 10:
			var i = special.a;
			return A2(
				$author$project$Model$Shared$NamedSpecialRule,
				'Gear Mod',
				$author$project$Model$Shared$needPlus(i) + ' modification to the vehicle\'s maximum Gear.');
		case 11:
			var i = special.a;
			return A2(
				$author$project$Model$Shared$NamedSpecialRule,
				'Crew Mod',
				$author$project$Model$Shared$needPlus(i) + ' modification to the vehicle\'s base Crew value.');
		case 12:
			var i = special.a;
			return A2(
				$author$project$Model$Shared$NamedSpecialRule,
				'Slot Mod',
				$author$project$Model$Shared$needPlus(i) + ' modification to the vehicle\'s base Slot value.');
		case 13:
			return A2($author$project$Model$Shared$NamedSpecialRule, 'Indirect', 'When making a shooting attack with a weapon with this special rule, the vehicle may ignore Terrain and Cover during that attack.');
		case 14:
			return A2($author$project$Model$Shared$NamedSpecialRule, 'Splash', 'When a weapon with the splash rule is used to attack, the weapon must target, and attack, every vehicle beneath the shooting template, including friendly vehicles. Each target must suffer a separate attack from the weapon.');
		default:
			return A2($author$project$Model$Shared$NamedSpecialRule, 'Full Fire Arc', 'Weapon has a 360-degree Arc of Fire.');
	}
};
var $author$project$View$Utils$specialToText = function (special) {
	if (special.$ === 2) {
		var name = special.a;
		var rule = special.b;
		return _Utils_Tuple2(
			$elm$html$Html$text(name),
			$elm$html$Html$text(rule));
	} else {
		return $author$project$View$Utils$specialToText(
			$author$project$Model$Shared$specialToNamedSpecial(special));
	}
};
var $author$project$View$Utils$specialToHeaderBody = F5(
	function (isPreview, isPrinting, mMsg, mEvent, special) {
		var _v0 = _Utils_Tuple3(special, mMsg, mEvent);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				if (!_v0.c.$) {
					var ammo = _v0.a.a;
					var msg = _v0.b.a;
					var event = _v0.c.a;
					var _v1 = _Utils_Tuple2(isPreview, isPrinting);
					if (_v1.a) {
						return $elm$core$Maybe$Just(
							$author$project$View$Utils$specialToText(special));
					} else {
						if (_v1.b) {
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$elm$html$Html$text('Ammo'),
									A2(
										$elm$html$Html$div,
										_List_Nil,
										A2(
											$elm$core$List$repeat,
											$elm$core$List$length(ammo),
											A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('hazard-check')
													]),
												_List_Nil)))));
						} else {
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$elm$html$Html$text('Ammo'),
									A3($author$project$View$Utils$renderCountDown, msg, event, ammo)));
						}
					}
				} else {
					var _v3 = _v0.c;
					return $elm$core$Maybe$Nothing;
				}
			} else {
				var _v2 = _v0.b;
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Just(
				$author$project$View$Utils$specialToText(special));
		}
	});
var $author$project$View$Utils$tagGen = F2(
	function (_v0, _v1) {
		var title = _v0.a;
		var titleColor = _v0.b;
		var mValue = _v1.a;
		var valueColor = _v1.b;
		var titleTag = A3(
			$surprisetalk$elm_bulma$Bulma$Elements$easyTag,
			_Utils_update(
				$surprisetalk$elm_bulma$Bulma$Elements$tagModifiers,
				{b9: titleColor}),
			_List_Nil,
			title);
		if (mValue.$ === 1) {
			return A2(
				$surprisetalk$elm_bulma$Bulma$Elements$multitag,
				_List_Nil,
				_List_fromArray(
					[titleTag]));
		} else {
			var value = mValue.a;
			return A2(
				$surprisetalk$elm_bulma$Bulma$Elements$multitag,
				_List_Nil,
				_List_fromArray(
					[
						titleTag,
						A3(
						$surprisetalk$elm_bulma$Bulma$Elements$easyTag,
						_Utils_update(
							$surprisetalk$elm_bulma$Bulma$Elements$tagModifiers,
							{b9: valueColor}),
						_List_Nil,
						value)
					]));
		}
	});
var $author$project$View$Upgrade$render = F4(
	function (cfg, model, vehicle, upgrade) {
		var slotsTakenBadge = _Utils_Tuple2(
			'slot' + ($author$project$View$Utils$plural(upgrade.di) + ' used'),
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(upgrade.di)));
		var renderSpecialsFunc = function (specialList) {
			return A2(
				$elm$core$List$map,
				$author$project$View$Utils$renderSpecialRow,
				A2(
					$elm$core$List$map,
					A4($author$project$View$Utils$specialToHeaderBody, cfg.bx, cfg.c7, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
					specialList));
		};
		var specials = function () {
			var _v1 = upgrade.dj;
			if (!_v1.b) {
				return $elm$html$Html$text('No special rules.');
			} else {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					renderSpecialsFunc(upgrade.dj));
			}
		}();
		var pointBadge = _Utils_Tuple2(
			'point' + $author$project$View$Utils$plural(upgrade.cb),
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(upgrade.cb)));
		var factsHolder = A2(
			$surprisetalk$elm_bulma$Bulma$Form$multilineFields,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (t) {
					return A3(
						$surprisetalk$elm_bulma$Bulma$Form$control,
						$surprisetalk$elm_bulma$Bulma$Form$controlModifiers,
						_List_Nil,
						_List_fromArray(
							[t]));
				},
				A2(
					$elm$core$List$map,
					function (_v0) {
						var title = _v0.a;
						var value = _v0.b;
						return A2(
							$author$project$View$Utils$tagGen,
							_Utils_Tuple2(title, 2),
							_Utils_Tuple2(value, 7));
					},
					_List_fromArray(
						[slotsTakenBadge, pointBadge]))));
		return A5(
			$author$project$View$EquipmentLayout$render,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('upgrade'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('alternate', cfg.bd)
						]))
				]),
			upgrade,
			$elm$core$Maybe$Just(
				A2(
					$elm$core$Basics$composeL,
					$author$project$Model$Model$UpgradeMsg,
					$author$project$Model$Upgrade$DeleteUpgrade(vehicle.cH))),
			_List_fromArray(
				[factsHolder]),
			_List_fromArray(
				[specials]));
	});
var $author$project$Model$Weapon$DeleteWeapon = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Model$Weapon$SetWeaponFired = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Model$Weapon$UpdateAmmoUsed = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $author$project$Model$Weapon$Common$fromDice = function (dice) {
	return $elm$core$String$fromInt(dice.cV) + ('d' + $elm$core$String$fromInt(dice.ce));
};
var $author$project$Model$Vehicle$Common$totalCrew = function (v) {
	var crewFilter = function (m) {
		if (m.$ === 11) {
			return true;
		} else {
			return false;
		}
	};
	return v.cc + A2($author$project$Model$Vehicle$Common$totalForModType, v.dD, crewFilter);
};
var $author$project$View$Weapon$render = F4(
	function (cfg, model, vehicle, weapon) {
		var slotsTakenBadge = _Utils_Tuple2(
			'slot' + ($author$project$View$Utils$plural(weapon.di) + ' used'),
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(weapon.di)));
		var renderSpecialsFunc = function (specialList) {
			return A2(
				$elm$core$List$map,
				$author$project$View$Utils$renderSpecialRow,
				A2(
					$elm$core$List$map,
					A4(
						$author$project$View$Utils$specialToHeaderBody,
						cfg.bx,
						cfg.c7,
						$elm$core$Maybe$Just($author$project$Model$Model$WeaponMsg),
						$elm$core$Maybe$Just(
							A2($author$project$Model$Weapon$UpdateAmmoUsed, vehicle.cH, weapon))),
					specialList));
		};
		var specials = function () {
			var _v11 = weapon.dj;
			if (!_v11.b) {
				return $elm$html$Html$text('No special rules.');
			} else {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					renderSpecialsFunc(weapon.dj));
			}
		}();
		var rangeBadge = _Utils_Tuple2(
			'range',
			$elm$core$Maybe$Just(
				$author$project$Model$Weapon$Common$fromWeaponRange(weapon.c8)));
		var previewDamage = function () {
			var _v10 = weapon.b2;
			if (_v10.$ === 1) {
				return _Utils_Tuple2(
					'damage',
					$elm$core$Maybe$Just('none'));
			} else {
				var attack = _v10.a;
				return _Utils_Tuple2(
					'damage',
					$elm$core$Maybe$Just(
						$author$project$Model$Weapon$Common$fromDice(attack)));
			}
		}();
		var pointBadge = _Utils_Tuple2(
			'point' + $author$project$View$Utils$plural(
				$author$project$Model$Weapon$Common$weaponCost(weapon)),
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(
					$author$project$Model$Weapon$Common$weaponCost(weapon))));
		var mountPoint = function () {
			var _v8 = weapon.cJ;
			if (!_v8.$) {
				if (_v8.a === 5) {
					var _v9 = _v8.a;
					return _Utils_Tuple2(
						$author$project$Model$Weapon$Common$fromWeaponMounting(5),
						$elm$core$Maybe$Nothing);
				} else {
					var point = _v8.a;
					return _Utils_Tuple2(
						$author$project$Model$Weapon$Common$fromWeaponMounting(point),
						$elm$core$Maybe$Nothing);
				}
			} else {
				return _Utils_Tuple2('No mount point', $elm$core$Maybe$Nothing);
			}
		}();
		var firingToggle = function () {
			var _v7 = weapon.dm;
			if (!_v7) {
				return $author$project$Model$Model$WeaponMsg(
					A2($author$project$Model$Weapon$SetWeaponFired, vehicle.cH, weapon));
			} else {
				return $author$project$Model$Model$WeaponMsg(
					A2($author$project$Model$Weapon$SetWeaponFired, vehicle.cH, weapon));
			}
		}();
		var factsHolder = A2(
			$surprisetalk$elm_bulma$Bulma$Form$multilineFields,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('weapon-facts')
				]),
			A2(
				$elm$core$List$map,
				function (t) {
					return A3(
						$surprisetalk$elm_bulma$Bulma$Form$control,
						$surprisetalk$elm_bulma$Bulma$Form$controlModifiers,
						_List_Nil,
						_List_fromArray(
							[t]));
				},
				A2(
					$elm$core$List$map,
					function (_v6) {
						var title = _v6.a;
						var value = _v6.b;
						return A2(
							$author$project$View$Utils$tagGen,
							_Utils_Tuple2(title, 2),
							_Utils_Tuple2(value, 7));
					},
					_List_fromArray(
						[mountPoint, slotsTakenBadge, previewDamage, rangeBadge, pointBadge]))));
		var deleteMsg = function () {
			var _v5 = cfg.de;
			if (_v5) {
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Basics$composeL,
						$author$project$Model$Model$WeaponMsg,
						$author$project$Model$Weapon$DeleteWeapon(vehicle.cH)));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var crewAvailable = _Utils_cmp(
			$author$project$View$Utils$crewUsed(vehicle),
			$author$project$Model$Vehicle$Common$totalCrew(vehicle)) < 0;
		var canFire = function () {
			var _v2 = _Utils_Tuple2(weapon.dm, crewAvailable);
			_v2$2:
			while (true) {
				if (!_v2.a) {
					if (_v2.b) {
						var _v3 = _v2.a;
						return true;
					} else {
						break _v2$2;
					}
				} else {
					if (!_v2.b) {
						var _v4 = _v2.a;
						return false;
					} else {
						break _v2$2;
					}
				}
			}
			return false;
		}();
		var attackResult = function () {
			var _v1 = weapon.b3;
			if (!_v1) {
				return $elm$html$Html$text('');
			} else {
				var i = _v1;
				return $elm$html$Html$text(
					' (rolled ' + ($elm$core$String$fromInt(i) + ')'));
			}
		}();
		var _v0 = $author$project$Model$Shared$getAmmoClip(weapon.dj);
		var mCurrentClip = _v0.b;
		return A5(
			$author$project$View$EquipmentLayout$render,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('weapon'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('alternate', cfg.bd)
						]))
				]),
			weapon,
			deleteMsg,
			_List_fromArray(
				[factsHolder]),
			_List_fromArray(
				[specials]));
	});
var $author$project$Model$Sponsors$aggression = _List_fromArray(
	[
		A3($author$project$Model$Sponsors$VehiclePerk, 'Double-Barreled', 2, 'During the attack step, up to 3 crewmembers in this vehicle may gain a +1 bonus to hit when shooting with a handgun.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Boarding Party', 2, 'This vehicle ignores the distracted rule. Crewmembers in this vehicle may attack during the attack step even if the vehicle is distracted.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Battlehammer', 4, 'When making a smash attack, this vehicle gains +1 attack dice for each hazard token it currently has.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Terrifying Lunatic', 5, 'Whenever a vehicle controlled by another player ends its movement step within short range of this vehicle, the active vehicle gains a hazard token.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Grinderman', 5, 'Before this vehicle rolls its attack dice in a smash attack, it may choose to add hazard tokens to the target vehicle for each damage it inflicts, instead of removing hull points.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Murder Tractor', 5, 'This vehicle may make piledriver attacks, like a War Rig.')
	]);
var $author$project$Model$Sponsors$badass = _List_fromArray(
	[
		A3($author$project$Model$Sponsors$VehiclePerk, 'Powder Keg', 1, 'This vehicle may add +1 to its explosion check. Treat this vehicle as one weight-class heavier when it explodes. NOTE: this bonus does apply during resolution of the FIREWORKS perk.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Crowd Pleaser', 1, 'If this vehicle wipes out, gain 1 audience vote.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Road Warrior', 2, 'If this vehicle successfully causes one or more hits on an enemy vehicle at any point during its activation, this vehicle may remove a single hazard token for free at the end of its activation.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Cover Me', 2, 'Once during its activation, this vehicle may remove a hazard token and place it on anther friendly vehicle within double range.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Madman', 3, 'At the end of this vehicle\'s activation, if it has 4 or more hazard tokens, it may remove a hazard token and place it on another vehicle within medium range.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Bullet-Time', 3, 'If this vehicle resolves a Slide result during its Movement Step, this may select one of its weapons to count as Turret-mounted for the rest of the activation.')
	]);
var $author$project$Model$Sponsors$built = _List_fromArray(
	[
		A3($author$project$Model$Sponsors$VehiclePerk, 'Dead Weight', 2, 'During this vehicle\'s Attack Step, this vehicle may gain 2 Hazard Tokens to count as one weight-class heavier (unless already Heavyweight) until the start of its next activation.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Barrel Roll', 2, 'When this vehicle suffers a Flip, it may choose to place the Flip template touching the centre of either side edge or the rear edge of this vehicle, and perpendicular to that edge, instead of touching the front edge as normal.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Bruiser', 4, 'In a Collision involving this vehicle, if this vehicle declares a reaction other than Evade against an enemy vehicle, the vehicle immediately gains one Hazard Token.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Splashback', 5, 'Once per step, when this vehicle loses one or more Hull Points, make a 1D6 attack against each vehicle within Medium range at end of that step.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Crusher', 7, 'This vehicle gains the Up and Over special rule (See the Monster Truck rules, page 71).'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Feel No Pain', 8, 'During an enemy vehicle\'s Attack Step, after an attacker has rolled all their attack dice against this vehicle, if the attacks caused a total of 2 or fewer uncancelled hits, cancel all remaining hits.')
	]);
var $author$project$Model$Sponsors$daring = _List_fromArray(
	[
		A3($author$project$Model$Sponsors$VehiclePerk, 'Chrome-Whisperer', 2, 'This vehicle may push it any number of times during a single skid check, gaining +1 hazard token each time.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Slippery', 3, 'Vehicles making a smash attack targeting this vehicle suffer a penalty of -2 attack dice.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Handbrake Artist', 3, 'When applying a Spin result, this vehicle may choose to face any direction.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Evasive', 5, 'This vehicle counts a roll of a 5+ as a success during an evade attempt.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Powerslide', 5, 'This vehicle may use any template except the long straight template instead of the slide template when applying a slide result. As with the movement step 1.1, you must use the first maneuver template you touch. Treat the selected maneuver template as a slide template for purposes of finding the vehicle\'s final position.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Stunt Driver', 7, 'This perk may only be taken on a lightweight or middleweight vehicle type with a base Handling Value of 3 or more. This vehicle may choose to ignore any number of obstructions during its movement step. After any movement step in which this vehicle chooses to ignore any obstruction using this ability, this vehicle immediately gains 3 hazard tokens.')
	]);
var $author$project$Model$Sponsors$horror = _List_fromArray(
	[
		A3($author$project$Model$Sponsors$VehiclePerk, 'Purifying Flames', 1, 'Once per activation, at the start of this vehicle\'s activation, this vehicle may suffer up to three damage to select any friendly vehicle. For each point of damage suffered via this effect, repair that number of Hull Points on the target vehicle. This damage may not be reduced. This damage counts as having the Fire rule. This effect may not be used to raise a vehicle above its starting Hull Value.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Ecstatic Visions', 1, 'Once per activation, at the start of this vehicle\'s activation, this vehicle may gain up to 3 Hazard Tokens to discard 1 Hazard Token from a friendly vehicle for each Hazard Token gained.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Sympathy For The Devil', 1, 'When this vehicle makes an Evade check, its controller may select a friendly vehicle within Medium range. Add the current Gear of the selected vehicle to this vehicle\'s current Gear for the purposes of this evade check. Both the selected vehicle and this vehicle suffer any unsaved damage from this attack, including any additional effects.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Highway To Hell', 2, 'At the end of its Movement Step, if this vehicle selected a straight template, this vehicle may suffer two damage. This damage counts as having the Fire rule. If any Hull Points are removed by this effect, this vehicle may leave its movement template (ignoring any slide template) in play as a Napalm dropped weapon template. Remove this template at the start of this vehicle\'s next activation. (You may wish to download and print out extra paper templates for this effect.)'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Violent Manifestation', 3, 'When this vehicle is respawned: make an immediate attack (with attack dice based on the weight of the respawned vehicle) against every other vehicle within Medium range as if this vehicle was an exploding wreck. This explosion counts as having both the \"Blast\" and \"Fire\" rules.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Angel Of Death', 4, 'Before making an attack, this vehicle may suffer up to three damage to add that many attack dice to a single weapon used in this attack.')
	]);
var $author$project$Model$Sponsors$military = _List_fromArray(
	[
		A3($author$project$Model$Sponsors$VehiclePerk, 'Dead-Eye', 2, 'During this vehicle\'s attack step, up to three crewmembers in this vehicle may gain a +1 bonus to hit if making a shooting attack at a target within double range and not within medium range. Critical hits still occur only on the natural roll of a 6.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Loader', 2, 'This vehicle may assign two crewmembers to a single weapon during the attack step to gain +1 to hit with that weapon. The second crewmember may not make a separate attack. Critical hits still occur only on the natural roll of a 6.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Fully Loaded', 2, 'When this vehicle attacks with a shooting weapon that has 2 or more ammo tokens remaining, gain +1 attack die.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Rapid Fire', 2, 'Once per turn a single crewmember in this vehicle may shoot twice with the same weapon in a single attack step. When firing a weapon that has limited ammo in this way, each attack removes a separate ammo token.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Headshot', 4, 'When making a shooting attack, this vehicle\'s critical hits inflict 3 hits instead of the normal 2 hits.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Return Fire', 5, 'Once per gear phase, if this vehicle is the target of a shooting attack, this vehicle may take 2 hazard tokens to immediately attack, as if it was the vehicle\'s attack step.')
	]);
var $author$project$Model$Sponsors$precision = _List_fromArray(
	[
		A3($author$project$Model$Sponsors$VehiclePerk, 'Mister Fahrenheit', 2, 'This vehicle cannot gain more than 2 Hazard Tokens from Collisions during a single activation.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Moment of Glory', 2, 'Once per game, after rolling the Skid Dice, but before resolving the results, this vehicle may immediately change any number of Skid Dice to any results they choose.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Restraint', 2, 'When making a skid check, this vehicle does not receive hazard tokens for stick-shifting down a gear.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Expertise', 3, 'This vehicle adds 1 to its Handling Value.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Trick Driving', 3, 'This vehicle may select a movement template as if its current Gear was one higher or one lower.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Easy Rider', 5, 'Once per turn, this vehicle may discard one rolled skid die result before applying the results.')
	]);
var $author$project$Model$Sponsors$prisonCars = _List_fromArray(
	[
		A3($author$project$Model$Sponsors$VehiclePerk, 'Prison Car', 0, 'Reduce the cost of this vehicle by 4 Cans. Reduce the hull value of this vehicle by 2. May only be purchased by middleweight vehicles.')
	]);
var $author$project$Model$Sponsors$pursuit = _List_fromArray(
	[
		A3($author$project$Model$Sponsors$VehiclePerk, 'On Your Tail', 2, 'When an enemy vehicle resolves a spin or slide move that ends within short range of this vehicle, that vehicle gains +1 hazard token.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Schadenfreude', 2, 'If another vehicle within short range of this vehicle resolves a wipe out, (either before or after any flip), remove all hazard tokens from this vehicle.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Taunt', 2, 'At the start of this vehicle\'s attack step, roll a skid die. If you roll something other than a SHIFT result, you may place that skid die result onto the dashboard of a target vehicle within short range. This skid die result must be resolved during that vehicle\'s next skid check, and may not be re-rolled.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Out Run', 2, 'At the start of this vehicle\'s attack step, all vehicles within short range of this vehicle and in a current, lower gear than this vehicle gain +1 hazard token.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Pit', 4, 'If this vehicle is involved in a collision with an enemy vehicle during its activation that is not head-on, it may declare a “Pursuit Intervention Technique” (PIT) against the enemy vehicle instead of declaring a SMASH ATTACK or an evade. If this vehicle declares a PIT, it may select any maneuver template the target vehicle considers hazardous in its current gear. The target vehicle must immediately resolve a movement step, during which it is forced to must use the maneuver template selected for it and may not roll any skid dice.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Unnerving Eye Contact', 5, 'Enemy vehicles within short range of this vehicle may not use shift results to remove hazard tokens from their dashboard.')
	]);
var $author$project$Model$Sponsors$reckless = _List_fromArray(
	[
		A3($author$project$Model$Sponsors$VehiclePerk, 'Drive Angry', 1, 'At the start of this vehicle\'s activation, this vehicle gains 1 Hazard Token.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Hog Wild', 2, 'During a Collision resolved during a Wipeout Step, this vehicle gains +2 Smash Attack dice. '),
		A3($author$project$Model$Sponsors$VehiclePerk, 'In For a Penny', 2, 'If this vehicle has gained six or more Hazard Tokens during this activation, it may double the attack dice of any Smash Attack it makes for the remainder of this activation. '),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Don\'t Come Knocking', 4, 'At the start of this vehicle\'s activation, it may gain 4 Hazard Tokens. If it does, this vehicle cannot gain or lose any Hazard Tokens by any means until the start of its next activation. '),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Bigger\'n You', 4, 'If this vehicle is involved in a Collision, double any Smash Attack bonuses or penalties resulting from weight differences during that Collision.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Beerserker', 5, 'When this vehicle would suffer iddon damage by 1, to a minimum of 1. reduce that this damage outside of its activat, ')
	]);
var $author$project$Model$Sponsors$speed = _List_fromArray(
	[
		A3($author$project$Model$Sponsors$VehiclePerk, 'Hot Start', 1, 'Roll a D6 at the start of the game. This vehicle starts the game in that gear.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Slipstream', 2, 'During this vehicles\' skid check, this vehicle gains a shift result if there is another vehicle within short range in front of it, (measured like a front-mounted short range shooting attack).'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Overload', 2, 'When making a skid check, this vehicle may roll one additional skid die. If it does, it must change up at least one gear or gain a hazard token.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Downshift', 3, 'At the end of a Movement Step in which this vehicle changed down one or more Gears, this vehicle may make a forced move Short Straight forward.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Time Extended!', 3, 'At the end of an activation in which this vehicle passes a gate, before checking for wipeouts, this vehicle may immediately remove any number of hazard tokens.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Hell For Leather', 5, 'This vehicle considers long straight to be permitted in any gear. The long straight is not considered either hazardous or trivial in any gear.')
	]);
var $author$project$Model$Sponsors$technology = _List_fromArray(
	[
		A3($author$project$Model$Sponsors$VehiclePerk, 'Rocket Thrusters', 1, 'When this vehicle is moved as part of a flip, it may choose to use the long straight, veer or gentle templates instead of the medium straight template.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Whizbang', 1, 'At the start of each game, this vehicle gains a random SPEED PERK. This perk is lost at the end of the game.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Gyroscope', 1, 'At the start of each game, this vehicle gains a random PRECISION PERK. This perk is lost at the end of the game.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Satellite Navigation', 2, 'When this vehicle resolves its Skid Dice, this vehicle\'s controller may set aside one Shift result. This vehicle may have any number of Shift results set aside. Any vehicle in this team may use these set aside Shift results during a later Movement Step, as if they rolled them in that Movement Step.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Mobile Mechanic', 3, 'Once per turn, during the attack step, a single crewmember may be assigned to perform a FIELD REPAIR instead of attack with a weapon. This vehicle gains 1 hull point, which may not take the remaining hull points above the vehicle\'s hull value.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Eureka!', 4, 'Once per game, at the start of its Attack Step, this vehicle\'s controller may declare any weapon that this vehicle has not attacked with yet this game. This vehicle counts as being armed with the declared weapon, on a facing of their choice, for the next attack only.')
	]);
var $author$project$Model$Sponsors$tuning = _List_fromArray(
	[
		A3($author$project$Model$Sponsors$VehiclePerk, 'Fenderkiss', 2, 'Reduce the number of attack dice rolled for smash attacks by 2 for all vehicles in collisions involving this vehicle.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Rear Drive', 2, 'This vehicle may pivot about the centre of its front edge, rather than the centre of the vehicle, when resolving Spin results.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Delicate Touch', 3, 'This vehicle ignores the hazard icons on maneuver templates.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Purring', 6, 'This vehicle does not receive more than 1 hazard token from Spin results each turn. This vehicle does not receive more than 1 hazard token from Slide results each turn. This vehicle does not receive more than 1 hazard token from Hazard results each turn. Excess hazards are ignored. This vehicle may still elect to resolve multiple copies of each result.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Skiing', 6, 'May only be taken on a Bike, Buggy, Car, or Performance Car. This vehicle may take 3 hazard tokens at the end of its activation to be ignored by other vehicles during their movement steps until the start of this vehicle\'s next activation. If, by ignoring this vehicle in this way, a vehicle\'s final position would overlap it, move that vehicle backwards along their maneuver template by the minimum amount to avoid overlapping any obstruction.'),
		A3($author$project$Model$Sponsors$VehiclePerk, 'Momentum', 3, 'When resolving a skid check, this vehicle may set aside any number of slide results to re-roll 1 non-slide result for each slide result set aside. When resolving a skid check, this vehicle may set aside any number for each spin results to re-roll 1 non-spin result for each spin result set aside. Set aside results must be resolved.')
	]);
var $author$project$Model$Sponsors$getClassPerks = function (perkClass) {
	switch (perkClass) {
		case 0:
			return $author$project$Model$Sponsors$aggression;
		case 1:
			return $author$project$Model$Sponsors$badass;
		case 2:
			return $author$project$Model$Sponsors$built;
		case 3:
			return $author$project$Model$Sponsors$daring;
		case 4:
			return $author$project$Model$Sponsors$horror;
		case 5:
			return $author$project$Model$Sponsors$military;
		case 6:
			return $author$project$Model$Sponsors$precision;
		case 7:
			return $author$project$Model$Sponsors$pursuit;
		case 8:
			return $author$project$Model$Sponsors$reckless;
		case 9:
			return $author$project$Model$Sponsors$speed;
		case 10:
			return $author$project$Model$Sponsors$technology;
		case 11:
			return $author$project$Model$Sponsors$prisonCars;
		default:
			return $author$project$Model$Sponsors$tuning;
	}
};
var $author$project$Model$Vehicle$SetPerkInVehicle = F3(
	function (a, b, c) {
		return {$: 16, a: a, b: b, c: c};
	});
var $elm$html$Html$b = _VirtualDom_node('b');
var $author$project$View$Sponsor$printPerk = function (perk) {
	return A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$b,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						perk.cK + (' (' + ($elm$core$String$fromInt(perk.cb) + '): ')))
					])),
				$elm$html$Html$text(perk.ap)
			]));
};
var $author$project$View$Sponsor$renderVehiclePerk = F2(
	function (vehicle, perk) {
		return A5(
			$surprisetalk$elm_bulma$Bulma$Form$controlCheckBox,
			false,
			_List_Nil,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(perk.cK),
					$elm$html$Html$Events$onCheck(
					A2(
						$elm$core$Basics$composeL,
						$author$project$Model$Model$VehicleMsg,
						A2($author$project$Model$Vehicle$SetPerkInVehicle, vehicle.cH, perk))),
					$elm$html$Html$Attributes$checked(
					A2($elm$core$List$member, perk, vehicle.c3))
				]),
			_List_fromArray(
				[
					$author$project$View$Sponsor$printPerk(perk)
				]));
	});
var $author$project$View$Sponsor$renderPerkClass = F2(
	function (vehicle, perkClass) {
		return A3(
			$surprisetalk$elm_bulma$Bulma$Columns$column,
			$surprisetalk$elm_bulma$Bulma$Columns$columnModifiers,
			_List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A3(
						$surprisetalk$elm_bulma$Bulma$Elements$title,
						5,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Model$Sponsors$fromPerkClass(perkClass))
							]))
					]),
				A2(
					$elm$core$List$map,
					$author$project$View$Sponsor$renderVehiclePerk(vehicle),
					$author$project$Model$Sponsors$getClassPerks(perkClass))));
	});
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$View$Sponsor$renderPerkList = F2(
	function (perks, perkClasses) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$elm$html$Html$p(_List_Nil),
				A2(
					$elm$core$List$map,
					function (perkClass) {
						return A2(
							$elm$core$List$map,
							$author$project$View$Sponsor$printPerk,
							A2(
								$elm$core$List$filter,
								function (perk) {
									return A2($elm$core$List$member, perk, perks);
								},
								$author$project$Model$Sponsors$getClassPerks(perkClass)));
					},
					perkClasses)));
	});
var $lattyware$elm_fontawesome$FontAwesome$Solid$shieldAlt = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'shield-alt',
	512,
	512,
	_List_fromArray(
		['M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z']));
var $author$project$View$Utils$tagList = function (tagConfig) {
	return A2(
		$surprisetalk$elm_bulma$Bulma$Form$multilineFields,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (t) {
				return A3(
					$surprisetalk$elm_bulma$Bulma$Form$control,
					$surprisetalk$elm_bulma$Bulma$Form$controlModifiers,
					_List_Nil,
					_List_fromArray(
						[t]));
			},
			A2(
				$elm$core$List$map,
				function (config) {
					return A2($author$project$View$Utils$tagGen, config.a, config.b);
				},
				tagConfig)));
};
var $author$project$Model$Vehicle$Common$totalGear = function (v) {
	var gearFilter = function (m) {
		if (m.$ === 10) {
			return true;
		} else {
			return false;
		}
	};
	return A3(
		$elm$core$Basics$clamp,
		1,
		6,
		v.ct.bo + A2($author$project$Model$Vehicle$Common$totalForModType, v.dD, gearFilter));
};
var $author$project$Model$Vehicle$Common$totalHandling = function (v) {
	var handlingFilter = function (m) {
		if (m.$ === 8) {
			return true;
		} else {
			return false;
		}
	};
	return v.cw + A2($author$project$Model$Vehicle$Common$totalForModType, v.dD, handlingFilter);
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$trashAlt = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'trash-alt',
	448,
	512,
	_List_fromArray(
		['M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z']));
var $author$project$Model$Vehicle$DiscardPhoto = function (a) {
	return {$: 20, a: a};
};
var $author$project$Model$Vehicle$TakePhoto = function (a) {
	return {$: 18, a: a};
};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$autoplay = $elm$html$Html$Attributes$boolProperty('autoplay');
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$View$Photo$renderPhoto = F2(
	function (murl, shouldDisplay) {
		return A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src(
					A2($elm$core$Maybe$withDefault, '', murl)),
					$elm$html$Html$Attributes$class('card-img-top'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('d-none', !shouldDisplay)
						]))
				]),
			_List_Nil);
	});
var $elm$html$Html$video = _VirtualDom_node('video');
var $author$project$View$Photo$view = F2(
	function (model, v) {
		var discardButton = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-danger'),
					$elm$html$Html$Events$onClick(
					$author$project$Model$Model$VehicleMsg(
						$author$project$Model$Vehicle$DiscardPhoto(v.cH)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('(Re)Take Photo')
				]));
		var _v0 = function () {
			var _v1 = v.c4;
			if (_v1.$ === 1) {
				return _Utils_Tuple2(true, false);
			} else {
				var p = _v1.a;
				return _Utils_Tuple2(false, true);
			}
		}();
		var displayStream = _v0.a;
		var displayPhoto = _v0.b;
		var videoDisplay = A2(
			$elm$html$Html$video,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$autoplay(true),
					$elm$html$Html$Events$onClick(
					$author$project$Model$Model$VehicleMsg(
						$author$project$Model$Vehicle$TakePhoto(v.cH))),
					A2($elm$html$Html$Attributes$style, 'max-width', '100%'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('d-none', !displayStream)
						]))
				]),
			_List_Nil);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					videoDisplay,
					A2($author$project$View$Photo$renderPhoto, v.c4, displayPhoto),
					discardButton
				]));
	});
var $author$project$View$Vehicle$configure = F3(
	function (model, cfg, v) {
		var weightDisplay = _Utils_Tuple2(
			$author$project$Model$Vehicle$Common$fromVehicleWeight(v.dH) + '-weight',
			$elm$core$Maybe$Nothing);
		var weaponsUsingSlots = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.di;
				},
				v.dG));
		var weaponsListBody = function () {
			var _v14 = v.dG;
			if (!_v14.b) {
				return _List_fromArray(
					[
						$elm$html$Html$text('No Equipped Weapons')
					]);
			} else {
				return A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, weapon) {
							return A4(
								$author$project$View$Weapon$render,
								_Utils_update(
									$author$project$View$Weapon$defaultWeaponConfig,
									{
										bd: 1 === A2($elm$core$Basics$modBy, 2, index),
										bx: false,
										c7: cfg.x,
										de: !cfg.x,
										df: !cfg.x
									}),
								model,
								v,
								weapon);
						}),
					v.dG);
			}
		}();
		var vtype = _Utils_Tuple2(v.dB, $elm$core$Maybe$Nothing);
		var upgradeUsingSlots = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.di;
				},
				v.dD));
		var upgradeListBody = function () {
			var _v13 = v.dD;
			if (!_v13.b) {
				return _List_fromArray(
					[
						$elm$html$Html$text('No Equipped Upgrades')
					]);
			} else {
				return A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, upgrade) {
							return A4(
								$author$project$View$Upgrade$render,
								A4(
									$author$project$View$Upgrade$RenderConfig,
									false,
									cfg.x,
									!cfg.x,
									A2($elm$core$Basics$modBy, 2, index) === 1),
								model,
								v,
								upgrade);
						}),
					v.dD);
			}
		}();
		var showWrecked = function () {
			var _v12 = $author$project$Model$Vehicle$Common$isWrecked(v);
			if (_v12) {
				return 0;
			} else {
				return 2;
			}
		}();
		var renderSpecialsFunc = function (specialList) {
			return A2(
				$elm$core$List$map,
				$author$project$View$Utils$renderSpecialRow,
				A2(
					$elm$core$List$map,
					A4($author$project$View$Utils$specialToHeaderBody, false, false, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
					specialList));
		};
		var specials = function () {
			var _v11 = v.dj;
			if (!_v11.b) {
				return $elm$html$Html$text('No special rules for ' + (v.cK + '.'));
			} else {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					renderSpecialsFunc(v.dj));
			}
		}();
		var specialHolder = A3(
			$author$project$View$Utils$detailSection,
			'Vehicle Specials',
			_List_Nil,
			_List_fromArray(
				[specials]));
		var pointsDisplay = _Utils_Tuple2(
			'points',
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(
					$author$project$Model$Vehicle$Common$vehicleCost(v))));
		var photoPlus = A3(
			$author$project$Model$Features$withDefault,
			'feature-car-photo',
			$elm$html$Html$text(''),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$hidden(!cfg.aO)
					]),
				_List_fromArray(
					[
						A2($author$project$View$Photo$view, model, v)
					])));
		var maxHullDisplay = _Utils_Tuple2(
			'max hull',
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(
					$author$project$Model$Vehicle$Common$totalHull(v))));
		var maxGearDisplay = _Utils_Tuple2(
			'max gear',
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(
					$author$project$Model$Vehicle$Common$totalGear(v))));
		var isCrewAvailable = _Utils_cmp(
			$author$project$Model$Vehicle$Common$totalCrew(v),
			$author$project$View$Utils$crewUsed(v)) > 0;
		var weaponListColor = function () {
			if (isCrewAvailable) {
				return 8;
			} else {
				return 10;
			}
		}();
		var hullCounter = function () {
			var _v9 = cfg.K;
			if (_v9) {
				return A3(
					$surprisetalk$elm_bulma$Bulma$Columns$columns,
					$surprisetalk$elm_bulma$Bulma$Columns$columnsModifiers,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$surprisetalk$elm_bulma$Bulma$Columns$column,
							$surprisetalk$elm_bulma$Bulma$Columns$columnModifiers,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$lattyware$elm_fontawesome$FontAwesome$Icon$viewStyled,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('print-icon')
										]),
									$lattyware$elm_fontawesome$FontAwesome$Solid$shieldAlt)
								])),
							A3(
							$surprisetalk$elm_bulma$Bulma$Columns$column,
							$surprisetalk$elm_bulma$Bulma$Columns$columnModifiers,
							_List_Nil,
							A2(
								$elm$core$List$repeat,
								$author$project$Model$Vehicle$Common$totalHull(v),
								A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('hazard-check mr-1')
										]),
									_List_Nil)))
						]));
			} else {
				return A6(
					$author$project$View$Vehicle$counterElement,
					$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$shieldAlt),
					0,
					$author$project$Model$Vehicle$Common$totalHull(v),
					v.cB.a2,
					A2($author$project$Model$Vehicle$ShiftHull, v.cH, -1),
					A2($author$project$Model$Vehicle$ShiftHull, v.cH, 1));
			}
		}();
		var hazardCounter = function () {
			var _v8 = cfg.K;
			if (_v8) {
				return A3(
					$surprisetalk$elm_bulma$Bulma$Columns$columns,
					$surprisetalk$elm_bulma$Bulma$Columns$columnsModifiers,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$surprisetalk$elm_bulma$Bulma$Columns$column,
							$surprisetalk$elm_bulma$Bulma$Columns$columnModifiers,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$lattyware$elm_fontawesome$FontAwesome$Icon$viewStyled,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('print-icon')
										]),
									$lattyware$elm_fontawesome$FontAwesome$Solid$exclamationTriangle)
								])),
							A3(
							$surprisetalk$elm_bulma$Bulma$Columns$column,
							$surprisetalk$elm_bulma$Bulma$Columns$columnModifiers,
							_List_Nil,
							A2(
								$elm$core$List$repeat,
								6,
								A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('hazard-check mr-1')
										]),
									_List_Nil)))
						]));
			} else {
				return A6(
					$author$project$View$Vehicle$counterElement,
					$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$exclamationTriangle),
					0,
					6,
					v.cx,
					A2($author$project$Model$Vehicle$ShiftHazards, v.cH, -1),
					A2($author$project$Model$Vehicle$ShiftHazards, v.cH, 1));
			}
		}();
		var handlingDisplay = _Utils_Tuple2(
			'handling',
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(
					$author$project$Model$Vehicle$Common$totalHandling(v))));
		var gearCounter = function () {
			var _v7 = _Utils_Tuple2(
				cfg.K,
				$author$project$Model$Vehicle$Common$isWrecked(v));
			_v7$0:
			while (true) {
				if (_v7.b) {
					if (_v7.a) {
						break _v7$0;
					} else {
						return $elm$html$Html$text('');
					}
				} else {
					if (_v7.a) {
						break _v7$0;
					} else {
						return A6(
							$author$project$View$Vehicle$counterElement,
							$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$cogs),
							1,
							$author$project$Model$Vehicle$Common$totalGear(v),
							v.ct.a2,
							A2($author$project$Model$Vehicle$ShiftGear, v.cH, -1),
							A2($author$project$Model$Vehicle$ShiftGear, v.cH, 1));
					}
				}
			}
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('gear-die')
					]),
				_List_fromArray(
					[
						$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$cogs)
					]));
		}();
		var footer = A2(
			$surprisetalk$elm_bulma$Bulma$Layout$level,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button-bar')
				]),
			_List_fromArray(
				[
					A2($surprisetalk$elm_bulma$Bulma$Layout$levelLeft, _List_Nil, _List_Nil),
					A2(
					$surprisetalk$elm_bulma$Bulma$Layout$levelRight,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$surprisetalk$elm_bulma$Bulma$Layout$levelItem,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$surprisetalk$elm_bulma$Bulma$Elements$button,
									_Utils_update(
										$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
										{
											b9: 10,
											cC: $elm$core$Maybe$Just(
												_Utils_Tuple3(
													1,
													_List_Nil,
													$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$trashAlt)))
										}),
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$Model$Model$VehicleMsg(
												$author$project$Model$Vehicle$DeleteVehicle(v.cH)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete Vehicle')
										]))
								]))
						]))
				]));
		var equipmentUsed = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.di;
				},
				v.dG));
		var equipmentSlotsDisplay = _Utils_Tuple2(
			'build slots',
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(v.ci)));
		var equipmentRemaining = $elm$core$String$fromInt(v.ci - equipmentUsed);
		var crewDisplay = _Utils_Tuple2(
			'total crew',
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(
					$author$project$Model$Vehicle$Common$totalCrew(v))));
		var factsHolder = A2(
			$surprisetalk$elm_bulma$Bulma$Form$multilineFields,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (t) {
					return A3(
						$surprisetalk$elm_bulma$Bulma$Form$control,
						$surprisetalk$elm_bulma$Bulma$Form$controlModifiers,
						_List_Nil,
						_List_fromArray(
							[t]));
				},
				A2(
					$elm$core$List$map,
					function (_v6) {
						var title = _v6.a;
						var value = _v6.b;
						return A2(
							$author$project$View$Utils$tagGen,
							_Utils_Tuple2(title, 2),
							_Utils_Tuple2(value, 7));
					},
					_List_fromArray(
						[vtype, pointsDisplay, weightDisplay, crewDisplay, handlingDisplay, equipmentSlotsDisplay, maxHullDisplay, maxGearDisplay]))));
		var counterHolder = function () {
			var _v5 = _Utils_Tuple2(cfg.U, cfg.K);
			if (!_v5.a) {
				return $elm$html$Html$text('');
			} else {
				return A2(
					$surprisetalk$elm_bulma$Bulma$Layout$level,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$surprisetalk$elm_bulma$Bulma$Layout$levelItem,
							_List_Nil,
							_List_fromArray(
								[gearCounter])),
							A2(
							$surprisetalk$elm_bulma$Bulma$Layout$levelItem,
							_List_Nil,
							_List_fromArray(
								[hazardCounter])),
							A2(
							$surprisetalk$elm_bulma$Bulma$Layout$levelItem,
							_List_Nil,
							_List_fromArray(
								[hullCounter]))
						]));
			}
		}();
		var left = A3(
			$surprisetalk$elm_bulma$Bulma$Columns$column,
			$surprisetalk$elm_bulma$Bulma$Columns$columnModifiers,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('vehicle-column-left')
				]),
			_List_fromArray(
				[factsHolder, counterHolder, specialHolder]));
		var canActivate = (_Utils_cmp(model.cu, v.ct.a2) < 1) && (!$author$project$Model$Vehicle$Common$isWrecked(v));
		var availablePerks = function () {
			var _v3 = _Utils_Tuple3(model.dl, cfg.ag, cfg.aJ);
			_v3$0:
			while (true) {
				if (_v3.a.$ === 1) {
					var _v4 = _v3.a;
					return $elm$html$Html$text('');
				} else {
					if (!_v3.b) {
						if (_v3.c) {
							break _v3$0;
						} else {
							return $elm$html$Html$text('');
						}
					} else {
						if (_v3.c) {
							break _v3$0;
						} else {
							var sponsor = _v3.a.a;
							return A3(
								$author$project$View$Utils$detailSection,
								'Perks available from ' + sponsor.cK,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$surprisetalk$elm_bulma$Bulma$Layout$container,
										_List_Nil,
										A2(
											$elm$core$List$map,
											$author$project$View$Sponsor$renderPerkClass(v),
											sponsor.cv))
									]));
						}
					}
				}
			}
			var sponsor = _v3.a.a;
			return A3(
				$author$project$View$Utils$detailSection,
				'Perks available from ' + sponsor.cK,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$View$Sponsor$renderPerkList, v.c3, sponsor.cv)
					]));
		}();
		var bottom = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('vehicle-body-bottom')
				]),
			_List_fromArray(
				[availablePerks]));
		var addonListButton = F3(
			function (buttonMsg, icon, text_) {
				return A3(
					$surprisetalk$elm_bulma$Bulma$Elements$button,
					_Utils_update(
						$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
						{
							cC: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									1,
									_List_Nil,
									$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon(icon))),
							dg: 0
						}),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button'),
							$elm$html$Html$Attributes$hidden(!cfg.af),
							$elm$html$Html$Events$onClick(
							$author$project$Model$Model$ViewMsg(buttonMsg))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(text_)
						]));
			});
		var upgradeList = function () {
			var _v2 = _Utils_Tuple3(v.dD, cfg.x, cfg.V);
			if (!_v2.c) {
				return $elm$html$Html$text('');
			} else {
				if ((!_v2.a.b) && _v2.b) {
					return $elm$html$Html$text('');
				} else {
					return A3(
						$author$project$View$Utils$detailSection,
						'Upgrades',
						_List_fromArray(
							[
								A3(
								addonListButton,
								$author$project$Model$Views$ViewNew(
									$author$project$Model$Views$NewUpgrade(v.cH)),
								$lattyware$elm_fontawesome$FontAwesome$Solid$plus,
								'Upgrade')
							]),
						_List_fromArray(
							[
								$author$project$View$Utils$tagList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										_Utils_Tuple2('slots used', 2),
										_Utils_Tuple2(
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(upgradeUsingSlots) + (' / ' + $elm$core$String$fromInt(v.ci))),
											8))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('thing-list upgrade-list')
									]),
								upgradeListBody)
							]));
				}
			}
		}();
		var weaponList = function () {
			var _v1 = _Utils_Tuple3(v.dG, cfg.x, cfg.V);
			if (!_v1.c) {
				return $elm$html$Html$text('');
			} else {
				if ((!_v1.a.b) && _v1.b) {
					return $elm$html$Html$text('');
				} else {
					return A3(
						$author$project$View$Utils$detailSection,
						'Weapons',
						_List_fromArray(
							[
								A3(
								addonListButton,
								$author$project$Model$Views$ViewNew(
									$author$project$Model$Views$NewWeapon(v.cH)),
								$lattyware$elm_fontawesome$FontAwesome$Solid$plus,
								'Weapon'),
								A3(
								$surprisetalk$elm_bulma$Bulma$Elements$button,
								_Utils_update(
									$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
									{
										cC: $elm$core$Maybe$Just(
											_Utils_Tuple3(
												1,
												_List_Nil,
												$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$plus))),
										dg: 0
									}),
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										$author$project$Model$Model$WeaponMsg(
											A2($author$project$Model$Weapon$AddWeapon, v.cH, $author$project$Model$Weapon$Common$handgun))),
										$elm$html$Html$Attributes$hidden(!cfg.af)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Handgun')
									]))
							]),
						_List_fromArray(
							[
								$author$project$View$Utils$tagList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										_Utils_Tuple2('crew used', 2),
										_Utils_Tuple2(
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$View$Utils$crewUsed(v)) + (' / ' + $elm$core$String$fromInt(
													$author$project$Model$Vehicle$Common$totalCrew(v)))),
											weaponListColor)),
										_Utils_Tuple2(
										_Utils_Tuple2('slots used', 2),
										_Utils_Tuple2(
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(weaponsUsingSlots) + (' / ' + $elm$core$String$fromInt(v.ci))),
											weaponListColor))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('thing-list weapon-list')
									]),
								weaponsListBody)
							]));
				}
			}
		}();
		var right = A3(
			$surprisetalk$elm_bulma$Bulma$Columns$column,
			$surprisetalk$elm_bulma$Bulma$Columns$columnModifiers,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('vehicle-column-right')
				]),
			_List_fromArray(
				[weaponList, upgradeList]));
		var body = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('vehicle-body')
				]),
			_List_fromArray(
				[
					A3(
					$surprisetalk$elm_bulma$Bulma$Columns$columns,
					$surprisetalk$elm_bulma$Bulma$Columns$columnsModifiers,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('vehicle-columns')
						]),
					_List_fromArray(
						[left, right])),
					bottom
				]));
		var activatedText = function () {
			var _v0 = _Utils_Tuple2(v.b$, canActivate);
			if (!_v0.b) {
				return 'Cannot be Activated';
			} else {
				if (_v0.a) {
					return 'Activated';
				} else {
					return 'Activate';
				}
			}
		}();
		var activateButton = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('vehicle-activate-button-holder mb-2'),
					$elm$html$Html$Attributes$hidden(!cfg.ae)
				]),
			_List_fromArray(
				[
					A3(
					$surprisetalk$elm_bulma$Bulma$Elements$button,
					_Utils_update(
						$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
						{b9: 5, cf: (!canActivate) || v.b$}),
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Model$Model$VehicleMsg(
								A2($author$project$Model$Vehicle$UpdateActivated, v.cH, !v.b$)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(activatedText)
						]))
				]));
		var header = A2(
			$surprisetalk$elm_bulma$Bulma$Layout$level,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$surprisetalk$elm_bulma$Bulma$Layout$levelLeft,
					_List_Nil,
					_List_fromArray(
						[
							photoPlus,
							A3(
							$surprisetalk$elm_bulma$Bulma$Elements$title,
							2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(v.cK),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('wrecked-display'),
											$surprisetalk$elm_bulma$Bulma$Modifiers$display(showWrecked)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('WRECKED!')
										]))
								]))
						])),
					A2(
					$surprisetalk$elm_bulma$Bulma$Layout$levelRight,
					_List_Nil,
					_List_fromArray(
						[activateButton]))
				]));
		return _Utils_Tuple3(header, body, footer);
	});
var $author$project$View$Vehicle$renderDetails = F2(
	function (model, v) {
		var _v0 = A3(
			$author$project$View$Vehicle$configure,
			model,
			_Utils_update(
				$author$project$View$Vehicle$config,
				{bi: true, ae: true, af: true, U: true, V: true, ag: true, aO: true, bO: true}),
			v);
		var header = _v0.a;
		var body = _v0.b;
		var footer = _v0.c;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[header, body, footer]));
	});
var $elm$html$Html$li = _VirtualDom_node('li');
var $surprisetalk$elm_bulma$Bulma$Components$tab = F4(
	function (active, attrs, attrs_, htmls) {
		return A2(
			$elm$html$Html$li,
			A2(
				$elm$core$List$cons,
				function () {
					if (active) {
						return $surprisetalk$elm_bulma$Bulma$Classes$isActive;
					} else {
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					}
				}(),
				attrs),
			_List_fromArray(
				[
					A2($elm$html$Html$a, attrs_, htmls)
				]));
	});
var $author$project$View$Dashboard$tabGen = F3(
	function (focused, viewEvent, display) {
		return A4(
			$surprisetalk$elm_bulma$Bulma$Components$tab,
			focused,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Model$Model$ViewTab(viewEvent))
				]),
			display);
	});
var $surprisetalk$elm_bulma$Bulma$Classes$isBoxed = $elm$html$Html$Attributes$class('is-boxed');
var $surprisetalk$elm_bulma$Bulma$Classes$isRight = $elm$html$Html$Attributes$class('is-right');
var $surprisetalk$elm_bulma$Bulma$Classes$isToggle = $elm$html$Html$Attributes$class('is-toggle');
var $surprisetalk$elm_bulma$Bulma$Classes$isToggleRounded = $elm$html$Html$Attributes$class('is-toggle-rounded');
var $surprisetalk$elm_bulma$Bulma$Classes$tabs = $elm$html$Html$Attributes$class('tabs');
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $surprisetalk$elm_bulma$Bulma$Components$tabs = F3(
	function (_v0, attrs, attrs_) {
		var style = _v0.aT;
		var alignment = _v0.G;
		var size = _v0.dg;
		return A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				A3(
					$surprisetalk$elm_bulma$Helpers$node,
					'div',
					_List_fromArray(
						[
							$surprisetalk$elm_bulma$Bulma$Classes$tabs,
							function () {
							switch (style) {
								case 2:
									return $surprisetalk$elm_bulma$Bulma$Classes$isToggle;
								case 3:
									return $surprisetalk$elm_bulma$Bulma$Classes$isToggle;
								default:
									return $surprisetalk$elm_bulma$Bulma$Classes$none;
							}
						}(),
							function () {
							if (style === 1) {
								return $surprisetalk$elm_bulma$Bulma$Classes$isBoxed;
							} else {
								return $surprisetalk$elm_bulma$Bulma$Classes$none;
							}
						}(),
							function () {
							if (style === 3) {
								return $surprisetalk$elm_bulma$Bulma$Classes$isToggleRounded;
							} else {
								return $surprisetalk$elm_bulma$Bulma$Classes$none;
							}
						}(),
							function () {
							switch (alignment) {
								case 0:
									return $surprisetalk$elm_bulma$Bulma$Classes$none;
								case 1:
									return $surprisetalk$elm_bulma$Bulma$Classes$isCentered;
								default:
									return $surprisetalk$elm_bulma$Bulma$Classes$isRight;
							}
						}(),
							function () {
							switch (size) {
								case 0:
									return $surprisetalk$elm_bulma$Bulma$Classes$isSmall;
								case 1:
									return $surprisetalk$elm_bulma$Bulma$Classes$none;
								case 2:
									return $surprisetalk$elm_bulma$Bulma$Classes$isMedium;
								default:
									return $surprisetalk$elm_bulma$Bulma$Classes$isLarge;
							}
						}()
						]),
					attrs),
				$surprisetalk$elm_bulma$Helpers$ls),
			$elm$html$Html$ul(attrs_));
	});
var $surprisetalk$elm_bulma$Bulma$Modifiers$Left = 0;
var $surprisetalk$elm_bulma$Bulma$Components$Minimal = 0;
var $surprisetalk$elm_bulma$Bulma$Components$tabsModifiers = {G: 0, dg: 1, aT: 0};
var $author$project$View$Dashboard$vehicleTab = F2(
	function (focused, vehicle) {
		return A3(
			$author$project$View$Dashboard$tabGen,
			focused,
			$author$project$Model$Views$ViewDetails(vehicle.cH),
			_List_fromArray(
				[
					$elm$html$Html$text(vehicle.cK)
				]));
	});
var $author$project$Model$Upgrade$AddUpgrade = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Model$Upgrade$TmpUpgradeUpdate = function (a) {
	return {$: 2, a: a};
};
var $surprisetalk$elm_bulma$Bulma$Classes$box = $elm$html$Html$Attributes$class('box');
var $surprisetalk$elm_bulma$Bulma$Elements$box = A2(
	$surprisetalk$elm_bulma$Helpers$node,
	'div',
	_List_fromArray(
		[$surprisetalk$elm_bulma$Bulma$Classes$box]));
var $surprisetalk$elm_bulma$Bulma$Classes$isFullWidth = $elm$html$Html$Attributes$class('is-fullwidth');
var $surprisetalk$elm_bulma$Bulma$Classes$select = $elm$html$Html$Attributes$class('select');
var $surprisetalk$elm_bulma$Bulma$Form$controlSelect = F3(
	function (mods, attrs, attrs_) {
		var size = mods.dg;
		var state = mods.g;
		var color = mods.b9;
		var expanded = mods.o;
		var iconLeft = mods.cC;
		var controlMods = {
			o: expanded,
			cC: iconLeft,
			ax: $elm$core$Maybe$Nothing,
			J: function () {
				if (state === 4) {
					return $elm$core$Maybe$Just(size);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}()
		};
		return A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						A2($surprisetalk$elm_bulma$Bulma$Form$control, controlMods, attrs),
						$surprisetalk$elm_bulma$Helpers$ls),
					A3(
						$surprisetalk$elm_bulma$Helpers$node,
						'span',
						_List_fromArray(
							[$surprisetalk$elm_bulma$Bulma$Classes$select]),
						_List_Nil)),
				$surprisetalk$elm_bulma$Helpers$ls),
			A3(
				$surprisetalk$elm_bulma$Helpers$node,
				'select',
				_List_fromArray(
					[
						function () {
						switch (size) {
							case 0:
								return $surprisetalk$elm_bulma$Bulma$Classes$isSmall;
							case 1:
								return $surprisetalk$elm_bulma$Bulma$Classes$none;
							case 2:
								return $surprisetalk$elm_bulma$Bulma$Classes$isMedium;
							default:
								return $surprisetalk$elm_bulma$Bulma$Classes$isLarge;
						}
					}(),
						function () {
						switch (state) {
							case 1:
								return $surprisetalk$elm_bulma$Bulma$Classes$isHovered;
							case 2:
								return $surprisetalk$elm_bulma$Bulma$Classes$isFocused;
							case 3:
								return $surprisetalk$elm_bulma$Bulma$Classes$isActive;
							case 4:
								return $surprisetalk$elm_bulma$Bulma$Classes$isLoading;
							default:
								return $surprisetalk$elm_bulma$Bulma$Classes$none;
						}
					}(),
						function () {
						switch (color) {
							case 0:
								return $surprisetalk$elm_bulma$Bulma$Classes$none;
							case 1:
								return $surprisetalk$elm_bulma$Bulma$Classes$isWhite;
							case 2:
								return $surprisetalk$elm_bulma$Bulma$Classes$isLight;
							case 3:
								return $surprisetalk$elm_bulma$Bulma$Classes$isDark;
							case 4:
								return $surprisetalk$elm_bulma$Bulma$Classes$isBlack;
							case 5:
								return $surprisetalk$elm_bulma$Bulma$Classes$isPrimary;
							case 7:
								return $surprisetalk$elm_bulma$Bulma$Classes$isInfo;
							case 8:
								return $surprisetalk$elm_bulma$Bulma$Classes$isSuccess;
							case 9:
								return $surprisetalk$elm_bulma$Bulma$Classes$isWarning;
							case 10:
								return $surprisetalk$elm_bulma$Bulma$Classes$isDanger;
							default:
								return $surprisetalk$elm_bulma$Bulma$Classes$isLink;
						}
					}(),
						function () {
						if (expanded) {
							return $surprisetalk$elm_bulma$Bulma$Classes$isFullWidth;
						} else {
							return $surprisetalk$elm_bulma$Bulma$Classes$none;
						}
					}()
					]),
				attrs_));
	});
var $surprisetalk$elm_bulma$Bulma$Form$controlSelectModifiers = {b9: 0, o: false, cC: $elm$core$Maybe$Nothing, dg: 1, g: 0};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$View$NewUpgrade$view = F3(
	function (model, vehicle, weapons) {
		var options = A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$option,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('')
					])),
			A2(
				$elm$core$List$map,
				function (upgrade) {
					return A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(upgrade.cK)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(upgrade.cK)
							]));
				},
				weapons));
		var selectList = A4(
			$surprisetalk$elm_bulma$Bulma$Form$controlSelect,
			$surprisetalk$elm_bulma$Bulma$Form$controlSelectModifiers,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$Events$onInput(
					A2($elm$core$Basics$composeL, $author$project$Model$Model$UpgradeMsg, $author$project$Model$Upgrade$TmpUpgradeUpdate))
				]),
			options);
		var body = function () {
			var _v1 = model.dx;
			if (!_v1.$) {
				var weapon = _v1.a;
				return A4(
					$author$project$View$Upgrade$render,
					A4($author$project$View$Upgrade$RenderConfig, true, false, false, false),
					model,
					vehicle,
					weapon);
			} else {
				return $elm$html$Html$text('Select an upgrade type from the dropdown.');
			}
		}();
		var addButton = function () {
			var _v0 = model.dx;
			if (!_v0.$) {
				var upgrade = _v0.a;
				return A4(
					$surprisetalk$elm_bulma$Bulma$Form$controlButton,
					$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Model$Model$UpgradeMsg(
								A2($author$project$Model$Upgrade$AddUpgrade, vehicle.cH, upgrade)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add ' + (upgrade.cK + (' to ' + vehicle.cK)))
						]));
			} else {
				return A4(
					$surprisetalk$elm_bulma$Bulma$Form$controlButton,
					_Utils_update(
						$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
						{cf: true}),
					_List_Nil,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Choose Upgrade Type')
						]));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$surprisetalk$elm_bulma$Bulma$Form$horizontalFields,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$surprisetalk$elm_bulma$Bulma$Form$fieldLabel,
							1,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$surprisetalk$elm_bulma$Bulma$Form$controlLabel,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Upgrade Type')
										]))
								])),
							A2(
							$surprisetalk$elm_bulma$Bulma$Form$fieldBody,
							_List_Nil,
							_List_fromArray(
								[selectList]))
						])),
					A2(
					$surprisetalk$elm_bulma$Bulma$Form$horizontalFields,
					_List_Nil,
					_List_fromArray(
						[
							A3($surprisetalk$elm_bulma$Bulma$Form$fieldLabel, 1, _List_Nil, _List_Nil),
							A2(
							$surprisetalk$elm_bulma$Bulma$Form$fieldBody,
							_List_Nil,
							_List_fromArray(
								[addButton]))
						])),
					A2(
					$surprisetalk$elm_bulma$Bulma$Elements$box,
					_List_Nil,
					_List_fromArray(
						[body]))
				]));
	});
var $author$project$Model$Vehicle$TmpName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Vehicle$TmpVehicleType = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Vehicle$AddVehicle = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$NewVehicle$addButton = function (tmpVehicle) {
	var event = function () {
		if (tmpVehicle.$ === 1) {
			return _List_Nil;
		} else {
			var v = tmpVehicle.a;
			return _List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Model$Model$VehicleMsg(
						$author$project$Model$Vehicle$AddVehicle(v)))
				]);
		}
	}();
	var disabledButton = function () {
		if (!tmpVehicle.$) {
			var vehicle = tmpVehicle.a;
			var _v3 = vehicle.cK;
			if (_v3 === '') {
				return true;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}();
	var buttonText = function () {
		if (!tmpVehicle.$) {
			var vehicle = tmpVehicle.a;
			var _v1 = vehicle.cK;
			if (_v1 === '') {
				return 'Input Name';
			} else {
				return 'Add ' + vehicle.cK;
			}
		} else {
			return 'Select Vehicle';
		}
	}();
	var attrs = A2($elm$core$List$append, event, _List_Nil);
	return A4(
		$surprisetalk$elm_bulma$Bulma$Form$controlButton,
		_Utils_update(
			$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
			{cf: disabledButton}),
		_List_Nil,
		attrs,
		_List_fromArray(
			[
				$elm$html$Html$text(buttonText)
			]));
};
var $surprisetalk$elm_bulma$Bulma$Form$controlInputModifiers = {b9: 0, cf: false, o: false, cC: $elm$core$Maybe$Nothing, ax: $elm$core$Maybe$Nothing, L: false, aM: false, dg: 1, g: 0};
var $surprisetalk$elm_bulma$Bulma$Classes$input = $elm$html$Html$Attributes$class('input');
var $elm$html$Html$Attributes$readonly = $elm$html$Html$Attributes$boolProperty('readOnly');
var $surprisetalk$elm_bulma$Bulma$Form$controlInput = F3(
	function (mods, attrs, attrs_) {
		var size = mods.dg;
		var state = mods.g;
		var color = mods.b9;
		var expanded = mods.o;
		var rounded = mods.aM;
		var readonly = mods.L;
		var disabled = mods.cf;
		var iconLeft = mods.cC;
		var iconRight = mods.ax;
		var controlMods = {
			o: expanded,
			cC: iconLeft,
			ax: iconRight,
			J: function () {
				if (state === 4) {
					return $elm$core$Maybe$Just(size);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}()
		};
		return A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				A2($surprisetalk$elm_bulma$Bulma$Form$control, controlMods, attrs),
				$surprisetalk$elm_bulma$Helpers$ls),
			A3(
				$surprisetalk$elm_bulma$Helpers$node,
				'input',
				_List_fromArray(
					[
						$surprisetalk$elm_bulma$Bulma$Classes$input,
						$elm$html$Html$Attributes$disabled(disabled),
						function () {
						if (readonly) {
							return $elm$html$Html$Attributes$readonly(readonly);
						} else {
							return $surprisetalk$elm_bulma$Bulma$Classes$none;
						}
					}(),
						function () {
						switch (size) {
							case 0:
								return $surprisetalk$elm_bulma$Bulma$Classes$isSmall;
							case 1:
								return $surprisetalk$elm_bulma$Bulma$Classes$none;
							case 2:
								return $surprisetalk$elm_bulma$Bulma$Classes$isMedium;
							default:
								return $surprisetalk$elm_bulma$Bulma$Classes$isLarge;
						}
					}(),
						function () {
						switch (state) {
							case 1:
								return $surprisetalk$elm_bulma$Bulma$Classes$isHovered;
							case 2:
								return $surprisetalk$elm_bulma$Bulma$Classes$isFocused;
							case 3:
								return $surprisetalk$elm_bulma$Bulma$Classes$isActive;
							case 4:
								return $surprisetalk$elm_bulma$Bulma$Classes$isLoading;
							default:
								return $surprisetalk$elm_bulma$Bulma$Classes$none;
						}
					}(),
						function () {
						switch (color) {
							case 0:
								return $surprisetalk$elm_bulma$Bulma$Classes$none;
							case 1:
								return $surprisetalk$elm_bulma$Bulma$Classes$isWhite;
							case 2:
								return $surprisetalk$elm_bulma$Bulma$Classes$isLight;
							case 3:
								return $surprisetalk$elm_bulma$Bulma$Classes$isDark;
							case 4:
								return $surprisetalk$elm_bulma$Bulma$Classes$isBlack;
							case 5:
								return $surprisetalk$elm_bulma$Bulma$Classes$isPrimary;
							case 7:
								return $surprisetalk$elm_bulma$Bulma$Classes$isInfo;
							case 8:
								return $surprisetalk$elm_bulma$Bulma$Classes$isSuccess;
							case 9:
								return $surprisetalk$elm_bulma$Bulma$Classes$isWarning;
							case 10:
								return $surprisetalk$elm_bulma$Bulma$Classes$isDanger;
							default:
								return $surprisetalk$elm_bulma$Bulma$Classes$isLink;
						}
					}(),
						function () {
						if (!rounded) {
							return $surprisetalk$elm_bulma$Bulma$Classes$none;
						} else {
							return $surprisetalk$elm_bulma$Bulma$Classes$isRounded;
						}
					}()
					]),
				attrs_));
	});
var $surprisetalk$elm_bulma$Bulma$Form$controlText = F3(
	function (mods, attrs, attrs_) {
		return A3(
			$surprisetalk$elm_bulma$Bulma$Form$controlInput,
			mods,
			attrs,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$type_('text'),
				attrs_));
	});
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $surprisetalk$elm_bulma$Bulma$Elements$H4 = 3;
var $author$project$View$Vehicle$renderPreview = F2(
	function (model, v) {
		var name = function () {
			var _v1 = v.cK;
			if (_v1 === '') {
				return '...';
			} else {
				return v.cK;
			}
		}();
		var header = A3(
			$surprisetalk$elm_bulma$Bulma$Elements$title,
			3,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(name)
				]));
		var _v0 = A3(
			$author$project$View$Vehicle$configure,
			model,
			_Utils_update(
				$author$project$View$Vehicle$config,
				{bw: true}),
			v);
		var body = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[header, body]));
	});
var $author$project$View$NewVehicle$vehicleOption = F2(
	function (i, vt) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$elm$core$String$fromInt(i))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(vt.dB)
				]));
	});
var $author$project$View$NewVehicle$view = function (model) {
	var options = A2(
		$elm$core$List$cons,
		A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value('-1')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Select Vehicle')
				])),
		A2(
			$elm$core$List$indexedMap,
			$author$project$View$NewVehicle$vehicleOption,
			A2(
				$elm$core$List$filter,
				$author$project$View$Utils$vehicleSponsorFilter(model),
				$author$project$Model$Vehicle$Common$allVehicles)));
	var selectList = A4(
		$surprisetalk$elm_bulma$Bulma$Form$controlSelect,
		$surprisetalk$elm_bulma$Bulma$Form$controlSelectModifiers,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$Events$onInput(
				A2($elm$core$Basics$composeL, $author$project$Model$Model$VehicleMsg, $author$project$Model$Vehicle$TmpVehicleType)),
				$elm$html$Html$Attributes$class('mb-3')
			]),
		options);
	var nameInput = function () {
		var _v1 = model.dy;
		if (_v1.$ === 1) {
			return A4(
				$surprisetalk$elm_bulma$Bulma$Form$controlText,
				_Utils_update(
					$surprisetalk$elm_bulma$Bulma$Form$controlInputModifiers,
					{cf: true}),
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$placeholder('Select a vehicle type above'),
						$elm$html$Html$Attributes$disabled(true)
					]),
				_List_Nil);
		} else {
			var vehicle = _v1.a;
			return A4(
				$surprisetalk$elm_bulma$Bulma$Form$controlText,
				$surprisetalk$elm_bulma$Bulma$Form$controlInputModifiers,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$placeholder('Name'),
						$elm$html$Html$Events$onInput(
						A2($elm$core$Basics$composeL, $author$project$Model$Model$VehicleMsg, $author$project$Model$Vehicle$TmpName)),
						$elm$html$Html$Attributes$value(vehicle.cK)
					]),
				_List_Nil);
		}
	}();
	var body = function () {
		var _v0 = model.dy;
		if (!_v0.$) {
			var v = _v0.a;
			return A2($author$project$View$Vehicle$renderPreview, model, v);
		} else {
			return $elm$html$Html$text('Select a vehicle type.');
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$surprisetalk$elm_bulma$Bulma$Form$horizontalFields,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$surprisetalk$elm_bulma$Bulma$Form$fieldLabel,
						1,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$surprisetalk$elm_bulma$Bulma$Form$controlLabel,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Vehicle Type')
									]))
							])),
						A2(
						$surprisetalk$elm_bulma$Bulma$Form$fieldBody,
						_List_Nil,
						_List_fromArray(
							[selectList]))
					])),
				A2(
				$surprisetalk$elm_bulma$Bulma$Form$horizontalFields,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$surprisetalk$elm_bulma$Bulma$Form$fieldLabel,
						1,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$surprisetalk$elm_bulma$Bulma$Form$controlLabel,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Vehicle Name')
									]))
							])),
						A2(
						$surprisetalk$elm_bulma$Bulma$Form$fieldBody,
						_List_Nil,
						_List_fromArray(
							[nameInput]))
					])),
				A2(
				$surprisetalk$elm_bulma$Bulma$Form$horizontalFields,
				_List_Nil,
				_List_fromArray(
					[
						A3($surprisetalk$elm_bulma$Bulma$Form$fieldLabel, 1, _List_Nil, _List_Nil),
						A2(
						$surprisetalk$elm_bulma$Bulma$Form$fieldBody,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$View$NewVehicle$addButton(model.dy)
							]))
					])),
				A2(
				$surprisetalk$elm_bulma$Bulma$Elements$box,
				_List_Nil,
				_List_fromArray(
					[body]))
			]));
};
var $author$project$Model$Weapon$TmpWeaponMountPoint = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Weapon$TmpWeaponUpdate = function (a) {
	return {$: 3, a: a};
};
var $author$project$View$NewWeapon$view = F3(
	function (model, vehicle, weapons) {
		var options = A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$option,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('')
					])),
			A2(
				$elm$core$List$map,
				function (weapon) {
					return A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(weapon.cK)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(weapon.cK)
							]));
				},
				weapons));
		var selectList = A4(
			$surprisetalk$elm_bulma$Bulma$Form$controlSelect,
			$surprisetalk$elm_bulma$Bulma$Form$controlSelectModifiers,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$Events$onInput(
					A2($elm$core$Basics$composeL, $author$project$Model$Model$WeaponMsg, $author$project$Model$Weapon$TmpWeaponUpdate))
				]),
			options);
		var mountPointOption = function (mountPoint) {
			return function (mp) {
				return A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(mp)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(mp)
						]));
			}(
				$author$project$Model$Weapon$Common$fromWeaponMounting(mountPoint));
		};
		var mountPointSelector = function () {
			var _v3 = model.dz;
			if (_v3.$ === 1) {
				return A4(
					$surprisetalk$elm_bulma$Bulma$Form$controlSelect,
					$surprisetalk$elm_bulma$Bulma$Form$controlSelectModifiers,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$disabled(true)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value('')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Select a weapon type above')
								]))
						]));
			} else {
				var weapon = _v3.a;
				var _v4 = _Utils_eq(
					$elm$core$Maybe$Just(5),
					weapon.cJ);
				if (_v4) {
					return A4(
						$surprisetalk$elm_bulma$Bulma$Form$controlSelect,
						$surprisetalk$elm_bulma$Bulma$Form$controlSelectModifiers,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$disabled(true)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$option,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value('')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Crew Fired')
									]))
							]));
				} else {
					return A4(
						$surprisetalk$elm_bulma$Bulma$Form$controlSelect,
						$surprisetalk$elm_bulma$Bulma$Form$controlSelectModifiers,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$Model$Model$WeaponMsg, $author$project$Model$Weapon$TmpWeaponMountPoint))
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$option,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value('')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('')
									])),
							A2(
								$elm$core$List$map,
								mountPointOption,
								_List_fromArray(
									[0, 1, 2, 3, 4]))));
				}
			}
		}();
		var body = function () {
			var _v2 = model.dz;
			if (!_v2.$) {
				var weapon = _v2.a;
				return A4(
					$author$project$View$Weapon$render,
					_Utils_update(
						$author$project$View$Weapon$defaultWeaponConfig,
						{c7: false, de: false, df: false}),
					model,
					vehicle,
					weapon);
			} else {
				return $elm$html$Html$text('Select a weapon type from the dropdown.');
			}
		}();
		var addButton = function () {
			var _v0 = model.dz;
			if (!_v0.$) {
				var weapon = _v0.a;
				var _v1 = weapon.cJ;
				if (_v1.$ === 1) {
					return A4(
						$surprisetalk$elm_bulma$Bulma$Form$controlButton,
						_Utils_update(
							$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
							{cf: true}),
						_List_Nil,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Select Mount Point')
							]));
				} else {
					return A4(
						$surprisetalk$elm_bulma$Bulma$Form$controlButton,
						$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Model$Model$WeaponMsg(
									A2($author$project$Model$Weapon$AddWeapon, vehicle.cH, weapon)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add ' + (weapon.cK + (' to ' + vehicle.cK)))
							]));
				}
			} else {
				return A4(
					$surprisetalk$elm_bulma$Bulma$Form$controlButton,
					_Utils_update(
						$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
						{cf: true}),
					_List_Nil,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Choose Weapon Type')
						]));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$surprisetalk$elm_bulma$Bulma$Form$horizontalFields,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$surprisetalk$elm_bulma$Bulma$Form$fieldLabel,
							1,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$surprisetalk$elm_bulma$Bulma$Form$controlLabel,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Weapon Type')
										]))
								])),
							A2(
							$surprisetalk$elm_bulma$Bulma$Form$fieldBody,
							_List_Nil,
							_List_fromArray(
								[selectList]))
						])),
					A2(
					$surprisetalk$elm_bulma$Bulma$Form$horizontalFields,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$surprisetalk$elm_bulma$Bulma$Form$fieldLabel,
							1,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$surprisetalk$elm_bulma$Bulma$Form$controlLabel,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Mount Point')
										]))
								])),
							A2(
							$surprisetalk$elm_bulma$Bulma$Form$fieldBody,
							_List_Nil,
							_List_fromArray(
								[mountPointSelector]))
						])),
					A2(
					$surprisetalk$elm_bulma$Bulma$Form$horizontalFields,
					_List_Nil,
					_List_fromArray(
						[
							A3($surprisetalk$elm_bulma$Bulma$Form$fieldLabel, 1, _List_Nil, _List_Nil),
							A2(
							$surprisetalk$elm_bulma$Bulma$Form$fieldBody,
							_List_Nil,
							_List_fromArray(
								[addButton]))
						])),
					A2(
					$surprisetalk$elm_bulma$Bulma$Elements$box,
					_List_Nil,
					_List_fromArray(
						[body]))
				]));
	});
var $author$project$View$Vehicle$renderPrint = F2(
	function (model, v) {
		var _v0 = A3(
			$author$project$View$Vehicle$configure,
			model,
			_Utils_update(
				$author$project$View$Vehicle$config,
				{K: true, x: true, by: true, aJ: true, U: true, V: true, ag: true}),
			v);
		var header = _v0.a;
		var body = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[header, body]));
	});
var $author$project$View$PrinterFriendly$view = F2(
	function (model, lvehicle) {
		return A3(
			$surprisetalk$elm_bulma$Bulma$Columns$columns,
			$surprisetalk$elm_bulma$Bulma$Columns$columnsModifiers,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (r) {
					return A3(
						$surprisetalk$elm_bulma$Bulma$Columns$column,
						$surprisetalk$elm_bulma$Bulma$Columns$columnModifiers,
						_List_Nil,
						_List_fromArray(
							[
								r,
								A2(
								$elm$html$Html$hr,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'border-top', 'dotted 3px')
									]),
								_List_Nil)
							]));
				},
				A2(
					$elm$core$List$map,
					$author$project$View$Vehicle$renderPrint(model),
					lvehicle)));
	});
var $lattyware$elm_fontawesome$FontAwesome$Brands$github = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fab',
	'github',
	496,
	512,
	_List_fromArray(
		['M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z']));
var $author$project$View$Settings$renderSection = F2(
	function (sectionTitle, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('settings-section')
				]),
			_List_fromArray(
				[
					A3(
					$surprisetalk$elm_bulma$Bulma$Elements$title,
					3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('settings-section-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(sectionTitle)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('settings-section-body')
						]),
					content)
				]));
	});
var $author$project$View$Settings$renderAbout = A2(
	$author$project$View$Settings$renderSection,
	'About',
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Built by Milo Gertjejansen.')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Email: milo plus glom at milogert dot com')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Built with '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('http://elm-lang.org')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Elm')
						])),
					$elm$html$Html$text('.')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Check out the '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('https://github.com/milogert/glom')
						]),
					_List_fromArray(
						[
							$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Brands$github)
						]))
				]))
		]));
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $author$project$Model$Features$get = F2(
	function (feature, actual) {
		return A3(
			$author$project$Model$Features$withDefault,
			feature,
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Just(actual));
	});
var $lattyware$elm_fontawesome$FontAwesome$Solid$check = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'check',
	512,
	512,
	_List_fromArray(
		['M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z']));
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $author$project$View$Settings$SquadGeneration$renderSpinResult = function (_v0) {
	var summary = _v0.dr;
	var cost = _v0.cb;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(summary),
				$elm$html$Html$text(
				$elm$core$String$fromInt(cost))
			]));
};
var $author$project$View$Settings$SquadGeneration$renderSpinResults = function (spinResults) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2($elm$core$List$map, $author$project$View$Settings$SquadGeneration$renderSpinResult, spinResults));
};
var $author$project$View$Settings$SquadGeneration$render = function (settings) {
	return A3(
		$surprisetalk$elm_bulma$Bulma$Columns$columns,
		$surprisetalk$elm_bulma$Bulma$Columns$columnsModifiers,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$surprisetalk$elm_bulma$Bulma$Columns$column,
				$surprisetalk$elm_bulma$Bulma$Columns$columnModifiers,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Squad Generation')
							]))
					])),
				A3(
				$surprisetalk$elm_bulma$Bulma$Columns$column,
				$surprisetalk$elm_bulma$Bulma$Columns$columnModifiers,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$View$Settings$SquadGeneration$renderSpinResults(settings.dk),
						A3(
						$surprisetalk$elm_bulma$Bulma$Elements$button,
						$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
						_List_Nil,
						_List_fromArray(
							[
								$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$check),
								$elm$html$Html$text('Accept Results')
							]))
					]))
			]));
};
var $author$project$View$Settings$renderAppSettings = function (settings) {
	var maybeAppSettings = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$author$project$Model$Features$get,
				'feature-generate-team',
				$author$project$View$Settings$SquadGeneration$render(settings))
			]));
	var actualSettings = function () {
		var _v0 = $elm$core$List$isEmpty(maybeAppSettings);
		if (_v0) {
			return _List_fromArray(
				[
					$elm$html$Html$text('Nothing here yet!')
				]);
		} else {
			return maybeAppSettings;
		}
	}();
	return A2($author$project$View$Settings$renderSection, 'App Settings', actualSettings);
};
var $author$project$Model$Settings$NewTeamVersion = {$: 5};
var $author$project$Model$Model$SettingsMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Model$Model$UpdatePointsAllowed = function (a) {
	return {$: 23, a: a};
};
var $author$project$Model$Model$UpdateTeamName = function (a) {
	return {$: 24, a: a};
};
var $surprisetalk$elm_bulma$Bulma$Classes$hasAddonsCentered = $elm$html$Html$Attributes$class('has-addons-centered');
var $surprisetalk$elm_bulma$Bulma$Classes$hasAddonsRight = $elm$html$Html$Attributes$class('has-addons-right');
var $surprisetalk$elm_bulma$Bulma$Form$connectedFields = function (alignment) {
	return A2(
		$surprisetalk$elm_bulma$Helpers$node,
		'div',
		_List_fromArray(
			[
				$surprisetalk$elm_bulma$Bulma$Classes$field,
				$surprisetalk$elm_bulma$Bulma$Classes$hasAddons,
				function () {
				switch (alignment) {
					case 0:
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					case 1:
						return $surprisetalk$elm_bulma$Bulma$Classes$hasAddonsCentered;
					default:
						return $surprisetalk$elm_bulma$Bulma$Classes$hasAddonsRight;
				}
			}()
			]));
};
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $author$project$View$Settings$renderGameSettings = function (model) {
	return A2(
		$author$project$View$Settings$renderSection,
		'Game Settings',
		_List_fromArray(
			[
				A2(
				$surprisetalk$elm_bulma$Bulma$Form$field,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$surprisetalk$elm_bulma$Bulma$Form$controlLabel,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for('teamName')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Team Name')
							])),
						A3(
						$surprisetalk$elm_bulma$Bulma$Form$connectedFields,
						0,
						_List_Nil,
						_List_fromArray(
							[
								A4(
								$surprisetalk$elm_bulma$Bulma$Form$controlText,
								$surprisetalk$elm_bulma$Bulma$Form$controlInputModifiers,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('is-expanded')
									]),
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('teamName'),
										$elm$html$Html$Events$onInput($author$project$Model$Model$UpdateTeamName),
										$elm$html$Html$Attributes$value(
										A2($elm$core$Maybe$withDefault, '', model.dv)),
										$elm$html$Html$Attributes$placeholder('Team Name')
									]),
								_List_Nil)
							])),
						A4(
						$surprisetalk$elm_bulma$Bulma$Form$controlButton,
						_Utils_update(
							$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
							{b9: 9}),
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Model$Model$SettingsMsg($author$project$Model$Settings$NewTeamVersion))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Create New Team Version')
							]))
					])),
				A2(
				$surprisetalk$elm_bulma$Bulma$Form$field,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$surprisetalk$elm_bulma$Bulma$Form$controlLabel,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for('squadPoints')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Maxiumum Points Allowed')
							])),
						A4(
						$surprisetalk$elm_bulma$Bulma$Form$controlInput,
						$surprisetalk$elm_bulma$Bulma$Form$controlInputModifiers,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('squadPoints'),
								$elm$html$Html$Attributes$type_('number'),
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromInt(model.c5)),
								$elm$html$Html$Events$onInput($author$project$Model$Model$UpdatePointsAllowed)
							]),
						_List_Nil)
					]))
			]));
};
var $surprisetalk$elm_bulma$Bulma$Modifiers$Centered = 1;
var $author$project$Model$Model$Share = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $surprisetalk$elm_bulma$Bulma$Classes$buttons = $elm$html$Html$Attributes$class('buttons');
var $surprisetalk$elm_bulma$Bulma$Elements$buttons = function (alignment) {
	return A2(
		$surprisetalk$elm_bulma$Helpers$node,
		'div',
		_List_fromArray(
			[
				$surprisetalk$elm_bulma$Bulma$Classes$buttons,
				function () {
				switch (alignment) {
					case 0:
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					case 1:
						return $surprisetalk$elm_bulma$Bulma$Classes$isCentered;
					default:
						return $surprisetalk$elm_bulma$Bulma$Classes$isRight;
				}
			}()
			]));
};
var $surprisetalk$elm_bulma$Bulma$Classes$textarea = $elm$html$Html$Attributes$class('textarea');
var $surprisetalk$elm_bulma$Bulma$Form$controlTextArea = F3(
	function (mods, attrs, attrs_) {
		var size = mods.dg;
		var state = mods.g;
		var color = mods.b9;
		var readonly = mods.L;
		var disabled = mods.cf;
		var controlMods = {
			o: false,
			cC: $elm$core$Maybe$Nothing,
			ax: $elm$core$Maybe$Nothing,
			J: function () {
				if (state === 4) {
					return $elm$core$Maybe$Just(size);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}()
		};
		return A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				A2($surprisetalk$elm_bulma$Bulma$Form$control, controlMods, attrs),
				$surprisetalk$elm_bulma$Helpers$ls),
			A3(
				$surprisetalk$elm_bulma$Helpers$node,
				'textarea',
				_List_fromArray(
					[
						$surprisetalk$elm_bulma$Bulma$Classes$textarea,
						$elm$html$Html$Attributes$disabled(disabled),
						function () {
						if (readonly) {
							return $elm$html$Html$Attributes$readonly(readonly);
						} else {
							return $surprisetalk$elm_bulma$Bulma$Classes$none;
						}
					}(),
						function () {
						switch (size) {
							case 0:
								return $surprisetalk$elm_bulma$Bulma$Classes$isSmall;
							case 1:
								return $surprisetalk$elm_bulma$Bulma$Classes$none;
							case 2:
								return $surprisetalk$elm_bulma$Bulma$Classes$isMedium;
							default:
								return $surprisetalk$elm_bulma$Bulma$Classes$isLarge;
						}
					}(),
						function () {
						switch (state) {
							case 1:
								return $surprisetalk$elm_bulma$Bulma$Classes$isHovered;
							case 2:
								return $surprisetalk$elm_bulma$Bulma$Classes$isFocused;
							case 3:
								return $surprisetalk$elm_bulma$Bulma$Classes$isActive;
							case 4:
								return $surprisetalk$elm_bulma$Bulma$Classes$isLoading;
							default:
								return $surprisetalk$elm_bulma$Bulma$Classes$none;
						}
					}(),
						function () {
						switch (color) {
							case 0:
								return $surprisetalk$elm_bulma$Bulma$Classes$none;
							case 1:
								return $surprisetalk$elm_bulma$Bulma$Classes$isWhite;
							case 2:
								return $surprisetalk$elm_bulma$Bulma$Classes$isLight;
							case 3:
								return $surprisetalk$elm_bulma$Bulma$Classes$isDark;
							case 4:
								return $surprisetalk$elm_bulma$Bulma$Classes$isBlack;
							case 5:
								return $surprisetalk$elm_bulma$Bulma$Classes$isPrimary;
							case 7:
								return $surprisetalk$elm_bulma$Bulma$Classes$isInfo;
							case 8:
								return $surprisetalk$elm_bulma$Bulma$Classes$isSuccess;
							case 9:
								return $surprisetalk$elm_bulma$Bulma$Classes$isWarning;
							case 10:
								return $surprisetalk$elm_bulma$Bulma$Classes$isDanger;
							default:
								return $surprisetalk$elm_bulma$Bulma$Classes$isLink;
						}
					}()
					]),
				attrs_));
	});
var $surprisetalk$elm_bulma$Bulma$Form$controlTextAreaModifiers = {b9: 0, cf: false, L: false, dg: 1, g: 0};
var $lattyware$elm_fontawesome$FontAwesome$Solid$download = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'download',
	512,
	512,
	_List_fromArray(
		['M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z']));
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$share = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'share',
	512,
	512,
	_List_fromArray(
		['M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z']));
var $author$project$Model$Model$DeleteItem = function (a) {
	return {$: 15, a: a};
};
var $author$project$Model$Model$LoadModel = function (a) {
	return {$: 14, a: a};
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$upload = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'upload',
	512,
	512,
	_List_fromArray(
		['M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z']));
var $author$project$View$Settings$storageMapper = F2(
	function (currentStorageKey, entry) {
		var display = function () {
			var _v0 = A2($elm$core$Basics$compare, currentStorageKey, entry.cH);
			if (_v0 === 1) {
				return A2(
					$elm$html$Html$b,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(entry.cK + ' (current team)')
						]));
			} else {
				return $elm$html$Html$text(entry.cK);
			}
		}();
		return A3(
			$surprisetalk$elm_bulma$Bulma$Form$connectedFields,
			0,
			_List_Nil,
			_List_fromArray(
				[
					A4(
					$surprisetalk$elm_bulma$Bulma$Form$controlButton,
					$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-expanded')
						]),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-fullwidth'),
							$elm$html$Html$Events$onClick(
							$author$project$Model$Model$LoadModel(entry.cH))
						]),
					_List_fromArray(
						[display])),
					A4(
					$surprisetalk$elm_bulma$Bulma$Form$controlButton,
					_Utils_update(
						$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
						{b9: 8}),
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							A2($author$project$Model$Model$Import, entry.cH, entry.N))
						]),
					_List_fromArray(
						[
							$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$upload)
						])),
					A4(
					$surprisetalk$elm_bulma$Bulma$Form$controlButton,
					_Utils_update(
						$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
						{b9: 7}),
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							A2($author$project$Model$Model$Share, entry.cH, entry.N))
						]),
					_List_fromArray(
						[
							$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$share)
						])),
					A4(
					$surprisetalk$elm_bulma$Bulma$Form$controlButton,
					_Utils_update(
						$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
						{b9: 10}),
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Model$Model$DeleteItem(entry.cH))
						]),
					_List_fromArray(
						[
							$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$trashAlt)
						]))
				]));
	});
var $author$project$View$Settings$renderImportExport = function (model) {
	var teamName = function () {
		var _v0 = model.dv;
		if (_v0.$ === 1) {
			return 'NoName';
		} else {
			var s = _v0.a;
			return s;
		}
	}();
	var buttonMods = _Utils_update(
		$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
		{dg: 1});
	return A2(
		$author$project$View$Settings$renderSection,
		'Import/Export',
		_List_fromArray(
			[
				A3(
				$surprisetalk$elm_bulma$Bulma$Columns$columns,
				$surprisetalk$elm_bulma$Bulma$Columns$columnsModifiers,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$surprisetalk$elm_bulma$Bulma$Columns$column,
						$surprisetalk$elm_bulma$Bulma$Columns$columnModifiers,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$surprisetalk$elm_bulma$Bulma$Elements$buttons,
								1,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$surprisetalk$elm_bulma$Bulma$Elements$button,
										buttonMods,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mb-2'),
												$elm$html$Html$Events$onClick($author$project$Model$Model$SaveModel)
											]),
										_List_fromArray(
											[
												$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$download),
												$elm$html$Html$text(' Save Team \"' + (teamName + '\"'))
											])),
										A3(
										$surprisetalk$elm_bulma$Bulma$Elements$button,
										buttonMods,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mb-2'),
												$elm$html$Html$Events$onClick(
												A2($author$project$Model$Model$Share, '', ''))
											]),
										_List_fromArray(
											[
												$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$share),
												$elm$html$Html$text(' Share')
											])),
										A3(
										$surprisetalk$elm_bulma$Bulma$Elements$button,
										buttonMods,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mb-2'),
												$elm$html$Html$Events$onClick(
												A2($author$project$Model$Model$Import, '', ''))
											]),
										_List_fromArray(
											[
												$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$upload),
												$elm$html$Html$text(' Import')
											]))
									])),
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								A2(
									$elm$core$List$map,
									$author$project$View$Settings$storageMapper(model.$7),
									model.dn))
							])),
						A3(
						$surprisetalk$elm_bulma$Bulma$Columns$column,
						$surprisetalk$elm_bulma$Bulma$Columns$columnModifiers,
						_List_Nil,
						_List_fromArray(
							[
								A4(
								$surprisetalk$elm_bulma$Bulma$Form$controlTextArea,
								$surprisetalk$elm_bulma$Bulma$Form$controlTextAreaModifiers,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput($author$project$Model$Model$SetImport),
										$elm$html$Html$Attributes$rows(5),
										A2($elm$html$Html$Attributes$style, 'font-family', 'monospace'),
										$elm$html$Html$Attributes$value(model.cE)
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $surprisetalk$elm_bulma$Bulma$Classes$isBordered = $elm$html$Html$Attributes$class('is-bordered');
var $surprisetalk$elm_bulma$Bulma$Classes$isHoverable = $elm$html$Html$Attributes$class('is-hoverable');
var $surprisetalk$elm_bulma$Bulma$Classes$isNarrow = $elm$html$Html$Attributes$class('is-narrow');
var $surprisetalk$elm_bulma$Bulma$Classes$isStriped = $elm$html$Html$Attributes$class('is-striped');
var $surprisetalk$elm_bulma$Bulma$Classes$table = $elm$html$Html$Attributes$class('table');
var $surprisetalk$elm_bulma$Bulma$Elements$table = function (_v0) {
	var bordered = _v0.am;
	var striped = _v0.aS;
	var narrow = _v0.aE;
	var hoverable = _v0.aw;
	var fullWidth = _v0.at;
	return A2(
		$surprisetalk$elm_bulma$Helpers$node,
		'table',
		_List_fromArray(
			[
				$surprisetalk$elm_bulma$Bulma$Classes$table,
				function () {
				if (bordered) {
					return $surprisetalk$elm_bulma$Bulma$Classes$isBordered;
				} else {
					return $surprisetalk$elm_bulma$Bulma$Classes$none;
				}
			}(),
				function () {
				if (striped) {
					return $surprisetalk$elm_bulma$Bulma$Classes$isStriped;
				} else {
					return $surprisetalk$elm_bulma$Bulma$Classes$none;
				}
			}(),
				function () {
				if (narrow) {
					return $surprisetalk$elm_bulma$Bulma$Classes$isNarrow;
				} else {
					return $surprisetalk$elm_bulma$Bulma$Classes$none;
				}
			}(),
				function () {
				if (hoverable) {
					return $surprisetalk$elm_bulma$Bulma$Classes$isHoverable;
				} else {
					return $surprisetalk$elm_bulma$Bulma$Classes$none;
				}
			}(),
				function () {
				if (fullWidth) {
					return $surprisetalk$elm_bulma$Bulma$Classes$isFullWidth;
				} else {
					return $surprisetalk$elm_bulma$Bulma$Classes$none;
				}
			}()
			]));
};
var $surprisetalk$elm_bulma$Bulma$Elements$tableBody = A2($surprisetalk$elm_bulma$Helpers$node, 'tbody', _List_Nil);
var $surprisetalk$elm_bulma$Bulma$Elements$tableCellHead = A2($surprisetalk$elm_bulma$Helpers$node, 'th', _List_Nil);
var $surprisetalk$elm_bulma$Bulma$Elements$tableHead = A2($surprisetalk$elm_bulma$Helpers$node, 'thead', _List_Nil);
var $surprisetalk$elm_bulma$Bulma$Elements$tableModifiers = {am: false, at: false, aw: false, aE: false, aS: false};
var $surprisetalk$elm_bulma$Bulma$Elements$tableRow = function (highlighted) {
	return A2(
		$surprisetalk$elm_bulma$Helpers$node,
		'tr',
		_List_fromArray(
			[
				function () {
				if (highlighted) {
					return $surprisetalk$elm_bulma$Bulma$Classes$isSelected;
				} else {
					return $surprisetalk$elm_bulma$Bulma$Classes$none;
				}
			}()
			]));
};
var $author$project$View$Settings$dataTable = F4(
	function (name, headerList, rowFunc, data) {
		var header = A2(
			$surprisetalk$elm_bulma$Bulma$Elements$tableHead,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$surprisetalk$elm_bulma$Bulma$Elements$tableRow,
					true,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (s) {
							return A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCellHead,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(s)
									]));
						},
						headerList))
				]));
		var body = A2(
			$surprisetalk$elm_bulma$Bulma$Elements$tableBody,
			_List_Nil,
			A2($elm$core$List$map, rowFunc, data));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$surprisetalk$elm_bulma$Bulma$Elements$title,
					4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						])),
					A3(
					$surprisetalk$elm_bulma$Bulma$Elements$table,
					$surprisetalk$elm_bulma$Bulma$Elements$tableModifiers,
					_List_Nil,
					_List_fromArray(
						[header, body]))
				]));
	});
var $author$project$Model$Shared$fromCategory = function (category) {
	if (!category) {
		return 'Basic';
	} else {
		return 'Advanced';
	}
};
var $surprisetalk$elm_bulma$Bulma$Elements$tableCell = A2($surprisetalk$elm_bulma$Helpers$node, 'td', _List_Nil);
var $author$project$View$Settings$renderReferenceSection = function (settings) {
	return A2(
		$author$project$View$Settings$renderSection,
		'Reference',
		_List_fromArray(
			[
				A4(
				$surprisetalk$elm_bulma$Bulma$Form$controlButton,
				$surprisetalk$elm_bulma$Bulma$Elements$buttonModifiers,
				_List_Nil,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Toggle references')
					])),
				A4(
				$author$project$View$Settings$dataTable,
				'Vehicles',
				_List_fromArray(
					['Type', 'Weight', 'Hull', 'Handling', 'Max Gear', 'Crew', 'Build Slots', 'Special Rules', 'Cost', 'Category']),
				function (v) {
					return A3(
						$surprisetalk$elm_bulma$Bulma$Elements$tableRow,
						false,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(v.dB)
									])),
								A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Model$Vehicle$Common$fromVehicleWeight(v.dH))
									])),
								A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(v.cB.bo))
									])),
								A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(v.cw))
									])),
								A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(v.ct.bo))
									])),
								A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(v.cc))
									])),
								A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(v.ci))
									])),
								A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('specials here')
									])),
								A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(v.cb))
									])),
								A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Model$Shared$fromCategory(v.b6))
									]))
							]));
				},
				$author$project$Model$Vehicle$Common$allVehicles),
				A4(
				$author$project$View$Settings$dataTable,
				'Weapons',
				_List_fromArray(
					['Type', 'Range', 'Attack', 'Build Slots', 'Special Rules', 'Cost', 'Sponsor', 'Category']),
				function (weapon) {
					var sponsor = function () {
						var _v1 = weapon.da;
						if (_v1.$ === 1) {
							return '-';
						} else {
							var s = _v1.a;
							return s.cK;
						}
					}();
					var attack = function () {
						var _v0 = weapon.b2;
						if (_v0.$ === 1) {
							return '-';
						} else {
							var dice = _v0.a;
							return $author$project$Model$Weapon$Common$fromDice(dice);
						}
					}();
					return A3(
						$surprisetalk$elm_bulma$Bulma$Elements$tableRow,
						false,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(weapon.cK)
									])),
								A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Model$Weapon$Common$fromWeaponRange(weapon.c8))
									])),
								A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(attack)
									])),
								A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(weapon.di))
									])),
								A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('specials here')
									])),
								A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(weapon.cb))
									])),
								A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(sponsor)
									])),
								A2(
								$surprisetalk$elm_bulma$Bulma$Elements$tableCell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Model$Shared$fromCategory(weapon.b6))
									]))
							]));
				},
				$author$project$Model$Weapon$Common$allWeaponsList)
			]));
};
var $surprisetalk$elm_bulma$Bulma$Classes$section = $elm$html$Html$Attributes$class('section');
var $surprisetalk$elm_bulma$Bulma$Layout$section = function (spacing) {
	return A2(
		$surprisetalk$elm_bulma$Helpers$node,
		'section',
		_List_fromArray(
			[
				$surprisetalk$elm_bulma$Bulma$Classes$section,
				function () {
				switch (spacing) {
					case 0:
						return $surprisetalk$elm_bulma$Bulma$Classes$none;
					case 1:
						return $surprisetalk$elm_bulma$Bulma$Classes$isMedium;
					default:
						return $surprisetalk$elm_bulma$Bulma$Classes$isLarge;
				}
			}()
			]));
};
var $author$project$View$Settings$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (s) {
				return A3(
					$surprisetalk$elm_bulma$Bulma$Layout$section,
					0,
					_List_Nil,
					_List_fromArray(
						[s]));
			},
			_List_fromArray(
				[
					$author$project$View$Settings$renderGameSettings(model),
					$author$project$View$Settings$renderAppSettings(model.dd),
					$author$project$View$Settings$renderImportExport(model),
					$author$project$View$Settings$renderReferenceSection(model.dd),
					$author$project$View$Settings$renderAbout
				])));
};
var $author$project$Model$Model$SponsorUpdate = function (a) {
	return {$: 6, a: a};
};
var $author$project$View$Sponsor$renderTeamPerk = function (_v0) {
	var name = _v0.cK;
	var description = _v0.ap;
	return A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$b,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(name + ': ')
					])),
				$elm$html$Html$text(description)
			]));
};
var $author$project$View$Sponsor$renderPerks = function (ps) {
	return A2(
		$elm$core$List$map,
		function (p) {
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$View$Sponsor$renderTeamPerk(p)
					]));
		},
		ps);
};
var $author$project$View$Sponsor$render = function (_v0) {
	var name = _v0.cK;
	var description = _v0.ap;
	var perks = _v0.c3;
	var grantedClasses = _v0.cv;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$surprisetalk$elm_bulma$Bulma$Elements$title,
				4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(description)
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				$author$project$View$Sponsor$renderPerks(perks)),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$b,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Available Perk Classes: ')
							])),
					A2(
						$elm$core$List$map,
						$elm$html$Html$text,
						A2(
							$elm$core$List$intersperse,
							', ',
							A2($elm$core$List$map, $author$project$Model$Sponsors$fromPerkClass, grantedClasses)))))
			]));
};
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$View$SponsorSelect$view = function (model) {
	var currentSponsorName = function () {
		var _v1 = model.dl;
		if (_v1.$ === 1) {
			return '';
		} else {
			var s = _v1.a;
			return s.cK;
		}
	}();
	var optionFunc = function (t) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(t),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(currentSponsorName, t))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(t)
				]));
	};
	var body = function () {
		var _v0 = model.dl;
		if (!_v0.$) {
			var s = _v0.a;
			return $author$project$View$Sponsor$render(s);
		} else {
			return $elm$html$Html$text('Select a sponsor.');
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$surprisetalk$elm_bulma$Bulma$Form$horizontalFields,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$surprisetalk$elm_bulma$Bulma$Form$fieldLabel,
						1,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$surprisetalk$elm_bulma$Bulma$Form$controlLabel,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Sponsor List')
									]))
							])),
						A2(
						$surprisetalk$elm_bulma$Bulma$Form$fieldBody,
						_List_Nil,
						_List_fromArray(
							[
								A4(
								$surprisetalk$elm_bulma$Bulma$Form$controlSelect,
								$surprisetalk$elm_bulma$Bulma$Form$controlSelectModifiers,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput($author$project$Model$Model$SponsorUpdate),
										$elm$html$Html$Attributes$class('form-control mb-3')
									]),
								A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$option,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('No Sponsor')
											])),
									A2(
										$elm$core$List$map,
										optionFunc,
										A2(
											$elm$core$List$map,
											function ($) {
												return $.cK;
											},
											$author$project$Model$Sponsors$allSponsors))))
							]))
					])),
				A2(
				$surprisetalk$elm_bulma$Bulma$Elements$box,
				_List_Nil,
				_List_fromArray(
					[body]))
			]));
};
var $author$project$View$Utils$weaponSponsorFilter = F2(
	function (model, weapon) {
		return A2($author$project$View$Utils$sponsorFilter_, model, weapon.da);
	});
var $author$project$View$Dashboard$view = function (model) {
	var vehicleTabOpened = function (vehicle) {
		return $elm$core$Maybe$Just(
			$author$project$Model$Views$ViewDetails(vehicle.cH));
	};
	var unavailableFunc = function (vehicle) {
		return vehicle.b$ || ($author$project$Model$Vehicle$Common$isWrecked(vehicle) || (_Utils_cmp(model.cu, vehicle.ct.a2) > 0));
	};
	var unavailable = A2(
		$elm$core$List$map,
		function (v) {
			return A2(
				$author$project$View$Dashboard$vehicleTab,
				_Utils_eq(
					vehicleTabOpened(v),
					model.ds),
				v);
		},
		A2(
			$elm$core$List$filter,
			function (v) {
				return unavailableFunc(v);
			},
			$elm$core$Dict$values(model.dE)));
	var display = function () {
		var _v0 = model.ds;
		if (!_v0.$) {
			var viewEvent = _v0.a;
			switch (viewEvent.$) {
				case 1:
					var type_ = viewEvent.a;
					switch (type_.$) {
						case 0:
							return $author$project$View$NewVehicle$view(model);
						case 1:
							var key = type_.a;
							var _v3 = A2($author$project$Model$Model$vehicleFromKey, model, key);
							if (_v3.$ === 1) {
								return $elm$html$Html$text('Select a different vehicle (invalid key: ' + (key + ')'));
							} else {
								var vehicle = _v3.a;
								return A3(
									$author$project$View$NewWeapon$view,
									model,
									vehicle,
									A2(
										$elm$core$List$filter,
										$author$project$View$Utils$weaponSponsorFilter(model),
										A2(
											$elm$core$List$filter,
											function (x) {
												return !_Utils_eq(x.cK, $author$project$Model$Weapon$Common$handgun.cK);
											},
											A2(
												$elm$core$List$filter,
												function (x) {
													return _Utils_cmp(
														x.di,
														$author$project$Model$Vehicle$Common$slotsRemaining(vehicle)) < 1;
												},
												$author$project$Model$Weapon$Common$allWeaponsList))));
							}
						default:
							var key = type_.a;
							var _v4 = A2($author$project$Model$Model$vehicleFromKey, model, key);
							if (_v4.$ === 1) {
								return $elm$html$Html$text('Select a different vehicle (invalid key: ' + (key + ')'));
							} else {
								var vehicle = _v4.a;
								return A3(
									$author$project$View$NewUpgrade$view,
									model,
									vehicle,
									A2(
										$elm$core$List$filter,
										function (x) {
											return _Utils_cmp(
												x.di,
												$author$project$Model$Vehicle$Common$slotsRemaining(vehicle)) < 1;
										},
										$author$project$Model$Upgrade$Common$allUpgradesList));
							}
					}
				case 2:
					var key = viewEvent.a;
					var _v5 = A2($author$project$Model$Model$vehicleFromKey, model, key);
					if (_v5.$ === 1) {
						return $elm$html$Html$text('Select a different vehicle (invalid key: ' + (key + ')'));
					} else {
						var vehicle = _v5.a;
						return A2($author$project$View$Vehicle$renderDetails, model, vehicle);
					}
				case 3:
					return $author$project$View$SponsorSelect$view(model);
				case 5:
					var key = viewEvent.a;
					return A2(
						$author$project$View$PrinterFriendly$view,
						model,
						$elm$core$List$singleton(
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$Model$Vehicle$defaultVehicle,
								A2($elm$core$Dict$get, key, model.dE))));
				case 4:
					return A2(
						$author$project$View$PrinterFriendly$view,
						model,
						$elm$core$Dict$values(model.dE));
				case 6:
					return $author$project$View$Settings$view(model);
				default:
					return $elm$html$Html$text('Serious error, probably trying to view the dashboard in the dashboard');
			}
		} else {
			return $elm$html$Html$text('Select or add a vehicle.');
		}
	}();
	var available = A2(
		$elm$core$List$map,
		function (v) {
			return A2(
				$author$project$View$Dashboard$vehicleTab,
				_Utils_eq(
					vehicleTabOpened(v),
					model.ds),
				v);
		},
		A2(
			$elm$core$List$filter,
			function (v) {
				return !unavailableFunc(v);
			},
			$elm$core$Dict$values(model.dE)));
	var addVehicleTab = _List_fromArray(
		[
			A3(
			$author$project$View$Dashboard$tabGen,
			_Utils_eq(
				model.ds,
				$elm$core$Maybe$Just(
					$author$project$Model$Views$ViewNew($author$project$Model$Views$NewVehicle))),
			$author$project$Model$Views$ViewNew($author$project$Model$Views$NewVehicle),
			_List_fromArray(
				[
					A2(
					$lattyware$elm_fontawesome$FontAwesome$Icon$viewStyled,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-right', '.5rem')
						]),
					$lattyware$elm_fontawesome$FontAwesome$Solid$plus),
					$elm$html$Html$text('New Vehicle')
				]))
		]);
	return A2(
		$surprisetalk$elm_bulma$Bulma$Layout$container,
		_List_Nil,
		_List_fromArray(
			[
				A4(
				$surprisetalk$elm_bulma$Bulma$Components$tabs,
				$surprisetalk$elm_bulma$Bulma$Components$tabsModifiers,
				_List_Nil,
				_List_Nil,
				_Utils_ap(
					available,
					_Utils_ap(unavailable, addVehicleTab))),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[display]))
			]));
};
var $author$project$View$Details$view = F2(
	function (model, v) {
		return A2($author$project$View$Vehicle$renderDetails, model, v);
	});
var $author$project$View$View$render = function (model) {
	var _v0 = model.dF;
	switch (_v0.$) {
		case 0:
			return $author$project$View$Dashboard$view(model);
		case 1:
			var type_ = _v0.a;
			switch (type_.$) {
				case 0:
					return $author$project$View$NewVehicle$view(model);
				case 1:
					var key = type_.a;
					var _v2 = A2($author$project$Model$Model$vehicleFromKey, model, key);
					if (_v2.$ === 1) {
						return $author$project$View$Dashboard$view(model);
					} else {
						var vehicle = _v2.a;
						return A3(
							$author$project$View$NewWeapon$view,
							model,
							vehicle,
							A2(
								$elm$core$List$filter,
								$author$project$View$Utils$weaponSponsorFilter(model),
								A2(
									$elm$core$List$filter,
									function (x) {
										return !_Utils_eq(x.cK, $author$project$Model$Weapon$Common$handgun.cK);
									},
									A2(
										$elm$core$List$filter,
										function (x) {
											return _Utils_cmp(
												x.di,
												$author$project$Model$Vehicle$Common$slotsRemaining(vehicle)) < 1;
										},
										$author$project$Model$Weapon$Common$allWeaponsList))));
					}
				default:
					var key = type_.a;
					var _v3 = A2($author$project$Model$Model$vehicleFromKey, model, key);
					if (_v3.$ === 1) {
						return $author$project$View$Dashboard$view(model);
					} else {
						var vehicle = _v3.a;
						return A3(
							$author$project$View$NewUpgrade$view,
							model,
							vehicle,
							A2(
								$elm$core$List$filter,
								function (x) {
									return _Utils_cmp(
										x.di,
										$author$project$Model$Vehicle$Common$slotsRemaining(vehicle)) < 1;
								},
								$author$project$Model$Upgrade$Common$allUpgradesList));
					}
			}
		case 2:
			var key = _v0.a;
			var _v4 = A2($author$project$Model$Model$vehicleFromKey, model, key);
			if (_v4.$ === 1) {
				return $author$project$View$Dashboard$view(model);
			} else {
				var vehicle = _v4.a;
				return A2($author$project$View$Details$view, model, vehicle);
			}
		case 3:
			return $author$project$View$SponsorSelect$view(model);
		case 5:
			var key = _v0.a;
			return A2(
				$author$project$View$PrinterFriendly$view,
				model,
				$elm$core$List$singleton(
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Model$Vehicle$defaultVehicle,
						A2($elm$core$Dict$get, key, model.dE))));
		case 4:
			return A2(
				$author$project$View$PrinterFriendly$view,
				model,
				$elm$core$Dict$values(model.dE));
		default:
			return $author$project$View$Settings$view(model);
	}
};
var $surprisetalk$elm_bulma$Bulma$CDN$stylesheet = A3(
	$elm$html$Html$node,
	'link',
	_List_fromArray(
		[
			$elm$html$Html$Attributes$rel('stylesheet'),
			$elm$html$Html$Attributes$href('https://cdnjs.cloudflare.com/ajax/libs/bulma/0.7.1/css/bulma.min.css')
		]),
	_List_Nil);
var $author$project$Model$Model$viewToStr = function (model) {
	var _v0 = model.dF;
	switch (_v0.$) {
		case 0:
			return 'Team ' + A2($elm$core$Maybe$withDefault, 'NoName', model.dv);
		case 1:
			var newType = _v0.a;
			switch (newType.$) {
				case 0:
					return 'New Vehicle';
				case 1:
					var key = newType.a;
					var _v2 = A2($author$project$Model$Model$vehicleFromKey, model, key);
					if (_v2.$ === 1) {
						return 'Not a vehicle';
					} else {
						var name = _v2.a.cK;
						return 'New Weapon for ' + name;
					}
				default:
					var key = newType.a;
					var _v3 = A2($author$project$Model$Model$vehicleFromKey, model, key);
					if (_v3.$ === 1) {
						return 'Not a vehicle';
					} else {
						var name = _v3.a.cK;
						return 'New Upgrade for ' + name;
					}
			}
		case 2:
			var key = _v0.a;
			var _v4 = A2($author$project$Model$Model$vehicleFromKey, model, key);
			if (_v4.$ === 1) {
				return 'Not a vehicle';
			} else {
				var vehicle = _v4.a;
				return vehicle.cK;
			}
		case 3:
			return 'Sponsor Select';
		case 4:
			return 'Printing ' + ($elm$core$String$fromInt(
				$elm$core$Dict$size(model.dE)) + ' vehicle(s)');
		case 5:
			var key = _v0.a;
			return 'Printing vehicle';
		default:
			return 'Settings';
	}
};
var $author$project$View$View$view = function (model) {
	return A2(
		$elm$browser$Browser$Document,
		$author$project$Model$Model$viewToStr(model),
		_List_fromArray(
			[
				$surprisetalk$elm_bulma$Bulma$CDN$stylesheet,
				$lattyware$elm_fontawesome$FontAwesome$Styles$css,
				$author$project$View$View$nav(model),
				A3(
				$elm$html$Html$node,
				'link',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$rel('stylesheet'),
						$elm$html$Html$Attributes$href('https://use.fontawesome.com/releases/v5.0.13/css/all.css'),
						A2($elm$html$Html$Attributes$attribute, 'integrity', 'sha384-DNOHZ68U8hZfKXOrtjWvjxusGo9WQnrNx2sqG0tfsghAvtVlRW3tvkXWZh58N9jp'),
						A2($elm$html$Html$Attributes$attribute, 'async', 'true'),
						A2($elm$html$Html$Attributes$attribute, 'crossorigin', 'anonymous')
					]),
				_List_Nil),
				$author$project$View$View$displayAlert(model),
				A3(
				$surprisetalk$elm_bulma$Bulma$Layout$section,
				0,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$View$View$render(model)
					]))
			]));
};
var $author$project$Main$main = $elm$browser$Browser$document(
	{cF: $author$project$Model$Model$init, dq: $author$project$Subscriptions$Subscriptions$subscriptions, dC: $author$project$Update$Update$update, dF: $author$project$View$View$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	$elm$json$Json$Decode$succeed(0))(0)}});}(this));